var Me = Object.defineProperty;
var He = (u, e, n) => e in u ? Me(u, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : u[e] = n;
var G = (u, e, n) => (He(u, typeof e != "symbol" ? e + "" : e, n), n);
import { defineComponent as y, computed as b, openBlock as o, createBlock as c, resolveDynamicComponent as ve, normalizeProps as ae, guardReactiveProps as ue, createSlots as Ie, renderList as S, withCtx as E, renderSlot as ce, shallowReactive as Se, watch as F, onBeforeUnmount as z, onMounted as $, ref as f, shallowRef as W, watchEffect as Ve, triggerRef as ne, unref as L, isRef as Be, nextTick as ge, createElementBlock as l, normalizeClass as r, createVNode as h, createCommentVNode as m, Fragment as I, mergeProps as D, normalizeStyle as M, createElementVNode as v, onUnmounted as P, withDirectives as R, vShow as N, toDisplayString as H, vModelRadio as _, vModelCheckbox as te, vModelSelect as Re, onUpdated as j, vModelText as Te, getCurrentInstance as he, createStaticVNode as Ze, toRaw as $e, Teleport as De, useSlots as Ae } from "vue";
import { Base as Ne, RendererFactory as x, Helpers as Pe, DropdownMultiSelectListModel as Ee, doKey2ClickUp as ye, createSvg as We, doKey2ClickDown as Fe, doKey2ClickBlur as ze, ActionDropdownViewModel as Oe, createPopupViewModel as Ue, SurveyProgressModel as de, ProgressButtonsResponsivityManager as Ke, addIconsToThemeSet as qe, SvgRegistry as X, PopupSurveyModel as je, settings as se, createPopupModalViewModel as Qe, ButtonGroupItemModel as Ge, SurveyModel as Je } from "survey-core";
const Y = class Y {
  constructor() {
    G(this, "creatorHash", {});
  }
  registerComponent(e, n) {
    this.creatorHash[e] = n;
  }
  getComponent(e) {
    return this.creatorHash[e] || e;
  }
  getAllTypes() {
    const e = new Array();
    for (const n in this.creatorHash)
      e.push(n);
    return e.sort();
  }
  isComponentRegistered(e) {
    return !!this.creatorHash[e];
  }
};
G(Y, "Instance", new Y());
let K = Y;
const d = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "SvComponent",
  props: {
    is: {}
  },
  setup(u) {
    const e = u, n = b(
      () => K.Instance.getComponent(e.is)
    );
    return (s, i) => (o(), c(ve(n.value), ae(ue(s.$attrs)), Ie({ _: 2 }, [
      S(s.$slots, (t, a) => ({
        name: a,
        fn: E((p) => [
          ce(s.$slots, a, ae(ue(p)))
        ])
      }))
    ]), 1040));
  }
});
Ne.createPropertiesHash = () => Se({});
class Xe {
  constructor(e) {
    G(this, "currentNextTickPromise");
    this.element = e;
  }
  async add() {
    const e = ge();
    this.currentNextTickPromise !== e && (this.currentNextTickPromise = e, await e, e == this.currentNextTickPromise && this.element.afterRerender());
  }
}
function Ye(u) {
  if (u) {
    if (u.__vueImplemented = u.__vueImplemented ?? 0, u.__vueImplemented <= 0) {
      const e = new Xe(u);
      u.createArrayCoreHandler = (n, s) => {
        const i = [], t = W(i);
        return i.onArrayChanged = () => {
          ne(t), e.add();
        }, n[s] = t, L(n[s]);
      }, u.iteratePropertiesHash((n, s) => {
        if (Array.isArray(n[s])) {
          const i = W(n[s]);
          n[s].onArrayChanged = () => {
            ne(i), e.add();
          }, n[s] = i;
        }
      }), u.getPropertyValueCoreHandler = (n, s) => L(n[s]), u.setPropertyValueCoreHandler = (n, s, i) => {
        Be(n[s]) ? n[s].value = i : n[s] = i, e.add();
      };
    }
    u.enableOnElementRerenderedEvent(), u.__vueImplemented++;
  }
}
function _e(u) {
  return !!u.__vueImplemented;
}
function me(u) {
  u && (u.__vueImplemented = u.__vueImplemented ?? 0, u.__vueImplemented--, u.__vueImplemented <= 0 && (u.iteratePropertiesHash((e, n) => {
    e[n] = L(e[n]), Array.isArray(e[n]) && (e[n].onArrayChanged = void 0);
  }), delete u.__vueImplemented, u.disableOnElementRerenderedEvent(), u.createArrayCoreHandler = void 0, u.getPropertyValueCoreHandler = void 0, u.setPropertyValueCoreHandler = void 0));
}
function V(u, e, n) {
  const s = F(
    u,
    (t, a) => {
      t && e && e(t, a), a && (me(a), n && n(a)), Ye(t);
    },
    {
      immediate: !0
    }
  );
  let i = !1;
  z(() => {
    if (!i) {
      const t = u();
      t && (me(t), s(), n && n(t)), i = !0;
    }
  });
}
function T(u, e, n, s) {
  V(() => u.question, n, s), $(() => {
    u.question && u.question.afterRenderQuestionElement(e.value);
  }), z(() => {
    u.question.beforeDestroyQuestionElement(e.value);
  });
}
function O(u) {
  const e = f(), n = (t) => {
    e.value = t.renderedHtml;
  }, s = (t) => {
    e.value = t.renderedHtml, t.onStringChanged.add(n);
  }, i = F(
    u,
    (t, a) => {
      a && a.onStringChanged.remove(n), s(t);
    },
    { immediate: !0 }
  );
  return z(() => {
    const t = u();
    t && t.onStringChanged.remove(n), i();
  }), e;
}
function oe(u) {
  return u.customWidget ? "survey-customwidget" : u.isDefaultRendering && u.isDefaultRendering() || u.isPanel ? "survey-" + u.getTemplate() : u.getComponentName();
}
function ee(u) {
  const e = W(), n = Ve(() => {
    e.value = u(), ne(e);
  });
  return z(() => {
    n();
  }), e;
}
const xe = /* @__PURE__ */ y({
  __name: "Page",
  props: {
    survey: {},
    page: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null), s = () => {
      e.survey && n.value && e.survey.afterRenderPage(n.value);
    }, i = b(() => e.page._showDescription);
    return V(
      () => e.page,
      () => {
        s();
      }
    ), $(() => {
      s();
    }), (t, a) => (o(), l("div", {
      class: r(t.page.cssRoot),
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "survey-element-title",
        element: t.page,
        css: t.css
      }, null, 8, ["element", "css"]),
      i.value ? (o(), l("div", {
        key: 0,
        class: r(t.page.cssClasses.page.description)
      }, [
        h(d, {
          is: "survey-string",
          locString: t.page.locDescription
        }, null, 8, ["locString"])
      ], 2)) : m("", !0),
      h(d, {
        is: "survey-errors",
        element: t.page
      }, null, 8, ["element"]),
      (o(!0), l(I, null, S(t.page.visibleRows, (p) => (o(), c(d, D({
        key: p.id,
        is: t.page.getSurvey().getRowWrapperComponentName(p)
      }, {
        componentData: t.page.getSurvey().getRowWrapperComponentData(p)
      }), {
        default: E(() => [
          h(d, {
            is: "survey-row",
            row: p,
            survey: t.survey,
            css: t.css
          }, null, 8, ["row", "survey", "css"])
        ]),
        _: 2
      }, 1040, ["is"]))), 128))
    ], 2));
  }
}), e1 = /* @__PURE__ */ y({
  __name: "Header",
  props: {
    survey: {}
  },
  setup(u) {
    const e = u, n = f();
    return $(() => {
      var s = n.value;
      s && e.survey && e.survey.afterRenderHeader(s);
    }), (s, i) => s.survey.renderedHasHeader ? (o(), l("div", {
      key: 0,
      class: r(s.survey.css.header),
      ref_key: "root",
      ref: n
    }, [
      s.survey.isLogoBefore ? (o(), c(d, {
        key: 0,
        is: s.survey.getElementWrapperComponentName(s.survey, "logo-image"),
        data: s.survey.getElementWrapperComponentData(s.survey, "logo-image")
      }, null, 8, ["is", "data"])) : m("", !0),
      s.survey.renderedHasTitle ? (o(), l("div", {
        key: 1,
        class: r(s.survey.css.headerText),
        style: M({ maxWidth: s.survey.titleMaxWidth })
      }, [
        h(d, {
          is: "survey-element-title",
          element: s.survey,
          css: s.survey.css
        }, null, 8, ["element", "css"]),
        s.survey.renderedHasDescription ? (o(), l("div", {
          key: 0,
          class: r(s.survey.css.description)
        }, [
          h(d, {
            is: "survey-string",
            locString: s.survey.locDescription
          }, null, 8, ["locString"])
        ], 2)) : m("", !0)
      ], 6)) : m("", !0),
      s.survey.isLogoAfter ? (o(), c(d, {
        key: 2,
        is: s.survey.getElementWrapperComponentName(s.survey, "logo-image"),
        data: s.survey.getElementWrapperComponentData(s.survey, "logo-image")
      }, null, 8, ["is", "data"])) : m("", !0),
      v("div", {
        class: r(s.survey.css.headerClose)
      }, null, 2)
    ], 2)) : m("", !0);
  }
}), s1 = /* @__PURE__ */ y({
  __name: "Row",
  props: {
    row: {},
    css: {},
    survey: {}
  },
  setup(u) {
    const e = u, n = f();
    return V(
      () => e.row,
      (s, i) => {
        s.setRootElement(n.value), i && (s.isNeedRender = i.isNeedRender);
      },
      (s) => {
        _e(s) || (s.setRootElement(void 0), s.stopLazyRendering(), s.isNeedRender = !s.isLazyRendering());
      }
    ), $(() => {
      if (e.row && (e.row.setRootElement(n.value), !e.row.isNeedRender)) {
        const s = n.value;
        setTimeout(() => {
          e.row.startLazyRendering(s);
        }, 10);
      }
    }), (s, i) => (o(), l("div", {
      class: r(s.row.getRowCss()),
      ref_key: "root",
      ref: n
    }, [
      (o(!0), l(I, null, S(s.row.visibleElements, (t) => (o(), c(d, {
        is: "survey-element",
        row: s.row,
        css: s.css,
        element: t,
        key: t.id
      }, null, 8, ["row", "css", "element"]))), 128))
    ], 2));
  }
}), n1 = ["id", "role", "aria-required", "aria-invalid", "aria-labelledby", "aria-describedby", "aria-expanded", "data-name"], t1 = ["id"], o1 = {
  inheritAttrs: !1
}, i1 = /* @__PURE__ */ y({
  ...o1,
  __name: "Question",
  props: {
    survey: {},
    element: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null), s = b(() => e.element.showErrorOnTop), i = b(() => e.element.showErrorOnBottom), t = (k) => k.cssContent, a = () => e.element.getRootStyle();
    V(() => e.element);
    const p = () => {
      n.value && e.element.afterRender(n.value);
    }, g = F(
      () => n.value,
      () => {
        p();
      }
    ), C = b(() => e.element.customWidget ? "survey-customwidget" : e.element.isDefaultRendering() ? "survey-" + e.element.getTemplate() : e.element.getComponentName()), q = b(() => e.element.survey.getQuestionContentWrapperComponentName(e.element)), B = b(() => ({
      componentData: {
        question: e.element,
        data: e.element.survey.getElementWrapperComponentData(e.element)
      }
    }));
    return P(() => {
      g();
    }), (k, Z) => (o(), l("div", {
      class: r(k.element.getRootCss()),
      style: M(a()),
      ref_key: "root",
      ref: n,
      onFocusin: Z[0] || (Z[0] = (w) => k.element.focusIn()),
      id: k.element.id,
      role: k.element.ariaRole,
      "aria-required": k.element.ariaRequired,
      "aria-invalid": k.element.ariaInvalid,
      "aria-labelledby": k.element.ariaLabelledBy,
      "aria-describedby": k.element.ariaDescribedBy,
      "aria-expanded": k.element.ariaExpanded,
      "data-name": k.element.name
    }, [
      k.element.showErrorsAboveQuestion ? (o(), c(d, {
        key: 0,
        is: "survey-errors",
        element: k.element,
        location: "top"
      }, null, 8, ["element"])) : m("", !0),
      k.element.hasTitleOnLeftTop ? (o(), c(d, {
        key: 1,
        is: "survey-element-header",
        element: k.element,
        css: k.css
      }, null, 8, ["element", "css"])) : m("", !0),
      h(d, D({ is: q.value }, B.value), {
        default: E(() => [
          v("div", {
            class: r(t(k.element) || void 0),
            style: M({ display: k.element.renderedIsExpanded ? void 0 : "none" }),
            role: "presentation"
          }, [
            s.value ? (o(), c(d, {
              key: 0,
              is: "survey-errors",
              element: k.element,
              location: "top"
            }, null, 8, ["element"])) : m("", !0),
            h(d, {
              is: C.value,
              question: k.element
            }, null, 8, ["is", "question"]),
            k.element.hasComment ? (o(), l("div", {
              key: 1,
              class: r(k.element.getCommentAreaCss())
            }, [
              v("div", null, [
                h(d, {
                  is: "survey-string",
                  locString: k.element.locCommentText
                }, null, 8, ["locString"])
              ]),
              h(d, {
                is: "survey-question-comment",
                question: k.element
              }, null, 8, ["question"])
            ], 2)) : m("", !0),
            i.value ? (o(), c(d, {
              key: 2,
              is: "survey-errors",
              element: k.element,
              location: "bottom"
            }, null, 8, ["element"])) : m("", !0),
            k.element.hasDescriptionUnderInput ? (o(), l("div", {
              key: 3,
              class: r(k.element.cssDescription),
              id: k.element.ariaDescriptionId
            }, [
              h(d, {
                is: "survey-string",
                locString: k.element.locDescription
              }, null, 8, ["locString"])
            ], 10, t1)) : m("", !0)
          ], 6)
        ]),
        _: 1
      }, 16, ["is"]),
      k.element.hasTitleOnBottom ? (o(), c(d, {
        key: 2,
        is: "survey-element-header",
        element: k.element,
        css: k.css
      }, null, 8, ["element", "css"])) : m("", !0),
      k.element.showErrorsBelowQuestion ? (o(), c(d, {
        key: 3,
        is: "survey-errors",
        element: k.element,
        location: "bottom"
      }, null, 8, ["element"])) : m("", !0)
    ], 46, n1));
  }
}), r1 = ["id"], l1 = ["id"], a1 = {
  inheritAttrs: !1
}, u1 = /* @__PURE__ */ y({
  ...a1,
  inheritAttrs: !1,
  __name: "Panel",
  props: {
    element: {},
    isEditMode: { type: Boolean },
    css: {}
  },
  setup(u) {
    const e = u, n = f(null), s = b(() => e.element.survey);
    return V(() => e.element), $(() => {
      e.element.survey && e.element.afterRender(n.value);
    }), (i, t) => i.element.getIsContentVisible() ? (o(), l("div", {
      key: 0,
      class: r(i.element.getContainerCss()),
      id: i.element.id,
      onFocusin: t[0] || (t[0] = (a) => i.element.focusIn()),
      ref_key: "root",
      ref: n
    }, [
      i.element.showErrorsAbovePanel ? (o(), c(d, {
        key: 0,
        is: "survey-errors",
        element: i.element
      }, null, 8, ["element"])) : m("", !0),
      i.element.hasTitle || i.element.hasDescription ? (o(), c(d, {
        key: 1,
        is: "survey-element-header",
        element: i.element,
        css: i.css
      }, null, 8, ["element", "css"])) : m("", !0),
      i.element.showErrorsAbovePanel ? m("", !0) : (o(), c(d, {
        key: 2,
        is: "survey-errors",
        element: i.element
      }, null, 8, ["element"])),
      i.element.renderedIsExpanded ? (o(), l("div", {
        key: 3,
        id: i.element.contentId,
        style: M({ paddingLeft: i.element.innerPaddingLeft }),
        class: r(i.element.cssClasses.panel.content)
      }, [
        (o(!0), l(I, null, S(i.element.visibleRows, (a) => (o(), c(d, D({
          key: a.id,
          is: i.element.getSurvey().getRowWrapperComponentName(a)
        }, {
          componentData: i.element.getSurvey().getRowWrapperComponentData(a)
        }), {
          default: E(() => [
            h(d, {
              is: "survey-row",
              row: a,
              survey: s.value,
              css: i.css
            }, null, 8, ["row", "survey", "css"])
          ]),
          _: 2
        }, 1040, ["is"]))), 128)),
        h(d, {
          is: "sv-action-bar",
          model: i.element.getFooterToolbar()
        }, null, 8, ["model"])
      ], 14, l1)) : m("", !0)
    ], 42, r1)) : m("", !0);
  }
}), d1 = ["id"], m1 = /* @__PURE__ */ y({
  __name: "ElementHeader",
  props: {
    element: {},
    css: {}
  },
  setup(u) {
    const e = u, n = (i) => {
      typeof e.element.clickTitleFunction == "function" && e.element.clickTitleFunction(i);
    }, s = () => {
      const i = { width: void 0 };
      return "titleWidth" in e.element && (i.width = e.element.titleWidth), i;
    };
    return (i, t) => (o(), l("div", {
      class: r(i.element.cssHeader),
      onClick: n,
      style: M(s())
    }, [
      h(d, {
        is: "survey-element-title",
        element: i.element,
        css: i.css
      }, null, 8, ["element", "css"]),
      i.element.hasDescriptionUnderTitle ? R((o(), l("div", {
        key: 0,
        class: r(i.element.cssDescription),
        id: i.element.ariaDescriptionId
      }, [
        h(d, {
          is: "survey-string",
          locString: i.element.locDescription
        }, null, 8, ["locString"])
      ], 10, d1)), [
        [N, i.element.hasDescription]
      ]) : m("", !0),
      i.element.hasAdditionalTitleToolbar ? (o(), c(d, {
        key: 1,
        is: "sv-action-bar",
        model: i.element.additionalTitleToolbar
      }, null, 8, ["model"])) : m("", !0)
    ], 6));
  }
}), p1 = /* @__PURE__ */ y({
  __name: "String",
  props: {
    locString: {}
  },
  setup(u) {
    return (e, n) => (o(), c(d, {
      is: e.locString.renderAs,
      locString: e.locString.renderAsData
    }, null, 8, ["is", "locString"]));
  }
}), C1 = ["innerHTML"], v1 = /* @__PURE__ */ y({
  __name: "StringViewer",
  props: {
    locString: {}
  },
  setup(u) {
    const e = u, n = O(() => e.locString), s = e.locString.allowLineBreaks ? "sv-string-viewer sv-string-viewer--multiline" : "sv-string-viewer";
    return (i, t) => i.locString.hasHtml ? (o(), l("span", {
      key: 0,
      class: r(L(s)),
      innerHTML: L(n)
    }, null, 10, C1)) : (o(), l("span", {
      key: 1,
      class: r(L(s))
    }, H(L(n)), 3));
  }
}), c1 = ["innerHTML"], g1 = /* @__PURE__ */ y({
  __name: "StringEditor",
  props: {
    locString: {}
  },
  setup(u) {
    const e = u, n = (i) => {
      const t = e.locString;
      t.text = i.target.innerText;
    }, s = (i) => {
      i.preventDefault(), i.stopPropagation();
    };
    return (i, t) => i.locString.hasHtml ? (o(), l("span", {
      key: 0,
      class: "sv-string-editor",
      contenteditable: "true",
      innerHTML: i.locString.renderedHtml,
      onBlur: n,
      onClick: s
    }, null, 40, c1)) : (o(), l("span", {
      key: 1,
      class: "sv-string-editor",
      contenteditable: "true",
      onBlur: n,
      onClick: s
    }, H(i.locString.renderedHtml), 33));
  }
}), h1 = ["id"], y1 = /* @__PURE__ */ y({
  __name: "Skeleton",
  props: {
    element: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.element), (n, s) => (o(), l("div", {
      class: "sv-skeleton-element",
      id: n.element.id,
      style: M({ height: n.element.skeletonHeight })
    }, null, 12, h1));
  }
}), q1 = ["id"], w1 = ["value"], L1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Text",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => s.question.isReadOnlyRenderDiv() ? (o(), l("div", {
      key: 0,
      ref_key: "root",
      ref: n
    }, H(s.question.value), 513)) : s.question.dataListId ? (o(), l("div", {
      key: 1,
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "survey-text-input",
        question: s.question
      }, null, 8, ["question"]),
      v("datalist", {
        id: s.question.dataListId
      }, [
        (o(!0), l(I, null, S(s.question.dataList, (t, a) => (o(), l("option", {
          key: a,
          value: t
        }, null, 8, w1))), 128))
      ], 8, q1)
    ], 512)) : (o(), c(d, {
      key: 2,
      is: "survey-text-input",
      question: s.question,
      "get-ref": (t) => {
        n.value = t;
      }
    }, null, 8, ["question", "get-ref"]));
  }
}), k1 = ["disabled", "readonly", "type", "maxlength", "min", "max", "step", "size", "id", "list", "placeholder", "autocomplete", "value", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], f1 = ["disabled", "readonly", "type", "maxlength", "min", "max", "step", "size", "id", "list", "placeholder", "autocomplete", "value", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], b1 = /* @__PURE__ */ y({
  __name: "TextInput",
  props: {
    question: {},
    getRef: { type: Function }
  },
  setup(u, { expose: e }) {
    const n = u, s = function(a) {
      n.getRef && n.getRef(a);
    }, i = f(null);
    e({ root: i }), V(() => n.question);
    const t = b(() => n.question.inputStyle);
    return (a, p) => a.question.getMaxLength() ? (o(), l("div", {
      key: 1,
      ref: (g) => s(g)
    }, [
      v("input", {
        disabled: a.question.isDisabledAttr,
        readonly: a.question.isReadOnlyAttr,
        class: r(a.question.getControlClass()),
        type: a.question.inputType,
        maxlength: a.question.getMaxLength(),
        min: a.question.renderedMin,
        max: a.question.renderedMax,
        step: a.question.renderedStep,
        size: a.question.renderedInputSize,
        style: M(t.value),
        id: a.question.inputId,
        list: a.question.dataListId,
        placeholder: a.question.renderedPlaceholder,
        autocomplete: a.question.autocomplete,
        value: a.question.inputValue,
        onChange: p[6] || (p[6] = //@ts-ignore
        (...g) => a.question.onChange && a.question.onChange(...g)),
        onKeyup: p[7] || (p[7] = //@ts-ignore
        (...g) => a.question.onKeyUp && a.question.onKeyUp(...g)),
        onKeydown: p[8] || (p[8] = //@ts-ignore
        (...g) => a.question.onKeyDown && a.question.onKeyDown(...g)),
        onCompositionUpdate: p[9] || (p[9] = //@ts-ignore
        (...g) => a.question.onCompositionUpdate && a.question.onCompositionUpdate(...g)),
        onBlur: p[10] || (p[10] = //@ts-ignore
        (...g) => a.question.onBlur && a.question.onBlur(...g)),
        onFocus: p[11] || (p[11] = //@ts-ignore
        (...g) => a.question.onFocus && a.question.onFocus(...g)),
        "aria-required": a.question.a11y_input_ariaRequired,
        "aria-label": a.question.a11y_input_ariaLabel,
        "aria-labelledby": a.question.a11y_input_ariaLabelledBy,
        "aria-describedby": a.question.a11y_input_ariaDescribedBy,
        "aria-invalid": a.question.a11y_input_ariaInvalid,
        "aria-errormessage": a.question.a11y_input_ariaErrormessage
      }, null, 46, f1),
      h(d, {
        is: "sv-character-counter",
        counter: a.question.characterCounter,
        remainingCharacterCounter: a.question.cssClasses.remainingCharacterCounter
      }, null, 8, ["counter", "remainingCharacterCounter"])
    ], 512)) : (o(), l("input", {
      key: 0,
      ref: (g) => s(g),
      disabled: a.question.isDisabledAttr,
      readonly: a.question.isReadOnlyAttr,
      class: r(a.question.getControlClass()),
      type: a.question.inputType,
      maxlength: a.question.getMaxLength(),
      min: a.question.renderedMin,
      max: a.question.renderedMax,
      step: a.question.renderedStep,
      size: a.question.renderedInputSize,
      style: M(t.value),
      id: a.question.inputId,
      list: a.question.dataListId,
      placeholder: a.question.renderedPlaceholder,
      autocomplete: a.question.autocomplete,
      value: a.question.inputValue,
      onChange: p[0] || (p[0] = //@ts-ignore
      (...g) => a.question.onChange && a.question.onChange(...g)),
      onKeyup: p[1] || (p[1] = //@ts-ignore
      (...g) => a.question.onKeyUp && a.question.onKeyUp(...g)),
      onKeydown: p[2] || (p[2] = //@ts-ignore
      (...g) => a.question.onKeyDown && a.question.onKeyDown(...g)),
      onCompositionUpdate: p[3] || (p[3] = //@ts-ignore
      (...g) => a.question.onCompositionUpdate && a.question.onCompositionUpdate(...g)),
      onBlur: p[4] || (p[4] = //@ts-ignore
      (...g) => a.question.onBlur && a.question.onBlur(...g)),
      onFocus: p[5] || (p[5] = //@ts-ignore
      (...g) => a.question.onFocus && a.question.onFocus(...g)),
      "aria-required": a.question.a11y_input_ariaRequired,
      "aria-label": a.question.a11y_input_ariaLabel,
      "aria-labelledby": a.question.a11y_input_ariaLabelledBy,
      "aria-describedby": a.question.a11y_input_ariaDescribedBy,
      "aria-invalid": a.question.a11y_input_ariaInvalid,
      "aria-errormessage": a.question.a11y_input_ariaErrormessage
    }, null, 46, k1));
  }
}), M1 = ["role", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], H1 = {
  key: 0,
  class: "sv-hidden"
}, I1 = { key: 7 }, S1 = ["value"], we = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "SelectBase",
  props: {
    question: {},
    showLegend: { type: Boolean }
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (t) => e.question.getItemValueWrapperComponentName(t) || e.question.itemComponent, i = (t) => ({
      componentName: e.question.itemComponent,
      componentData: {
        question: e.question,
        item: t,
        data: e.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, a) => (o(), l("fieldset", {
      class: r(t.question.getSelectBaseRootCss()),
      ref_key: "root",
      ref: n,
      role: t.question.a11y_input_ariaRole,
      "aria-required": t.question.a11y_input_ariaRequired,
      "aria-label": t.question.a11y_input_ariaLabel,
      "aria-labelledby": t.question.a11y_input_ariaLabelledBy,
      "aria-describedby": t.question.a11y_input_ariaDescribedBy,
      "aria-invalid": t.question.a11y_input_ariaInvalid,
      "aria-errormessage": t.question.a11y_input_ariaErrormessage
    }, [
      t.showLegend ? (o(), l("legend", H1, H(t.question.locTitle.renderedHtml), 1)) : m("", !0),
      t.question.hasHeadItems ? (o(!0), l(I, { key: 1 }, S(t.question.headItems, (p) => (o(), c(d, D({
        key: p.value,
        is: s(p)
      }, i(p)), null, 16, ["is"]))), 128)) : m("", !0),
      !t.question.hasColumns && !t.question.blockedRow ? (o(!0), l(I, { key: 2 }, S(t.question.bodyItems, (p) => (o(), c(d, D({
        key: p.value,
        is: s(p)
      }, i(p)), null, 16, ["is"]))), 128)) : m("", !0),
      t.question.blockedRow ? (o(), l("div", {
        key: 3,
        class: r(t.question.cssClasses.rootRow)
      }, [
        !t.question.hasColumns && t.question.blockedRow ? (o(!0), l(I, { key: 0 }, S(t.question.dataChoices, (p) => (o(), c(d, D({
          key: p.value,
          is: s(p)
        }, i(p)), null, 16, ["is"]))), 128)) : m("", !0)
      ], 2)) : m("", !0),
      t.question.hasColumns ? (o(), l("div", {
        key: 4,
        class: r(t.question.cssClasses.rootMultiColumn)
      }, [
        t.question.hasColumns ? (o(!0), l(I, { key: 0 }, S(t.question.columns, (p, g) => (o(), l("div", {
          key: g,
          class: r(t.question.getColumnClass()),
          role: "presentation"
        }, [
          (o(!0), l(I, null, S(p, (C) => (o(), c(d, D({
            key: C.value,
            is: s(C)
          }, i(C)), null, 16, ["is"]))), 128))
        ], 2))), 128)) : m("", !0)
      ], 2)) : m("", !0),
      t.question.hasFootItems ? (o(!0), l(I, { key: 5 }, S(t.question.footItems, (p) => (o(), c(d, D({
        key: p.value,
        is: s(p)
      }, i(p)), null, 16, ["is"]))), 128)) : m("", !0),
      t.question.renderedValue && t.question.isOtherSelected ? (o(), c(d, {
        key: 6,
        is: "survey-other-choice",
        question: t.question
      }, null, 8, ["question"])) : m("", !0),
      t.question.showClearButtonInContent ? (o(), l("div", I1, [
        v("input", {
          type: "button",
          class: r(t.question.cssClasses.clearButton),
          onClick: a[0] || (a[0] = () => {
            t.question.clearValue(!0);
          }),
          value: t.question.clearButtonCaption
        }, null, 10, S1)
      ])) : m("", !0)
    ], 10, M1));
  }
}), V1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Checkbox",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => (o(), c(we, {
      question: e.question,
      "show-legend": !0
    }, null, 8, ["question"]));
  }
});
function Le(u, e, n) {
  $(() => {
    n.value && (e().isDesignMode || u().setRootElement(n.value));
  }), P(() => {
    e().isDesignMode || u().setRootElement(void 0);
  }), V(u, (s, i) => {
    e().isDesignMode || (s && n.value && s.setRootElement(n.value), i && i.setRootElement(void 0));
  });
}
const B1 = ["name", "checked", "value", "id", "disabled", "readonly", "required"], R1 = ["xlink:href"], T1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "CheckboxItem",
  props: {
    question: {},
    item: {},
    hideLabel: { type: Boolean }
  },
  setup(u) {
    const e = f(), n = u;
    Le(
      () => n.item,
      () => n.question,
      e
    );
    const s = (i) => {
      n.question.clickItemHandler(n.item, i.target.checked);
    };
    return (i, t) => (o(), l("div", {
      role: "presentation",
      class: r(i.question.getItemClass(i.item)),
      ref_key: "root",
      ref: e
    }, [
      v("label", {
        class: r(i.question.getLabelClass(i.item))
      }, [
        v("input", {
          type: "checkbox",
          name: i.question.name + i.item.id,
          checked: i.question.isItemSelected(i.item),
          onInput: t[0] || (t[0] = (a) => {
            s(a);
          }),
          value: i.item.value,
          id: i.question.getItemId(i.item),
          disabled: !i.question.getItemEnabled(i.item),
          readonly: i.question.isReadOnlyAttr,
          class: r(i.question.cssClasses.itemControl),
          required: i.question.hasRequiredError()
        }, null, 42, B1),
        i.question.cssClasses.materialDecorator ? (o(), l("span", {
          key: 0,
          class: r(i.question.cssClasses.materialDecorator)
        }, [
          i.question.itemSvgIcon ? (o(), l("svg", {
            key: 0,
            class: r(i.question.cssClasses.itemDecorator)
          }, [
            v("use", {
              "xlink:href": i.question.itemSvgIcon
            }, null, 8, R1)
          ], 2)) : m("", !0)
        ], 2)) : m("", !0),
        i.hideLabel ? m("", !0) : (o(), l("span", {
          key: 1,
          class: r(i.question.cssClasses.controlLabel)
        }, [
          h(d, {
            is: "survey-string",
            locString: i.item.locText
          }, null, 8, ["locString"])
        ], 2))
      ], 2)
    ], 2));
  }
}), Z1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Radiogroup",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => (o(), c(we, { question: e.question }, null, 8, ["question"]));
  }
}), $1 = ["name", "value", "id", "aria-errormessage", "disabled", "readonly"], D1 = ["xlink:href"], A1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "RadiogroupItem",
  props: {
    question: {},
    item: {},
    hideLabel: { type: Boolean }
  },
  setup(u) {
    const e = f(), n = u, s = (a) => n.question.getLabelClass(a), i = (a) => n.question.getControlLabelClass(a), t = b({
      get: () => n.question.renderedValue,
      set: (a) => {
        const p = n.question;
        p.renderedValue = a;
      }
    });
    return Le(
      () => n.item,
      () => n.question,
      e
    ), (a, p) => (o(), l("div", {
      role: "presentation",
      class: r(a.question.getItemClass(a.item)),
      ref_key: "root",
      ref: e
    }, [
      v("label", {
        onMousedown: p[1] || (p[1] = (g) => a.question.onMouseDown()),
        class: r(s(a.item))
      }, [
        R(v("input", {
          type: "radio",
          name: a.question.questionName,
          value: a.item.value,
          id: a.question.getItemId(a.item),
          "aria-errormessage": a.question.ariaErrormessage,
          "onUpdate:modelValue": p[0] || (p[0] = (g) => t.value = g),
          disabled: !a.question.getItemEnabled(a.item),
          readonly: a.question.isReadOnlyAttr,
          class: r(a.question.cssClasses.itemControl)
        }, null, 10, $1), [
          [_, t.value]
        ]),
        a.question.cssClasses.materialDecorator ? (o(), l("span", {
          key: 0,
          class: r(a.question.cssClasses.materialDecorator)
        }, [
          a.question.itemSvgIcon ? (o(), l("svg", {
            key: 0,
            class: r(a.question.cssClasses.itemDecorator)
          }, [
            v("use", {
              "xlink:href": a.question.itemSvgIcon
            }, null, 8, D1)
          ], 2)) : m("", !0)
        ], 2)) : m("", !0),
        a.hideLabel ? m("", !0) : (o(), l("span", {
          key: 1,
          class: r(i(a.item))
        }, [
          h(d, {
            is: "survey-string",
            locString: a.item.locText
          }, null, 8, ["locString"])
        ], 2))
      ], 34)
    ], 2));
  }
}), N1 = ["src"], P1 = ["title"], E1 = { key: 0 }, W1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Signaturepad",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.cssClasses.root),
      ref_key: "root",
      ref: n,
      style: M({
        width: s.question.renderedCanvasWidth
      })
    }, [
      R(v("div", {
        class: r(s.question.cssClasses.placeholder)
      }, [
        h(d, {
          is: "survey-string",
          locString: s.question.locRenderedPlaceholder
        }, null, 8, ["locString"])
      ], 2), [
        [N, s.question.needShowPlaceholder()]
      ]),
      v("div", null, [
        s.question.backgroundImage ? (o(), l("img", {
          key: 0,
          class: r(s.question.cssClasses.backgroundImage),
          src: s.question.backgroundImage,
          style: M({
            width: s.question.renderedCanvasWidth
          })
        }, null, 14, N1)) : m("", !0),
        v("canvas", {
          tabindex: "-1",
          class: r(s.question.cssClasses.canvas),
          onBlur: i[0] || (i[0] = //@ts-ignore
          (...t) => s.question.onBlur && s.question.onBlur(...t))
        }, null, 34)
      ]),
      s.question.canShowClearButton ? (o(), l("div", {
        key: 0,
        class: r(s.question.cssClasses.controls)
      }, [
        v("button", {
          type: "button",
          class: r(s.question.cssClasses.clearButton),
          title: s.question.clearButtonCaption,
          onClick: i[1] || (i[1] = () => {
            s.question.clearValue(!0);
          })
        }, [
          s.question.cssClasses.clearButtonIconId ? m("", !0) : (o(), l("span", E1, "✖")),
          s.question.cssClasses.clearButtonIconId ? (o(), c(d, {
            key: 1,
            is: "sv-svg-icon",
            iconName: s.question.cssClasses.clearButtonIconId,
            size: "auto"
          }, null, 8, ["iconName"])) : m("", !0)
        ], 10, P1)
      ], 2)) : m("", !0),
      s.question.showLoadingIndicator ? (o(), l("div", {
        key: 1,
        class: r(s.question.cssClasses.loadingIndicator)
      }, [
        h(d, { is: "sv-loading-indicator" })
      ], 2)) : m("", !0)
    ], 6));
  }
}), F1 = ["innerHTML"], z1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Html",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = O(() => e.question.locHtml);
    return (i, t) => (o(), l("div", {
      ref_key: "root",
      ref: n,
      class: r(i.question.renderCssRoot),
      innerHTML: L(s)
    }, null, 10, F1));
  }
}), O1 = ["src", "alt", "width", "height"], U1 = ["src", "width", "height"], K1 = ["src", "width", "height"], j1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Image",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = O(() => e.question.locImageLink);
    return (i, t) => (o(), l("div", {
      class: r(i.question.cssClasses.root),
      ref_key: "root",
      ref: n
    }, [
      i.question.renderedMode === "image" ? R((o(), l("img", {
        key: 0,
        class: r(i.question.getImageCss()),
        src: L(s),
        alt: i.question.altText || i.question.title,
        width: i.question.renderedWidth,
        height: i.question.renderedHeight,
        style: M({
          objectFit: i.question.imageFit,
          width: i.question.renderedStyleWidth,
          height: i.question.renderedStyleHeight
        }),
        onLoad: t[0] || (t[0] = (a) => {
          i.question.onLoadHandler();
        }),
        onError: t[1] || (t[1] = (a) => {
          i.question.onErrorHandler();
        })
      }, null, 46, O1)), [
        [N, L(s) && !i.question.contentNotLoaded]
      ]) : m("", !0),
      i.question.renderedMode === "video" ? R((o(), l("video", {
        key: 1,
        controls: "",
        class: r(i.question.getImageCss()),
        src: L(s),
        width: i.question.renderedWidth,
        height: i.question.renderedHeight,
        style: M({
          objectFit: i.question.imageFit,
          width: i.question.renderedStyleWidth,
          height: i.question.renderedStyleHeight
        }),
        onLoadedmetadata: t[2] || (t[2] = (a) => {
          i.question.onLoadHandler();
        }),
        onError: t[3] || (t[3] = (a) => {
          i.question.onErrorHandler();
        })
      }, null, 46, U1)), [
        [N, L(s) && !i.question.contentNotLoaded]
      ]) : m("", !0),
      i.question.renderedMode === "youtube" ? (o(), l("iframe", {
        key: 2,
        class: r(i.question.getImageCss()),
        src: L(s),
        width: i.question.renderedWidth,
        height: i.question.renderedHeight,
        style: M({
          objectFit: i.question.imageFit,
          width: i.question.renderedStyleWidth,
          height: i.question.renderedStyleHeight
        })
      }, null, 14, K1)) : m("", !0),
      !L(s) || i.question.contentNotLoaded ? (o(), l("div", {
        key: 3,
        class: r(i.question.cssClasses.noImage)
      }, [
        h(d, {
          is: "sv-svg-icon",
          iconName: i.question.cssClasses.noImageSvgIconId,
          size: 48
        }, null, 8, ["iconName"])
      ], 2)) : m("", !0)
    ], 2));
  }
}), Q1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Expression",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.cssClasses.root),
      ref_key: "root",
      ref: n
    }, H(s.question.formatedValue), 3));
  }
}), G1 = ["id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "multiple", "title", "accept", "capture"], J1 = ["id", "multiple", "placeholder"], X1 = ["id", "multiple", "placeholder"], Y1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "File",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.fileRootCss),
      ref_key: "root",
      ref: n
    }, [
      !s.question.isReadOnlyAttr && !s.question.isDisabledAttr && s.question.hasFileUI ? (o(), l("input", {
        key: 0,
        class: r(s.question.cssClasses.fileInput),
        tabindex: "-1",
        type: "file",
        id: s.question.inputId,
        "aria-required": s.question.ariaRequired,
        "aria-label": s.question.ariaLabel,
        "aria-invalid": s.question.ariaInvalid,
        "aria-errormessage": s.question.ariaErrormessage,
        multiple: s.question.allowMultiple,
        title: s.question.inputTitle,
        accept: s.question.acceptedTypes,
        capture: s.question.renderCapture
      }, null, 10, G1)) : m("", !0),
      s.question.isReadOnlyAttr ? (o(), l("input", {
        key: 1,
        type: "file",
        readonly: "",
        id: s.question.inputId,
        class: r(s.question.getReadOnlyFileCss()),
        multiple: s.question.allowMultiple,
        placeholder: s.question.title,
        style: { color: "transparent" }
      }, null, 10, J1)) : m("", !0),
      s.question.isDisabledAttr ? (o(), l("input", {
        key: 2,
        type: "file",
        disabled: "",
        id: s.question.inputId,
        class: r(s.question.getReadOnlyFileCss()),
        multiple: s.question.allowMultiple,
        placeholder: s.question.title,
        style: { color: "transparent" }
      }, null, 10, X1)) : m("", !0),
      v("div", {
        class: r(s.question.cssClasses.dragArea),
        onDrop: i[0] || (i[0] = //@ts-ignore
        (...t) => s.question.onDrop && s.question.onDrop(...t)),
        onDragover: i[1] || (i[1] = //@ts-ignore
        (...t) => s.question.onDragOver && s.question.onDragOver(...t)),
        onDragleave: i[2] || (i[2] = //@ts-ignore
        (...t) => s.question.onDragLeave && s.question.onDragLeave(...t)),
        onDragenter: i[3] || (i[3] = //@ts-ignore
        (...t) => s.question.onDragEnter && s.question.onDragEnter(...t))
      }, [
        s.question.showFileDecorator ? (o(), l("div", {
          key: 0,
          class: r(s.question.getFileDecoratorCss())
        }, [
          v("span", {
            class: r(s.question.cssClasses.dragAreaPlaceholder)
          }, [
            h(d, {
              is: "survey-string",
              locString: s.question.locRenderedPlaceholder
            }, null, 8, ["locString"])
          ], 2),
          v("div", {
            class: r(s.question.cssClasses.wrapper)
          }, [
            s.question.showChooseButton ? (o(), c(d, {
              key: 0,
              is: "sv-file-choose-btn",
              data: { question: s.question }
            }, null, 8, ["data"])) : m("", !0),
            s.question.actionsContainerVisible ? (o(), c(d, {
              key: 1,
              is: "sv-action-bar",
              model: s.question.actionsContainer
            }, null, 8, ["model"])) : m("", !0),
            s.question.isEmpty() ? (o(), l("span", {
              key: 2,
              class: r(s.question.cssClasses.noFileChosen)
            }, H(s.question.noFileChosenCaption), 3)) : m("", !0)
          ], 2)
        ], 2)) : m("", !0),
        s.question.showRemoveButton ? (o(), c(d, {
          key: 1,
          is: "sv-file-clean-btn",
          question: s.question,
          css: s.question.showRemoveButton
        }, null, 8, ["question", "css"])) : m("", !0),
        s.question.showLoadingIndicator ? (o(), l("div", {
          key: 2,
          class: r(s.question.cssClasses.loadingIndicator)
        }, [
          h(d, { is: "sv-loading-indicator" })
        ], 2)) : m("", !0),
        s.question.isPlayingVideo ? (o(), c(d, {
          key: 3,
          is: "sv-file-video",
          question: s.question
        }, null, 8, ["question"])) : m("", !0),
        s.question.allowShowPreview ? (o(), c(d, {
          key: 4,
          is: "sv-file-preview",
          question: s.question
        }, null, 8, ["question"])) : m("", !0),
        s.question.showRemoveButtonBottom ? (o(), c(d, {
          key: 5,
          is: "sv-file-clean-btn",
          question: s.question,
          css: s.question.showRemoveButtonBottom
        }, null, 8, ["question", "css"])) : m("", !0),
        s.question.fileNavigatorVisible ? (o(), c(d, {
          key: 6,
          is: "sv-action-bar",
          model: s.question.fileNavigator
        }, null, 8, ["model"])) : m("", !0)
      ], 34)
    ], 2));
  }
}), _1 = { class: "sv-hidden" }, pe = "survey-imagepicker-item", x1 = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Imagepicker",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (t) => e.question.getItemValueWrapperComponentName(t) || pe, i = (t) => ({
      componentName: pe,
      componentData: {
        question: e.question,
        item: t,
        data: e.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, a) => (o(), l("fieldset", {
      class: r(t.question.getSelectBaseRootCss()),
      style: M(t.question.getContainerStyle()),
      ref_key: "root",
      ref: n
    }, [
      v("legend", _1, H(t.question.locTitle.renderedHtml), 1),
      t.question.hasColumns ? m("", !0) : (o(!0), l(I, { key: 0 }, S(t.question.visibleChoices, (p) => (o(), c(d, D({
        key: p.value,
        is: s(p)
      }, i(p)), null, 16, ["is"]))), 128)),
      t.question.hasColumns ? (o(!0), l(I, { key: 1 }, S(t.question.columns, (p, g) => (o(), l("div", {
        class: r(t.question.getColumnClass()),
        key: g,
        role: "presentation"
      }, [
        (o(!0), l(I, null, S(p, (C) => (o(), c(d, D({
          key: C.value,
          is: s(C)
        }, i(C)), null, 16, ["is"]))), 128))
      ], 2))), 128)) : m("", !0)
    ], 6));
  }
}), es = ["name", "value", "id", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], ss = ["name", "value", "id", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], ns = ["src", "width", "height", "alt"], ts = ["src", "width", "height"], os = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "ImagepickerItem",
  props: {
    question: {},
    item: {}
  },
  setup(u) {
    const e = u, n = (t) => e.question.getItemClass(t), s = b({
      get() {
        return e.question.value;
      },
      set(t) {
        const a = e.question;
        a.isReadOnlyAttr || (a.value = t);
      }
    });
    V(() => e.item);
    const i = O(() => e.item.locImageLink);
    return (t, a) => (o(), l("div", {
      class: r(n(t.item))
    }, [
      v("label", {
        class: r(t.question.cssClasses.label)
      }, [
        t.question.multiSelect ? R((o(), l("input", {
          key: 0,
          type: "checkbox",
          name: t.question.questionName,
          value: t.item.value,
          id: t.question.getItemId(t.item),
          "onUpdate:modelValue": a[0] || (a[0] = (p) => s.value = p),
          disabled: !t.question.getItemEnabled(t.item),
          readonly: t.question.isReadOnlyAttr,
          "aria-required": t.question.ariaRequired,
          "aria-label": t.item.locText.renderedHtml,
          "aria-invalid": t.question.ariaInvalid,
          "aria-errormessage": t.question.ariaErrormessage,
          class: r(t.question.cssClasses.itemControl)
        }, null, 10, es)), [
          [te, s.value]
        ]) : R((o(), l("input", {
          key: 1,
          type: "radio",
          name: t.question.questionName,
          value: t.item.value,
          id: t.question.getItemId(t.item),
          "onUpdate:modelValue": a[1] || (a[1] = (p) => s.value = p),
          disabled: !t.question.getItemEnabled(t.item),
          readonly: t.question.isReadOnlyAttr,
          "aria-required": t.question.ariaRequired,
          "aria-label": t.item.locText.renderedHtml,
          "aria-invalid": t.question.ariaInvalid,
          "aria-errormessage": t.question.ariaErrormessage,
          class: r(t.question.cssClasses.itemControl)
        }, null, 10, ss)), [
          [_, s.value]
        ]),
        v("div", {
          class: r(t.question.cssClasses.itemDecorator)
        }, [
          v("div", {
            class: r(t.question.cssClasses.imageContainer)
          }, [
            t.question.cssClasses.checkedItemDecorator ? (o(), l("span", {
              key: 0,
              class: r(t.question.cssClasses.checkedItemDecorator),
              "aria-hidden": "true"
            }, [
              t.question.cssClasses.checkedItemSvgIconId ? (o(), c(d, {
                key: 0,
                is: "sv-svg-icon",
                class: r(t.question.cssClasses.checkedItemSvgIcon),
                size: "auto",
                iconName: t.question.cssClasses.checkedItemSvgIconId
              }, null, 8, ["class", "iconName"])) : m("", !0)
            ], 2)) : m("", !0),
            L(i) && !t.item.contentNotLoaded && t.question.contentMode === "image" ? (o(), l("img", {
              key: 1,
              class: r(t.question.cssClasses.image),
              src: L(i),
              width: t.question.renderedImageWidth,
              height: t.question.renderedImageHeight,
              style: M({ objectFit: t.question.imageFit }),
              alt: t.item.locText.renderedHtml,
              onLoad: a[2] || (a[2] = (p) => {
                t.question.onContentLoaded(t.item, p);
              }),
              onError: a[3] || (a[3] = (p) => {
                t.item.onErrorHandler();
              })
            }, null, 46, ns)) : m("", !0),
            L(i) && !t.item.contentNotLoaded && t.question.contentMode === "video" ? (o(), l("video", {
              key: 2,
              controls: "",
              class: r(t.question.cssClasses.image),
              src: L(i),
              width: t.question.renderedImageWidth,
              height: t.question.renderedImageHeight,
              style: M({ objectFit: t.question.imageFit }),
              onLoadedmetadata: a[4] || (a[4] = (p) => {
                t.question.onContentLoaded(t.item, p);
              }),
              onError: a[5] || (a[5] = (p) => {
                t.item.onErrorHandler();
              })
            }, null, 46, ts)) : m("", !0),
            !L(i) || t.item.contentNotLoaded ? (o(), l("div", {
              key: 3,
              class: r(t.question.cssClasses.itemNoImage),
              style: M({
                width: t.question.renderedImageWidth + "px",
                height: t.question.renderedImageHeight + "px",
                objectFit: t.question.imageFit
              })
            }, [
              h(d, {
                is: "sv-svg-icon",
                class: r(t.question.cssClasses.itemNoImageSvgIcon),
                iconName: t.question.cssClasses.itemNoImageSvgIconId,
                size: 48
              }, null, 8, ["class", "iconName"])
            ], 6)) : m("", !0)
          ], 2),
          t.question.showLabel ? (o(), l("span", {
            key: 0,
            class: r(t.question.cssClasses.itemText)
          }, [
            h(d, {
              is: "survey-string",
              locString: t.item.locText
            }, null, 8, ["locString"])
          ], 2)) : m("", !0)
        ], 2)
      ], 2)
    ], 2));
  }
}), is = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Comment",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => !s.question.isReadOnlyRenderDiv() && s.question.getMaxLength() ? (o(), l("div", {
      key: 0,
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "sv-text-area",
        model: s.question.textAreaModel
      }, null, 8, ["model"]),
      h(d, {
        is: "sv-character-counter",
        counter: s.question.characterCounter,
        remainingCharacterCounter: s.question.cssClasses.remainingCharacterCounter
      }, null, 8, ["counter", "remainingCharacterCounter"])
    ], 512)) : !s.question.isReadOnlyRenderDiv() && !s.question.getMaxLength() ? (o(), c(d, {
      key: 1,
      is: "sv-text-area",
      ref_key: "root",
      ref: n,
      model: s.question.textAreaModel
    }, null, 8, ["model"])) : (o(), l("div", {
      key: 2,
      ref_key: "root",
      ref: n
    }, H(s.question.value), 513));
  }
}), rs = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Dropdown",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.renderCssRoot),
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "sv-dropdown",
        question: s.question
      }, null, 8, ["question"]),
      s.question.isOtherSelected ? (o(), c(d, {
        key: 0,
        is: "survey-other-choice",
        question: s.question
      }, null, 8, ["question"])) : m("", !0)
    ], 2));
  }
}), ls = ["id", "autocomplete", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "required"], as = {
  key: 0,
  value: ""
}, us = ["id"];
x.Instance.registerRenderer(
  "dropdown",
  "select",
  "sv-dropdown-select"
);
const ds = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "DropdownSelect",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (a) => {
      e.question.onClick(a);
    }, i = (a) => {
      e.question.onKeyUp(a);
    }, t = b({
      get() {
        return e.question.value ?? "";
      },
      set(a) {
        const p = e.question;
        a === "" ? p.renderedValue = void 0 : p.renderedValue = a;
      }
    });
    return (a, p) => (o(), l("div", {
      class: r(a.question.renderCssRoot),
      ref_key: "root",
      ref: n
    }, [
      v("div", {
        class: r(a.question.cssClasses.selectWrapper)
      }, [
        a.question.isReadOnly ? (o(), l("div", {
          key: 1,
          disabled: "",
          id: a.question.inputId,
          class: r(a.question.getControlClass())
        }, H(a.question.readOnlyText), 11, us)) : R((o(), l("select", {
          key: 0,
          id: a.question.inputId,
          "onUpdate:modelValue": p[0] || (p[0] = (g) => t.value = g),
          onClick: s,
          onKeyup: i,
          autocomplete: a.question.autocomplete,
          class: r(a.question.getControlClass()),
          "aria-required": a.question.ariaRequired,
          "aria-label": a.question.ariaLabel,
          "aria-invalid": a.question.ariaInvalid,
          "aria-errormessage": a.question.ariaErrormessage,
          required: a.question.isRequired
        }, [
          a.question.allowClear ? (o(), l("option", as, H(a.question.placeholder), 1)) : m("", !0),
          (o(!0), l(I, null, S(a.question.visibleChoices, (g) => (o(), c(d, {
            is: "sv-dropdown-option-item",
            item: g,
            key: g.id
          }, null, 8, ["item"]))), 128))
        ], 42, ls)), [
          [Re, t.value]
        ]),
        a.question.cssClasses.chevronButtonIconId ? (o(), l("div", {
          key: 2,
          class: r(a.question.cssClasses.chevronButton),
          "aria-hidden": "true"
        }, [
          h(d, {
            is: "sv-svg-icon",
            class: r(a.question.cssClasses.chevronButtonSvg),
            iconName: a.question.cssClasses.chevronButtonIconId,
            size: "auto"
          }, null, 8, ["class", "iconName"])
        ], 2)) : m("", !0)
      ], 2),
      a.question.isOtherSelected ? (o(), c(d, {
        key: 0,
        is: "survey-other-choice",
        question: a.question
      }, null, 8, ["question"])) : m("", !0)
    ], 2));
  }
}), ms = ["value", "disabled"], ps = /* @__PURE__ */ y({
  __name: "OptionItem",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, n = O(() => e.item.locText);
    return V(() => e.item), (s, i) => (o(), l("option", {
      value: s.item.value,
      disabled: !s.item.isEnabled
    }, H(L(n)), 9, ms));
  }
}), Cs = ["id", "disabled", "tabindex", "role", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "aria-expanded", "aria-controls", "aria-activedescendant", "required"], vs = { style: { visibility: "hidden" } }, cs = ["disabled", "inputmode", "role", "id", "tabindex", "readonly", "aria-expanded", "aria-controls", "aria-label", "aria-labelledby", "aria-describedby", "aria-activedescendant", "placeholder"], gs = ["id", "aria-label", "aria-labelledby", "aria-describedby", "tabindex"], hs = /* @__PURE__ */ y({
  __name: "Dropdown",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null), s = b(() => e.question.dropdownListModel), i = (w) => {
      var A;
      (A = s.value) == null || A.onClick(w);
    }, t = (w) => {
      var A;
      (A = s.value) == null || A.chevronPointerDown(w);
    }, a = (w) => {
      var A;
      (A = s.value) == null || A.onClear(w);
    }, p = (w) => {
      var A;
      (A = s.value) == null || A.keyHandler(w);
    }, g = () => {
      if (n.value) {
        const w = n.value, A = s.value.inputStringRendered;
        Pe.isTwoValueEquals(A, w.value, !1, !0, !1) || (w.value = s.value.inputStringRendered);
      }
    }, C = (w) => {
      e.question.onBlur(w), g();
    }, q = (w) => {
      e.question.onFocus(w);
    }, B = (w) => {
      s.value.inputStringRendered = w.target.value;
    }, k = b(
      () => e.question.showSelectedItemLocText
    ), Z = b(() => e.question.selectedItemLocText);
    return V(() => s.value), j(g), $(g), (w, A) => (o(), l("div", {
      class: r(w.question.cssClasses.selectWrapper),
      onClick: i
    }, [
      w.question.isReadOnly ? m("", !0) : (o(), l("div", {
        key: 0,
        id: w.question.inputId,
        disabled: w.question.isDisabledAttr ? !0 : null,
        tabindex: s.value.noTabIndex ? void 0 : 0,
        onKeydown: p,
        onBlur: C,
        class: r(w.question.getControlClass()),
        role: w.question.ariaRole,
        "aria-required": w.question.ariaRequired,
        "aria-label": w.question.ariaLabel,
        "aria-invalid": w.question.ariaInvalid,
        "aria-errormessage": w.question.ariaErrormessage,
        "aria-expanded": w.question.ariaExpanded,
        "aria-controls": s.value.listElementId,
        "aria-activedescendant": s.value.ariaActivedescendant,
        required: w.question.isRequired ? !0 : null
      }, [
        s.value.showHintPrefix ? (o(), l("div", {
          key: 0,
          class: r(w.question.cssClasses.hintPrefix)
        }, [
          v("span", null, H(s.value.hintStringPrefix), 1)
        ], 2)) : m("", !0),
        v("div", {
          class: r(w.question.cssClasses.controlValue)
        }, [
          k.value ? (o(), c(d, {
            key: 0,
            is: "survey-string",
            locString: Z.value
          }, null, 8, ["locString"])) : m("", !0),
          s.value.showHintString ? (o(), l("div", {
            key: 1,
            class: r(w.question.cssClasses.hintSuffix)
          }, [
            v("span", vs, H(s.value.inputStringRendered), 1),
            v("span", null, H(s.value.hintStringSuffix), 1)
          ], 2)) : m("", !0),
          w.question.showInputFieldComponent ? (o(), c(d, {
            key: 2,
            is: w.question.inputFieldComponentName,
            item: s.value.getSelectedAction(),
            question: w.question
          }, null, 8, ["is", "item", "question"])) : m("", !0),
          v("input", {
            type: "text",
            ref_key: "inputElement",
            ref: n,
            class: r(w.question.cssClasses.filterStringInput),
            disabled: w.question.isDisabledAttr,
            autocomplete: "off",
            inputmode: s.value.inputMode,
            role: s.value.filterStringEnabled ? w.question.ariaRole : void 0,
            id: w.question.getInputId(),
            tabindex: s.value.noTabIndex ? void 0 : -1,
            readonly: s.value.filterReadOnly ? !0 : void 0,
            "aria-expanded": w.question.ariaExpanded,
            "aria-controls": s.value.listElementId,
            "aria-label": w.question.a11y_input_ariaLabel,
            "aria-labelledby": w.question.a11y_input_ariaLabelledBy,
            "aria-describedby": w.question.a11y_input_ariaDescribedBy,
            "aria-activedescendant": s.value.ariaActivedescendant,
            placeholder: s.value.placeholderRendered,
            onInput: B,
            onBlur: C,
            onFocus: q
          }, null, 42, cs)
        ], 2),
        w.question.allowClear && w.question.cssClasses.cleanButtonIconId ? R((o(), l("div", {
          key: 1,
          class: r(w.question.cssClasses.cleanButton),
          onClick: a,
          "aria-hidden": "true"
        }, [
          h(d, {
            is: "sv-svg-icon",
            class: r(w.question.cssClasses.cleanButtonSvg),
            iconName: w.question.cssClasses.cleanButtonIconId,
            title: w.question.clearCaption,
            size: "auto"
          }, null, 8, ["class", "iconName", "title"])
        ], 2)), [
          [N, w.question.showClearButton]
        ]) : m("", !0)
      ], 42, Cs)),
      w.question.isReadOnly ? (o(), l("div", {
        key: 2,
        id: w.question.inputId,
        "aria-label": w.question.a11y_input_ariaLabel,
        "aria-labelledby": w.question.a11y_input_ariaLabelledBy,
        "aria-describedby": w.question.a11y_input_ariaDescribedBy,
        tabindex: w.question.isDisabledAttr ? void 0 : 0,
        class: r(w.question.getControlClass())
      }, [
        w.question.selectedItemLocText ? (o(), c(d, {
          key: 0,
          is: "survey-string",
          locString: w.question.selectedItemLocText
        }, null, 8, ["locString"])) : m("", !0),
        v("div", null, H(w.question.readOnlyText), 1)
      ], 10, gs)) : (o(), c(d, {
        key: 1,
        is: "sv-popup",
        model: w.question.dropdownListModel.popupModel
      }, null, 8, ["model"])),
      w.question.cssClasses.chevronButtonIconId ? (o(), l("div", {
        key: 3,
        class: r(w.question.cssClasses.chevronButton),
        onPointerdown: t,
        "aria-hidden": "true"
      }, [
        h(d, {
          is: "sv-svg-icon",
          class: r(w.question.cssClasses.chevronButtonSvg),
          iconName: w.question.cssClasses.chevronButtonIconId,
          size: "auto"
        }, null, 8, ["class", "iconName"])
      ], 34)) : m("", !0)
    ], 2));
  }
}), ys = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Tagbox",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.renderCssRoot),
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "sv-tagbox",
        question: s.question
      }, null, 8, ["question"]),
      s.question.isOtherSelected ? (o(), c(d, {
        key: 0,
        is: "survey-other-choice",
        question: s.question
      }, null, 8, ["question"])) : m("", !0)
    ], 2));
  }
}), qs = ["id", "tabindex", "disabled", "role", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "aria-expanded", "aria-controls", "aria-activedescendant", "required"], ws = ["id", "aria-label", "aria-labelledby", "aria-describedby", "tabindex"], Ls = /* @__PURE__ */ y({
  __name: "Tagbox",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = b(() => {
      const C = e.question;
      return C.dropdownListModel || (C.dropdownListModel = new Ee(C)), e.question.dropdownListModel;
    }), s = (C) => {
      var q;
      (q = n.value) == null || q.onClick(C);
    }, i = (C) => {
      var q;
      (q = n.value) == null || q.chevronPointerDown(C);
    }, t = (C) => {
      var q;
      (q = n.value) == null || q.onClear(C);
    }, a = (C) => {
      var q;
      (q = n.value) == null || q.keyHandler(C);
    }, p = (C) => {
      var q;
      (q = n.value) == null || q.onBlur(C);
    }, g = ee(() => e.question.selectedChoices);
    return V(() => n.value), (C, q) => (o(), l("div", {
      class: r(C.question.cssClasses.selectWrapper),
      onClick: s
    }, [
      C.question.isReadOnly ? m("", !0) : (o(), l("div", {
        key: 0,
        id: C.question.inputId,
        tabindex: n.value.noTabIndex ? void 0 : 0,
        disabled: C.question.isDisabledAttr ? !0 : null,
        onKeydown: a,
        onBlur: p,
        class: r(C.question.getControlClass()),
        role: C.question.ariaRole,
        "aria-required": C.question.ariaRequired,
        "aria-label": C.question.ariaLabel,
        "aria-invalid": C.question.ariaInvalid,
        "aria-errormessage": C.question.ariaErrormessage,
        "aria-expanded": C.question.ariaExpanded,
        "aria-controls": n.value.listElementId,
        "aria-activedescendant": n.value.ariaActivedescendant,
        required: C.question.isRequired ? !0 : null
      }, [
        v("div", {
          class: r(C.question.cssClasses.controlValue)
        }, [
          (o(!0), l(I, null, S(L(g), (B, k) => (o(), c(d, {
            is: "sv-tagbox-item",
            item: B,
            question: C.question,
            key: "item" + k
          }, null, 8, ["item", "question"]))), 128)),
          h(d, {
            is: "sv-tagbox-filter",
            model: n.value,
            question: C.question
          }, null, 8, ["model", "question"])
        ], 2),
        C.question.allowClear && C.question.cssClasses.cleanButtonIconId ? R((o(), l("div", {
          key: 0,
          class: r(C.question.cssClasses.cleanButton),
          onClick: t,
          "aria-hidden": "true"
        }, [
          h(d, {
            is: "sv-svg-icon",
            class: r(C.question.cssClasses.cleanButtonSvg),
            iconName: C.question.cssClasses.cleanButtonIconId,
            title: C.question.clearCaption,
            size: "auto"
          }, null, 8, ["class", "iconName", "title"])
        ], 2)), [
          [N, C.question.showClearButton]
        ]) : m("", !0)
      ], 42, qs)),
      C.question.isReadOnly ? (o(), l("div", {
        key: 2,
        id: C.question.inputId,
        "aria-label": C.question.a11y_input_ariaLabel,
        "aria-labelledby": C.question.a11y_input_ariaLabelledBy,
        "aria-describedby": C.question.a11y_input_ariaDescribedBy,
        tabindex: C.question.isDisabledAttr ? void 0 : 0,
        class: r(C.question.getControlClass())
      }, [
        C.question.locReadOnlyText ? (o(), c(d, {
          key: 0,
          is: "survey-string",
          locString: C.question.locReadOnlyText
        }, null, 8, ["locString"])) : m("", !0)
      ], 10, ws)) : (o(), c(d, {
        key: 1,
        is: "sv-popup",
        model: n.value.popupModel
      }, null, 8, ["model"])),
      C.question.cssClasses.chevronButtonIconId ? (o(), l("div", {
        key: 3,
        class: r(C.question.cssClasses.chevronButton),
        onPointerdown: i,
        "aria-hidden": "true"
      }, [
        h(d, {
          is: "sv-svg-icon",
          class: r(C.question.cssClasses.chevronButtonSvg),
          iconName: C.question.cssClasses.chevronButtonIconId,
          size: "auto"
        }, null, 8, ["class", "iconName"])
      ], 34)) : m("", !0)
    ], 2));
  }
}), ks = { style: { visibility: "hidden" } }, fs = ["placeholder", "disabled", "inputmode", "role", "aria-expanded", "aria-controls", "aria-label", "aria-labelledby", "aria-describedby", "aria-activedescendant", "id", "readonly", "size"], bs = /* @__PURE__ */ y({
  __name: "TagboxFilter",
  props: {
    question: {},
    model: {}
  },
  setup(u) {
    const e = u, n = (a) => {
      const p = e.model;
      p.inputStringRendered = a.target.value;
    }, s = (a) => {
      e.model.inputKeyHandler(a);
    }, i = (a) => {
      e.question.onBlur(a);
    }, t = (a) => {
      e.question.onFocus(a);
    };
    return V(() => e.model), (a, p) => (o(), l("div", {
      class: r(a.question.cssClasses.hint)
    }, [
      a.model.showHintPrefix ? (o(), l("div", {
        key: 0,
        class: r(a.question.cssClasses.hintPrefix)
      }, [
        v("span", null, H(a.model.hintStringPrefix), 1)
      ], 2)) : m("", !0),
      v("div", {
        class: r(a.question.cssClasses.hintSuffixWrapper)
      }, [
        a.question.showSelectedItemLocText ? (o(), c(d, {
          key: 0,
          is: "survey-string",
          locString: a.question.selectedItemLocText
        }, null, 8, ["locString"])) : m("", !0),
        a.model.showHintString ? (o(), l("div", {
          key: 1,
          class: r(a.question.cssClasses.hintSuffix)
        }, [
          v("span", ks, H(a.model.inputStringRendered), 1),
          v("span", null, H(a.model.hintStringSuffix), 1)
        ], 2)) : m("", !0),
        R(v("input", {
          type: "text",
          autocomplete: "off",
          "onUpdate:modelValue": p[0] || (p[0] = (g) => a.model.inputStringRendered = g),
          class: r(a.question.cssClasses.filterStringInput),
          placeholder: a.model.filterStringPlaceholder,
          disabled: a.question.isDisabledAttr,
          inputmode: a.model.inputMode,
          role: a.model.filterStringEnabled ? a.question.ariaRole : void 0,
          "aria-expanded": a.question.ariaExpanded,
          "aria-controls": a.model.listElementId,
          "aria-label": a.question.a11y_input_ariaLabel,
          "aria-labelledby": a.question.a11y_input_ariaLabelledBy,
          "aria-describedby": a.question.a11y_input_ariaDescribedBy,
          "aria-activedescendant": a.model.ariaActivedescendant,
          id: a.question.getInputId(),
          readonly: a.model.filterReadOnly ? !0 : void 0,
          size: a.model.inputStringRendered ? void 0 : 1,
          onChange: n,
          onKeydown: s,
          onBlur: i,
          onFocus: t
        }, null, 42, fs), [
          [Te, a.model.inputStringRendered]
        ])
      ], 2)
    ], 2));
  }
}), Ms = { class: "sv-tagbox__item-text" }, Hs = /* @__PURE__ */ y({
  __name: "TagboxItem",
  props: {
    question: {},
    item: {}
  },
  setup(u) {
    const e = u, n = (s) => {
      e.question.dropdownListModel.deselectItem(e.item.value), s.stopPropagation();
    };
    return V(() => e.item), (s, i) => (o(), l("div", {
      class: "sv-tagbox__item",
      key: s.item.key
    }, [
      v("div", Ms, [
        h(d, {
          is: "survey-string",
          locString: s.item.locText
        }, null, 8, ["locString"])
      ]),
      v("div", {
        class: r(s.question.cssClasses.cleanItemButton),
        onClick: n
      }, [
        h(d, {
          is: "sv-svg-icon",
          class: r(s.question.cssClasses.cleanItemButtonSvg),
          iconName: s.question.cssClasses.cleanItemButtonIconId,
          size: "auto"
        }, null, 8, ["class", "iconName"])
      ], 2)
    ]));
  }
}), Is = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Ranking",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (t) => e.question.getItemValueWrapperComponentName(t) || "survey-ranking-item", i = (t, a, p) => ({
      componentName: "survey-ranking-item",
      componentData: {
        question: e.question,
        item: t,
        index: a,
        unrankedItem: p,
        data: e.question.getItemValueWrapperComponentData(t)
      }
    });
    return (t, a) => (o(), l("div", {
      class: r(t.question.rootClass),
      ref_key: "root",
      ref: n
    }, [
      t.question.selectToRankEnabled ? m("", !0) : (o(!0), l(I, { key: 0 }, S(t.question.renderedRankingChoices, (p, g) => (o(), c(d, D({
        key: p.value + "-" + g + "-item",
        is: s(p)
      }, i(p, g)), null, 16, ["is"]))), 128)),
      t.question.selectToRankEnabled ? (o(), l("div", {
        key: 1,
        class: r(t.question.getContainerClasses("from")),
        "data-ranking": "from-container"
      }, [
        (o(!0), l(I, null, S(t.question.renderedUnRankingChoices, (p, g) => (o(), c(d, D({
          key: p.value + "-" + g + "-item",
          is: s(p)
        }, i(p, g, !0)), null, 16, ["is"]))), 128)),
        t.question.renderedUnRankingChoices.length === 0 ? (o(), l("div", {
          key: 0,
          class: r(t.question.cssClasses.containerPlaceholder)
        }, [
          h(d, {
            is: "survey-string",
            locString: t.question.locSelectToRankEmptyRankedAreaText
          }, null, 8, ["locString"])
        ], 2)) : m("", !0)
      ], 2)) : m("", !0),
      t.question.selectToRankEnabled ? (o(), l("div", {
        key: 2,
        class: r(t.question.cssClasses.containersDivider)
      }, null, 2)) : m("", !0),
      t.question.selectToRankEnabled ? (o(), l("div", {
        key: 3,
        class: r(t.question.getContainerClasses("to")),
        "data-ranking": "to-container"
      }, [
        (o(!0), l(I, null, S(t.question.renderedRankingChoices, (p, g) => (o(), c(d, D({
          key: p.value + "-" + g + "-item",
          is: s(p)
        }, i(p, g)), null, 16, ["is"]))), 128)),
        t.question.renderedRankingChoices.length === 0 ? (o(), l("div", {
          key: 0,
          class: r(t.question.cssClasses.containerPlaceholder)
        }, [
          h(d, {
            is: "survey-string",
            locString: t.question.locSelectToRankEmptyUnrankedAreaText
          }, null, 8, ["locString"])
        ], 2)) : m("", !0)
      ], 2)) : m("", !0)
    ], 2));
  }
}), Ss = ["tabindex", "data-sv-drop-target-ranking-item"], Vs = {
  tabindex: "-1",
  style: { outline: "none" }
}, Bs = ["xlink:href"], Rs = ["xlink:href"], Ts = ["xlink:href"], Zs = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "RankingItem",
  props: {
    index: {},
    question: {},
    item: {},
    unrankedItem: { type: Boolean }
  },
  setup(u) {
    const e = u, n = b(() => e.question.getNumberByIndex(e.index));
    return V(() => e.item), (s, i) => (o(), l("div", {
      tabindex: s.question.getItemTabIndex(s.item),
      "data-sv-drop-target-ranking-item": s.index,
      class: r(s.question.getItemClass(s.item)),
      onKeydown: i[0] || (i[0] = (t) => {
        s.question.handleKeydown.call(s.question, t, s.item);
      }),
      onPointerdown: i[1] || (i[1] = (t) => {
        s.question.handlePointerDown.call(
          s.question,
          t,
          s.item,
          t.currentTarget
        );
      }),
      onPointerup: i[2] || (i[2] = (t) => {
        s.question.handlePointerUp.call(
          s.question,
          t,
          s.item,
          t.currentTarget
        );
      })
    }, [
      v("div", Vs, [
        v("div", {
          class: r(s.question.cssClasses.itemGhostNode)
        }, null, 2),
        v("div", {
          class: r(s.question.cssClasses.itemContent)
        }, [
          v("div", {
            class: r(s.question.cssClasses.itemIconContainer)
          }, [
            (o(), l("svg", {
              class: r(s.question.getIconHoverCss())
            }, [
              v("use", {
                "xlink:href": s.question.dragDropSvgIcon
              }, null, 8, Bs)
            ], 2)),
            (o(), l("svg", {
              class: r(s.question.getIconFocusCss())
            }, [
              v("use", {
                "xlink:href": s.question.arrowsSvgIcon
              }, null, 8, Rs)
            ], 2))
          ], 2),
          !s.unrankedItem && n.value ? (o(), l("div", {
            key: 0,
            class: r(s.question.getItemIndexClasses(s.item))
          }, H(n.value), 3)) : (o(), l("div", {
            key: 1,
            class: r(s.question.getItemIndexClasses(s.item))
          }, [
            (o(), l("svg", null, [
              v("use", {
                "xlink:href": s.question.dashSvgIcon
              }, null, 8, Ts)
            ]))
          ], 2)),
          h(d, {
            is: s.question.itemComponent,
            item: s.item,
            cssClasses: s.question.cssClasses
          }, null, 8, ["is", "item", "cssClasses"])
        ], 2)
      ])
    ], 42, Ss));
  }
}), $s = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "RankingItemContent",
  props: {
    item: {},
    cssClasses: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", {
      class: r(e.cssClasses.controlLabel)
    }, [
      h(d, {
        is: "survey-string",
        locString: e.item.locText
      }, null, 8, ["locString"])
    ], 2));
  }
}), Ds = { role: "radiogroup" }, As = /* @__PURE__ */ v("legend", {
  role: "presentation",
  class: "sv-hidden"
}, null, -1), Ns = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Rating",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (i) => e.question.getInputId(i);
    return (i, t) => (o(), l("div", {
      class: r(i.question.ratingRootCss),
      ref_key: "root",
      ref: n
    }, [
      v("fieldset", Ds, [
        As,
        i.question.hasMinLabel ? (o(), l("span", {
          key: 0,
          class: r(i.question.cssClasses.minText)
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locMinRateDescription
          }, null, 8, ["locString"])
        ], 2)) : m("", !0),
        (o(!0), l(I, null, S(i.question.renderedRateItems, (a, p) => (o(), c(d, {
          key: s(p),
          is: i.question.itemComponent,
          item: a,
          index: p,
          question: i.question
        }, null, 8, ["is", "item", "index", "question"]))), 128)),
        i.question.hasMaxLabel ? (o(), l("span", {
          key: 1,
          class: r(i.question.cssClasses.maxText)
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locMaxRateDescription
          }, null, 8, ["locString"])
        ], 2)) : m("", !0)
      ])
    ], 2));
  }
}), Ps = ["name", "id", "value", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Es = ["data-text"], Ws = /* @__PURE__ */ y({
  __name: "RatingItem",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l("label", {
      key: n.item.value,
      onMousedown: s[1] || (s[1] = (i) => n.question.onMouseDown()),
      class: r(n.question.getItemClassByText(n.item.itemValue, n.item.text))
    }, [
      v("input", {
        type: "radio",
        class: "sv-visuallyhidden",
        name: n.question.questionName,
        id: n.question.getInputId(n.index),
        value: n.item.value,
        disabled: n.question.isDisabledAttr,
        readonly: n.question.isReadOnlyAttr,
        onClick: s[0] || (s[0] = (i) => n.question.setValueFromClick(i.target.value)),
        "aria-required": n.question.ariaRequired,
        "aria-label": n.question.ariaLabel,
        "aria-invalid": n.question.ariaInvalid,
        "aria-errormessage": n.question.ariaErrormessage
      }, null, 8, Ps),
      v("span", {
        class: r(n.question.cssClasses.itemText),
        "data-text": n.item.text
      }, [
        h(d, {
          is: "survey-string",
          locString: n.item.locText
        }, null, 8, ["locString"])
      ], 10, Es)
    ], 34));
  }
}), Fs = ["name", "id", "value", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], zs = /* @__PURE__ */ y({
  __name: "RatingItemSmiley",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l("label", {
      key: n.item.value,
      onMousedown: s[1] || (s[1] = (i) => n.question.onMouseDown()),
      style: M(n.question.getItemStyle(n.item.itemValue, n.item.highlight)),
      class: r(n.question.getItemClass(n.item.itemValue, n.item.highlight)),
      onMouseover: s[2] || (s[2] = (i) => n.question.onItemMouseIn(n.item)),
      onMouseleave: s[3] || (s[3] = (i) => n.question.onItemMouseOut(n.item))
    }, [
      v("input", {
        type: "radio",
        class: "sv-visuallyhidden",
        name: n.question.questionName,
        id: n.question.getInputId(n.index),
        value: n.item.value,
        disabled: n.question.isDisabledAttr,
        readonly: n.question.isReadOnlyAttr,
        onClick: s[0] || (s[0] = (i) => n.question.setValueFromClick(i.target.value)),
        "aria-required": n.question.ariaRequired,
        "aria-label": n.question.ariaLabel,
        "aria-invalid": n.question.ariaInvalid,
        "aria-errormessage": n.question.ariaErrormessage
      }, null, 8, Fs),
      h(d, {
        is: "sv-svg-icon",
        iconName: n.question.getItemSmileyIconName(n.item.itemValue),
        size: "auto",
        title: n.item.text
      }, null, 8, ["iconName", "title"])
    ], 38));
  }
}), Os = ["name", "id", "value", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Us = /* @__PURE__ */ y({
  __name: "RatingItemStar",
  props: {
    question: {},
    item: {},
    index: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l("label", {
      key: n.item.value,
      onMousedown: s[1] || (s[1] = (i) => n.question.onMouseDown()),
      class: r(n.question.getItemClass(n.item.itemValue)),
      onMouseover: s[2] || (s[2] = (i) => n.question.onItemMouseIn(n.item)),
      onMouseleave: s[3] || (s[3] = (i) => n.question.onItemMouseOut(n.item))
    }, [
      v("input", {
        type: "radio",
        class: "sv-visuallyhidden",
        name: n.question.questionName,
        id: n.question.getInputId(n.index),
        value: n.item.value,
        disabled: n.question.isDisabledAttr,
        readonly: n.question.isReadOnlyAttr,
        onClick: s[0] || (s[0] = (i) => n.question.setValueFromClick((i == null ? void 0 : i.target).value)),
        "aria-required": n.question.ariaRequired,
        "aria-label": n.question.ariaLabel,
        "aria-invalid": n.question.ariaInvalid,
        "aria-errormessage": n.question.ariaErrormessage
      }, null, 8, Os),
      h(d, {
        is: "sv-svg-icon",
        class: r("sv-star"),
        iconName: n.question.itemStarIcon,
        size: "auto",
        title: n.item.text
      }, null, 8, ["iconName", "title"]),
      h(d, {
        is: "sv-svg-icon",
        class: r("sv-star-2"),
        iconName: n.question.itemStarIconAlt,
        size: "auto",
        title: n.item.text
      }, null, 8, ["iconName", "title"])
    ], 34));
  }
}), Ks = { class: "sd-rating-dropdown-item" }, js = { class: "sd-rating-dropdown-item_text" }, Qs = {
  key: 0,
  class: "sd-rating-dropdown-item_description"
}, Gs = /* @__PURE__ */ y({
  __name: "RatingDropdownItem",
  props: {
    item: {},
    model: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l("div", Ks, [
      v("span", js, H(n.item.title), 1),
      n.item.description ? (o(), l("div", Qs, [
        h(d, {
          is: "survey-string",
          locString: n.item.description
        }, null, 8, ["locString"])
      ])) : m("", !0)
    ]));
  }
});
x.Instance.registerRenderer(
  "rating",
  "dropdown",
  "sv-rating-dropdown"
);
const Js = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "RatingDropdown",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.cssClasses.rootDropdown),
      ref_key: "root",
      ref: n
    }, [
      h(d, {
        is: "sv-dropdown",
        question: s.question
      }, null, 8, ["question"])
    ], 2));
  }
}), Xs = ["name", "value", "id", ".indeterminate", "disabled", "readonly", "role", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], Ys = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "BooleanSwitch",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = (t, a) => {
      e.question.onLabelClick(t, a);
    }, i = (t) => {
      e.question.onSwitchClickModel(t);
    };
    return (t, a) => (o(), l("div", {
      class: r(t.question.cssClasses.root),
      ref_key: "root",
      ref: n,
      onKeydown: a[4] || (a[4] = (p) => t.question.onKeyDownCore(p))
    }, [
      v("label", {
        class: r(t.question.getItemCss())
      }, [
        R(v("input", {
          type: "checkbox",
          name: t.question.name,
          value: t.question.booleanValue ?? "",
          "onUpdate:modelValue": a[0] || (a[0] = (p) => t.question.booleanValue = p),
          class: r(t.question.cssClasses.control),
          id: t.question.inputId,
          ".indeterminate": t.question.isIndeterminate,
          disabled: t.question.isDisabledAttr,
          readonly: t.question.isReadOnlyAttr,
          role: t.question.a11y_input_ariaRole,
          "aria-required": t.question.a11y_input_ariaRequired,
          "aria-label": t.question.a11y_input_ariaLabel,
          "aria-labelledby": t.question.a11y_input_ariaLabelledBy,
          "aria-describedby": t.question.a11y_input_ariaDescribedBy,
          "aria-invalid": t.question.a11y_input_ariaInvalid,
          "aria-errormessage": t.question.a11y_input_ariaErrormessage
        }, null, 42, Xs), [
          [te, t.question.booleanValue]
        ]),
        v("div", {
          class: r(t.question.cssClasses.sliderGhost),
          onClick: a[1] || (a[1] = (p) => s(p, t.question.swapOrder))
        }, [
          v("span", {
            class: r(t.question.getLabelCss(t.question.swapOrder))
          }, [
            h(d, {
              is: "survey-string",
              locString: t.question.locLabelLeft
            }, null, 8, ["locString"])
          ], 2)
        ], 2),
        v("div", {
          class: r(t.question.cssClasses.switch),
          onClick: a[2] || (a[2] = (p) => i(p))
        }, [
          v("span", {
            class: r(t.question.cssClasses.slider)
          }, [
            t.question.cssClasses.sliderText && t.question.isDeterminated ? (o(), l("span", {
              key: 0,
              class: r(t.question.cssClasses.sliderText)
            }, [
              h(d, {
                is: "survey-string",
                locString: t.question.getCheckedLabel()
              }, null, 8, ["locString"])
            ], 2)) : m("", !0)
          ], 2)
        ], 2),
        v("div", {
          class: r(t.question.cssClasses.sliderGhost),
          onClick: a[3] || (a[3] = (p) => s(p, !t.question.swapOrder))
        }, [
          v("span", {
            class: r(t.question.getLabelCss(!t.question.swapOrder))
          }, [
            h(d, {
              is: "survey-string",
              locString: t.question.locLabelRight
            }, null, 8, ["locString"])
          ], 2)
        ], 2)
      ], 2)
    ], 34));
  }
});
x.Instance.registerRenderer(
  "boolean",
  "radio",
  "sv-boolean-radio"
);
const _s = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "BooleanRadio",
  props: {
    question: {}
  },
  setup(u) {
    const e = f(null);
    return T(u, e), (s, i) => (o(), l("div", {
      class: r(s.question.cssClasses.rootRadio),
      ref_key: "root",
      ref: e
    }, [
      v("fieldset", {
        role: "presentation",
        class: r(s.question.cssClasses.radioFieldset)
      }, [
        s.question.swapOrder ? (o(), c(d, {
          is: "sv-boolean-radio-item",
          key: "true",
          question: s.question,
          locText: s.question.locLabelTrue,
          value: !0
        }, null, 8, ["question", "locText"])) : m("", !0),
        (o(), c(d, {
          is: "sv-boolean-radio-item",
          key: "false",
          question: s.question,
          locText: s.question.locLabelFalse,
          value: !1
        }, null, 8, ["question", "locText"])),
        s.question.swapOrder ? m("", !0) : (o(), c(d, {
          is: "sv-boolean-radio-item",
          key: "true",
          question: s.question,
          locText: s.question.locLabelTrue,
          value: !0
        }, null, 8, ["question", "locText"]))
      ], 2)
    ], 2));
  }
}), xs = ["name", "value", "checked", "aria-errormessage", "disabled", "readonly"], en = ["xlink:href"], sn = /* @__PURE__ */ y({
  __name: "BooleanRadioItem",
  props: {
    question: {},
    locText: {},
    value: { type: Boolean }
  },
  setup(u) {
    const e = u, n = (s) => {
      const i = e.question;
      i.booleanValue = s.target.value == "true";
    };
    return (s, i) => (o(), l("div", {
      role: "presentation",
      class: r(s.question.getRadioItemClass(s.question.cssClasses, s.value))
    }, [
      v("label", {
        class: r(s.question.cssClasses.radioLabel)
      }, [
        v("input", {
          type: "radio",
          name: s.question.name,
          value: s.value,
          checked: s.value === s.question.booleanValueRendered,
          "aria-errormessage": s.question.ariaErrormessage,
          disabled: s.question.isDisabledAttr,
          readonly: s.question.isReadOnlyAttr,
          class: r(s.question.cssClasses.itemRadioControl),
          onChange: n
        }, null, 42, xs),
        s.question.cssClasses.materialRadioDecorator ? (o(), l("span", {
          key: 0,
          class: r(s.question.cssClasses.materialRadioDecorator)
        }, [
          s.question.itemSvgIcon ? (o(), l("svg", {
            key: 0,
            class: r(s.question.cssClasses.itemRadioDecorator)
          }, [
            v("use", {
              "xlink:href": s.question.itemSvgIcon
            }, null, 8, en)
          ], 2)) : m("", !0)
        ], 2)) : m("", !0),
        v("span", {
          class: r(s.question.cssClasses.radioControlLabel)
        }, [
          h(d, {
            is: "survey-string",
            locString: s.locText
          }, null, 8, ["locString"])
        ], 2)
      ], 2)
    ], 2));
  }
}), nn = ["name", "value", "id", ".indeterminate", "disabled", "readonly", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], tn = ["xlink:href"], on = /* @__PURE__ */ v("span", { class: "check" }, null, -1), rn = ["id"], ln = ["id"];
x.Instance.registerRenderer(
  "boolean",
  "checkbox",
  "sv-boolean-checkbox"
);
const an = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "BooleanCheckbox",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), l("div", {
      class: r(s.question.cssClasses.rootCheckbox),
      ref_key: "root",
      ref: n
    }, [
      v("div", {
        class: r(s.question.getCheckboxItemCss())
      }, [
        v("label", {
          class: r(s.question.cssClasses.checkboxLabel)
        }, [
          R(v("input", {
            type: "checkbox",
            name: s.question.name,
            value: s.question.booleanValue ?? "",
            "onUpdate:modelValue": i[0] || (i[0] = (t) => s.question.booleanValue = t),
            class: r(s.question.cssClasses.controlCheckbox),
            id: s.question.inputId,
            ".indeterminate": s.question.isIndeterminate,
            disabled: s.question.isDisabledAttr,
            readonly: s.question.isReadOnlyAttr,
            "aria-required": s.question.ariaRequired,
            "aria-label": s.question.ariaLabel,
            "aria-invalid": s.question.ariaInvalid,
            "aria-errormessage": s.question.ariaErrormessage
          }, null, 42, nn), [
            [te, s.question.booleanValue]
          ]),
          v("span", {
            class: r(s.question.cssClasses.checkboxMaterialDecorator)
          }, [
            s.question.svgIcon ? (o(), l("svg", {
              key: 0,
              class: r(s.question.cssClasses.checkboxItemDecorator)
            }, [
              v("use", {
                "xlink:href": s.question.svgIcon
              }, null, 8, tn)
            ], 2)) : m("", !0),
            on
          ], 2),
          s.question.isLabelRendered ? (o(), l("span", {
            key: 0,
            id: s.question.labelRenderedAriaID,
            class: r(s.question.cssClasses.checkboxControlLabel)
          }, [
            s.question.hasTitleActions ? m("", !0) : (o(), c(d, {
              key: 0,
              is: "survey-element-title-content",
              element: s.question,
              css: s.css
            }, null, 8, ["element", "css"])),
            s.question.hasTitleActions ? (o(), c(d, {
              key: 1,
              is: "sv-title-actions",
              element: s.question,
              css: s.css
            }, null, 8, ["element", "css"])) : m("", !0)
          ], 10, rn)) : m("", !0)
        ], 2),
        s.question.canRenderLabelDescription ? (o(), l("div", {
          key: 0,
          class: r(s.question.cssDescription),
          id: s.question.ariaDescriptionId
        }, [
          h(d, {
            is: "survey-string",
            locString: s.question.locDescription
          }, null, 8, ["locString"])
        ], 10, ln)) : m("", !0)
      ], 2)
    ], 2));
  }
}), un = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Multipletext",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null), s = ee(() => e.question.getRows());
    return T(e, n), (i, t) => (o(), l("table", {
      class: r(i.question.getQuestionRootCss()),
      ref_key: "root",
      ref: n
    }, [
      v("tbody", null, [
        (o(!0), l(I, null, S(L(s), (a, p) => (o(), l(I, {
          key: i.question.inputId + "rowkey" + p
        }, [
          a.isVisible ? (o(), l("tr", {
            key: 0,
            class: r(i.question.cssClasses.row)
          }, [
            (o(!0), l(I, null, S(a.cells, (g) => (o(), l("td", {
              key: "item" + g.item.editor.id,
              class: r(g.className)
            }, [
              h(d, {
                is: "survey-multipletext-item",
                question: i.question,
                cell: g
              }, null, 8, ["question", "cell"])
            ], 2))), 128))
          ], 2)) : m("", !0)
        ], 64))), 128))
      ])
    ], 2));
  }
}), dn = { key: 1 }, mn = /* @__PURE__ */ y({
  __name: "MultipletextItem",
  props: {
    question: {},
    cell: {}
  },
  setup(u) {
    const e = u, n = (i) => oe(i);
    V(() => e.cell.item.editor);
    const s = b(() => e.cell.item);
    return (i, t) => i.cell.isErrorsCell ? (o(), c(d, {
      key: 1,
      is: "survey-errors",
      element: s.value.editor
    }, null, 8, ["element"])) : (o(), l("label", {
      key: 0,
      class: r(i.question.getItemLabelCss(s.value))
    }, [
      v("span", {
        class: r(i.question.getItemTitleCss()),
        style: M({
          minWidth: i.question.itemTitleWidth,
          width: i.question.itemTitleWidth
        })
      }, [
        s.value.editor.isRequireTextBeforeTitle || s.value.editor.isRequireTextOnStart ? (o(), l("span", {
          key: 0,
          class: r(i.question.cssClasses.requiredMark)
        }, H(s.value.editor.requiredMark), 3)) : m("", !0),
        h(d, {
          is: "survey-string",
          locString: s.value.locTitle
        }, null, 8, ["locString"]),
        s.value.editor.isRequireTextAfterTitle ? (o(), l("span", dn, " ")) : m("", !0),
        s.value.editor.isRequireTextAfterTitle ? (o(), l("span", {
          key: 2,
          "aria-hidden": "true",
          class: r(i.question.cssClasses.requiredMark)
        }, H(s.value.editor.requiredMark), 3)) : m("", !0)
      ], 6),
      (o(), l("div", {
        key: s.value.editor.id,
        class: r(i.question.getItemCss()),
        onFocusin: t[0] || (t[0] = (a) => s.value.focusIn())
      }, [
        h(d, {
          is: n(s.value.editor),
          question: s.value.editor
        }, null, 8, ["is", "question"])
      ], 34))
    ], 2));
  }
}), pn = { class: "sv-hidden" }, Cn = { key: 0 }, vn = { key: 0 }, cn = ["onClick"], gn = ["data-responsive-title", "onClick"], hn = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Matrix",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null), s = W();
    T(
      e,
      n,
      (t) => {
        s.value = t.visibleRows, t.visibleRowsChangedCallback = () => {
          s.value = t.visibleRows;
        };
      },
      (t) => {
        t.visibleRowsChangedCallback = () => {
        };
      }
    );
    const i = (t, a) => {
      t.value = a.value;
    };
    return (t, a) => (o(), l("div", {
      class: r(t.question.cssClasses.tableWrapper),
      ref_key: "root",
      ref: n
    }, [
      v("fieldset", null, [
        v("legend", pn, H(t.question.locTitle.renderedHtml), 1),
        v("table", {
          class: r(t.question.getTableCss())
        }, [
          t.question.showHeader ? (o(), l("thead", Cn, [
            v("tr", null, [
              t.question.hasRows ? (o(), l("td", vn)) : m("", !0),
              (o(!0), l(I, null, S(t.question.visibleColumns, (p, g) => (o(), l("th", {
                key: g,
                class: r(t.question.cssClasses.headerCell),
                style: M({
                  minWidth: t.question.columnMinWidth,
                  width: t.question.columnMinWidth
                })
              }, [
                h(d, {
                  is: t.question.getColumnHeaderWrapperComponentName(p),
                  componentData: t.question.getColumnHeaderWrapperComponentData(p)
                }, {
                  default: E(() => [
                    h(d, {
                      is: "survey-string",
                      locString: p.locText
                    }, null, 8, ["locString"])
                  ]),
                  _: 2
                }, 1032, ["is", "componentData"])
              ], 6))), 128))
            ])
          ])) : m("", !0),
          v("tbody", null, [
            (o(!0), l(I, null, S(s.value, (p, g) => (o(), l("tr", {
              key: "row_" + p.name + "_" + g,
              class: r(p.rowClasses || void 0)
            }, [
              R(v("td", {
                class: r(p.rowTextClasses),
                style: M({
                  minWidth: t.question.rowTitleWidth,
                  width: t.question.rowTitleWidth
                })
              }, [
                h(d, {
                  is: t.question.getRowHeaderWrapperComponentName(p),
                  componentData: t.question.getRowHeaderWrapperComponentData(p)
                }, {
                  default: E(() => [
                    h(d, {
                      is: "survey-string",
                      locString: p.locText
                    }, null, 8, ["locString"])
                  ]),
                  _: 2
                }, 1032, ["is", "componentData"])
              ], 6), [
                [N, t.question.hasRows]
              ]),
              t.question.hasCellText ? (o(!0), l(I, { key: 0 }, S(t.question.visibleColumns, (C, q) => (o(), l("td", {
                key: q,
                class: r(t.question.getItemClass(p, C)),
                onClick: (B) => i(p, C)
              }, [
                h(d, {
                  is: "survey-string",
                  locString: t.question.getCellDisplayLocText(p.name, C)
                }, null, 8, ["locString"])
              ], 10, cn))), 128)) : m("", !0),
              t.question.hasCellText ? m("", !0) : (o(!0), l(I, { key: 1 }, S(t.question.visibleColumns, (C, q) => (o(), l("td", {
                key: q,
                "data-responsive-title": C.locText.renderedHtml,
                class: r(t.question.cssClasses.cell),
                onClick: (B) => i(p, C)
              }, [
                h(d, {
                  is: t.question.cellComponent,
                  question: t.question,
                  row: p,
                  column: C,
                  columnIndex: q
                }, null, 8, ["is", "question", "row", "column", "columnIndex"])
              ], 10, gn))), 128))
            ], 2))), 128))
          ])
        ], 2)
      ])
    ], 2));
  }
}), yn = ["data-sv-drop-target-matrix-row"], qn = /* @__PURE__ */ y({
  __name: "MatrixRow",
  props: {
    question: {},
    row: {}
  },
  setup(u) {
    const e = u, n = f();
    V(() => e.row);
    const s = F(
      () => e.row,
      (i, t) => {
        t && t.setRootElement(void 0), i.setRootElement(n.value);
      }
    );
    return $(() => {
      e.row.setRootElement(n.value);
    }), P(() => {
      e.row.setRootElement(void 0), s();
    }), (i, t) => i.row.visible ? (o(), l("tr", {
      key: 0,
      "data-sv-drop-target-matrix-row": i.row.row && i.row.row.id,
      onPointerdown: t[0] || (t[0] = (a) => i.question.onPointerDown(a, i.row.row)),
      class: r(i.row.className),
      ref_key: "root",
      ref: n
    }, [
      (o(!0), l(I, null, S(i.row.cells, (a) => (o(), c(d, {
        is: "survey-matrixdropdown-cell",
        cell: a,
        question: i.question,
        key: i.row.id + "_" + a.id
      }, null, 8, ["cell", "question"]))), 128))
    ], 42, yn)) : m("", !0);
  }
}), wn = ["name", "value", "readonly", "disabled", "id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage"], Ln = ["xlink:href"], kn = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "MatrixCell",
  props: {
    question: {},
    row: {},
    column: {},
    columnIndex: {}
  },
  setup(u) {
    return (e, n) => (o(), l("label", {
      onMousedown: n[1] || (n[1] = (s) => e.question.onMouseDown()),
      class: r(e.question.getItemClass(e.row, e.column))
    }, [
      R(v("input", {
        type: "radio",
        class: r(e.question.cssClasses.itemValue),
        name: e.row.fullName,
        "onUpdate:modelValue": n[0] || (n[0] = (s) => e.row.value = s),
        value: e.column.value,
        readonly: e.row.isReadOnlyAttr,
        disabled: e.row.isDisabledAttr,
        id: e.question.inputId + "_" + e.row.name + "_" + e.columnIndex,
        "aria-required": e.question.a11y_input_ariaRequired,
        "aria-label": e.question.getCellAriaLabel(
          e.row.locText.renderedHtml,
          e.column.locText.renderedHtml
        ),
        "aria-invalid": e.question.a11y_input_ariaInvalid,
        "aria-errormessage": e.question.a11y_input_ariaErrormessage
      }, null, 10, wn), [
        [_, e.row.value]
      ]),
      v("span", {
        class: r(e.question.cssClasses.materialDecorator)
      }, [
        e.question.itemSvgIcon ? (o(), l("svg", {
          key: 0,
          class: r(e.question.cssClasses.itemDecorator)
        }, [
          v("use", {
            "xlink:href": e.question.itemSvgIcon
          }, null, 8, Ln)
        ], 2)) : m("", !0)
      ], 2),
      e.question.isMobile ? (o(), l("span", {
        key: 0,
        class: r(e.question.cssClasses.cellResponsiveTitle)
      }, [
        h(d, {
          is: "survey-string",
          locString: e.column.locText
        }, null, 8, ["locString"])
      ], 2)) : m("", !0)
    ], 34));
  }
}), fn = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "MatrixDropdown",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    return T(e, n), (s, i) => (o(), c(d, {
      is: "survey-matrixtable",
      question: s.question,
      ref_key: "root",
      ref: n
    }, null, 8, ["question"]));
  }
}), bn = { key: 0 }, Mn = { key: 1 }, Hn = /* @__PURE__ */ y({
  __name: "MatrixTable",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = b(() => e.question.renderedTable);
    return V(() => n.value), (s, i) => (o(), l("div", {
      style: M({ overflowX: s.question.showHorizontalScroll ? "scroll" : "" }),
      class: r(s.question.cssClasses.tableWrapper)
    }, [
      v("table", {
        class: r(s.question.getTableCss())
      }, [
        n.value.showHeader ? (o(), l("thead", bn, [
          v("tr", null, [
            (o(!0), l(I, null, S(n.value.headerRow.cells, (t) => (o(), l(I, null, [
              t.hasTitle ? (o(), l("th", {
                key: "header_" + t.id,
                class: r(t.className),
                style: M({ minWidth: t.minWidth, width: t.width })
              }, [
                h(d, {
                  is: s.question.getColumnHeaderWrapperComponentName(t),
                  componentData: s.question.getColumnHeaderWrapperComponentData(t)
                }, {
                  default: E(() => [
                    h(d, {
                      is: "survey-string",
                      locString: t.locTitle
                    }, null, 8, ["locString"]),
                    t.column ? (o(), c(d, {
                      key: 0,
                      is: "survey-matrixheaderrequired",
                      column: t.column,
                      question: s.question
                    }, null, 8, ["column", "question"])) : m("", !0)
                  ]),
                  _: 2
                }, 1032, ["is", "componentData"])
              ], 6)) : m("", !0),
              t.hasTitle ? m("", !0) : (o(), l("td", {
                class: r(t.className),
                key: "header_" + t.id,
                style: M({ minWidth: t.minWidth, width: t.width })
              }, null, 6))
            ], 64))), 256))
          ])
        ])) : m("", !0),
        v("tbody", null, [
          (o(!0), l(I, null, S(n.value.renderedRows, (t) => (o(), c(d, {
            key: s.question.inputId + "_" + t.id,
            is: "survey-matrix-row",
            row: t,
            question: s.question
          }, null, 8, ["row", "question"]))), 128))
        ]),
        n.value.showFooter ? (o(), l("tfoot", Mn, [
          v("tr", null, [
            (o(!0), l(I, null, S(n.value.footerRow.cells, (t, a) => (o(), c(d, {
              is: "survey-matrixdropdown-cell",
              cell: t,
              question: s.question,
              key: "footer_" + a
            }, null, 8, ["cell", "question"]))), 128))
          ])
        ])) : m("", !0)
      ], 2)
    ], 6));
  }
}), In = /* @__PURE__ */ v("span", null, " ", -1), Sn = /* @__PURE__ */ y({
  __name: "MatrixHeaderRequired",
  props: {
    question: {},
    column: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.column), (n, s) => n.column.isRenderedRequired ? (o(), l(I, { key: 0 }, [
      In,
      n.column.isRenderedRequired ? (o(), l("span", {
        key: 0,
        class: r(n.question.cssClasses.cellRequiredMark)
      }, H(n.column.requiredMark), 3)) : m("", !0)
    ], 64)) : m("", !0);
  }
}), Vn = ["title", "colspan"], Bn = /* @__PURE__ */ y({
  __name: "MatrixDropdownCellComp",
  props: {
    question: {},
    cell: {}
  },
  setup(u) {
    const e = u, n = f(!1), s = f(), i = () => e.cell.width || e.cell.minWidth ? { width: e.cell.width, minWidth: e.cell.minWidth } : null, t = () => {
      !e.cell.hasQuestion || !e.question || !e.question.survey || (n.value = e.cell.question.isVisible);
    }, a = (C) => oe(C);
    t(), $(() => {
      if (!e.cell.hasQuestion || !e.question || !e.question.survey)
        return;
      e.cell.question.registerPropertyChangedHandlers(["isVisible"], () => {
        t();
      });
      const C = s.value, q = e.cell.question, B = {
        cell: e.cell.cell,
        cellQuestion: q,
        htmlElement: C,
        row: e.cell.row,
        column: e.cell.cell.column
      };
      e.question.survey.matrixAfterCellRender(e.question, B), q && q.afterRenderCore(C);
    });
    const p = b(() => {
      const C = e.cell;
      if (C.hasPanel) {
        const q = C.panel, B = q.survey;
        if (B) {
          const k = B.getElementWrapperComponentName(q);
          if (k)
            return k;
        }
        return "survey-panel";
      }
    }), g = b(() => {
      if (e.cell.hasPanel) {
        const q = e.cell.panel, B = q.survey;
        let k;
        return B && (k = B.getElementWrapperComponentData(q)), {
          componentName: "survey-panel",
          componentData: {
            element: q,
            data: k,
            css: e.question.cssClasses
          }
        };
      }
    });
    return (C, q) => C.cell.isVisible ? (o(), l("td", {
      key: 0,
      class: r(C.cell.className),
      title: C.cell.getTitle(),
      style: M(i()),
      colspan: C.cell.colSpans,
      onFocusin: q[0] || (q[0] = (B) => C.cell.focusIn()),
      ref_key: "root",
      ref: s
    }, [
      C.cell.isErrorsCell ? (o(), c(d, {
        key: 0,
        is: "survey-errors",
        element: C.cell.question
      }, null, 8, ["element"])) : m("", !0),
      C.cell.isDragHandlerCell ? (o(), c(d, {
        key: 1,
        is: "sv-matrix-drag-drop-icon",
        item: { data: { row: C.cell.row, question: C.question } }
      }, null, 8, ["item"])) : m("", !0),
      C.cell.isActionsCell ? (o(), c(d, {
        key: 2,
        is: "sv-action-bar",
        model: C.cell.item.getData(),
        handleClick: !1
      }, null, 8, ["model"])) : m("", !0),
      C.cell.hasPanel ? (o(), c(d, D({
        key: 3,
        is: p.value
      }, g.value), null, 16, ["is"])) : m("", !0),
      C.cell.showResponsiveTitle ? (o(), l("span", {
        key: 4,
        class: r(C.cell.responsiveTitleCss)
      }, [
        h(d, {
          is: "survey-string",
          locString: C.cell.responsiveLocTitle
        }, null, 8, ["locString"]),
        h(d, {
          is: "survey-matrixheaderrequired",
          column: C.cell.column,
          question: C.cell.matrix
        }, null, 8, ["column", "question"])
      ], 2)) : m("", !0),
      C.cell.hasQuestion ? R((o(), l("div", {
        key: 5,
        class: r(C.cell.cellQuestionWrapperClassName)
      }, [
        !C.cell.isChoice && C.cell.question.isDefaultRendering() ? (o(), c(d, {
          key: 0,
          is: C.question.getCellWrapperComponentName(C.cell.cell),
          componentData: C.question.getCellWrapperComponentData(C.cell.cell)
        }, {
          default: E(() => [
            h(d, {
              is: a(C.cell.question),
              question: C.cell.question
            }, null, 8, ["is", "question"])
          ]),
          _: 1
        }, 8, ["is", "componentData"])) : m("", !0),
        !C.cell.isChoice && !C.cell.question.isDefaultRendering() ? (o(), c(d, {
          key: 1,
          is: C.cell.question.getComponentName(),
          question: C.cell.question
        }, null, 8, ["is", "question"])) : m("", !0),
        C.cell.isItemChoice ? (o(), c(d, {
          key: 2,
          is: C.question.getCellWrapperComponentName(C.cell.cell),
          componentData: C.question.getCellWrapperComponentData(C.cell.cell)
        }, {
          default: E(() => [
            C.cell.isRadio ? (o(), c(d, {
              is: "survey-radiogroup-item",
              key: C.cell.item.value,
              question: C.cell.question,
              item: C.cell.item,
              hideLabel: !0
            }, null, 8, ["question", "item"])) : m("", !0),
            C.cell.isCheckbox ? (o(), c(d, {
              is: "survey-checkbox-item",
              key: C.cell.item.value,
              question: C.cell.question,
              item: C.cell.item,
              hideLabel: !0
            }, null, 8, ["question", "item"])) : m("", !0)
          ]),
          _: 1
        }, 8, ["is", "componentData"])) : m("", !0),
        C.cell.isOtherChoice ? (o(), c(d, {
          key: 3,
          is: "survey-other-choice",
          question: C.cell.question
        }, null, 8, ["question"])) : m("", !0)
      ], 2)), [
        [N, n.value]
      ]) : m("", !0),
      C.cell.hasTitle ? (o(), c(d, {
        key: 6,
        is: C.question.getCellWrapperComponentName(C.cell),
        componentData: C.question.getCellWrapperComponentData(C.cell)
      }, {
        default: E(() => [
          C.cell.hasTitle ? (o(), c(d, {
            key: 0,
            is: "survey-string",
            locString: C.cell.locTitle
          }, null, 8, ["locString"])) : m("", !0),
          C.cell.requiredMark ? (o(), l("span", {
            key: 1,
            class: r(C.question.cssClasses.cellRequiredMark)
          }, H(C.cell.requiredMark), 3)) : m("", !0)
        ]),
        _: 1
      }, 8, ["is", "componentData"])) : m("", !0)
    ], 46, Vn)) : m("", !0);
  }
}), Rn = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "MatrixDynamic",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = () => {
      e.question.addRowUI();
    };
    return (i, t) => (o(), l("div", {
      ref_key: "root",
      ref: n
    }, [
      i.question.renderedTable.showAddRowOnTop ? (o(), l("div", {
        key: 0,
        class: r(i.question.cssClasses.footer)
      }, [
        v("button", {
          type: "button",
          class: r(i.question.getAddRowButtonCss()),
          onClick: s
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locAddRowText
          }, null, 8, ["locString"]),
          v("span", {
            class: r(i.question.cssClasses.iconAdd)
          }, null, 2)
        ], 2)
      ], 2)) : m("", !0),
      i.question.renderedTable.showTable ? (o(), c(d, {
        key: 1,
        is: "survey-matrixtable",
        question: i.question
      }, null, 8, ["question"])) : m("", !0),
      i.question.renderedTable.showTable ? m("", !0) : (o(), l("div", {
        key: 2,
        class: r(i.question.cssClasses.noRowsSection)
      }, [
        v("div", {
          class: r(i.question.cssClasses.noRowsText)
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locNoRowsText
          }, null, 8, ["locString"])
        ], 2),
        i.question.renderedTable.showAddRow ? (o(), l("button", {
          key: 0,
          type: "button",
          class: r(i.question.getAddRowButtonCss(!0)),
          onClick: s
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locAddRowText
          }, null, 8, ["locString"]),
          v("span", {
            class: r(i.question.cssClasses.iconAdd)
          }, null, 2)
        ], 2)) : m("", !0)
      ], 2)),
      i.question.renderedTable.showAddRowOnBottom ? (o(), l("div", {
        key: 3,
        class: r(i.question.cssClasses.footer)
      }, [
        v("button", {
          type: "button",
          class: r(i.question.getAddRowButtonCss()),
          onClick: s
        }, [
          h(d, {
            is: "survey-string",
            locString: i.question.locAddRowText
          }, null, 8, ["locString"]),
          v("span", {
            class: r(i.question.cssClasses.iconAdd)
          }, null, 2)
        ], 2)
      ], 2)) : m("", !0)
    ], 512));
  }
});
function ie(u, e = !0) {
  return {
    question: b(() => u.item.data.question),
    row: e ? b(() => u.item.data.row) : void 0
  };
}
const Tn = ["disabled"], Zn = /* @__PURE__ */ y({
  __name: "RemoveButton",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, { question: n, row: s } = ie(e);
    return (i, t) => (o(), l("button", {
      type: "button",
      class: r(L(n).getRemoveRowButtonCss()),
      disabled: L(n).isInputReadOnly,
      onClick: t[0] || (t[0] = () => L(n).removeRowUI(L(s)))
    }, [
      h(d, {
        is: "survey-string",
        locString: L(n).locRemoveRowText
      }, null, 8, ["locString"]),
      v("span", {
        class: r(L(n).cssClasses.iconRemove)
      }, null, 2)
    ], 10, Tn));
  }
}), $n = ["xlink:href"], Dn = /* @__PURE__ */ y({
  __name: "DragDropIcon",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, { question: n } = ie(e, !1);
    return (s, i) => (o(), l("div", null, [
      L(n).iconDragElement ? (o(), l("svg", {
        key: 0,
        class: r(L(n).cssClasses.dragElementDecorator)
      }, [
        v("use", {
          "xlink:href": L(n).iconDragElement
        }, null, 8, $n)
      ], 2)) : (o(), l("span", {
        key: 1,
        class: r(L(n).cssClasses.iconDrag)
      }, null, 2))
    ]));
  }
}), An = ["aria-expanded", "aria-controls"], Nn = /* @__PURE__ */ y({
  __name: "DetailButton",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, { question: n, row: s } = ie(e);
    return (i, t) => (o(), l("button", {
      type: "button",
      class: r(L(n).getDetailPanelButtonCss(L(s))),
      onClick: t[0] || (t[0] = () => L(s).showHideDetailPanelClick()),
      "aria-expanded": L(n).getIsDetailPanelShowing(L(s)) ? "true" : "false",
      "aria-controls": L(n).getIsDetailPanelShowing(L(s)) ? L(s).detailPanelId : null
    }, [
      h(d, {
        is: "sv-svg-icon",
        class: r(L(n).getDetailPanelIconCss(L(s))),
        iconName: L(n).getDetailPanelIconId(L(s)),
        size: "auto"
      }, null, 8, ["class", "iconName"])
    ], 10, An));
  }
}), Pn = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "PanelDynamic",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null), s = he();
    T(
      e,
      n,
      (p) => {
        p.panelCountChangedCallback = () => {
          var g;
          (g = s == null ? void 0 : s.proxy) == null || g.$forceUpdate();
        }, p.currentIndexChangedCallback = () => {
          var g;
          (g = s == null ? void 0 : s.proxy) == null || g.$forceUpdate();
        }, p.renderModeChangedCallback = () => {
          var g;
          (g = s == null ? void 0 : s.proxy) == null || g.$forceUpdate();
        };
      },
      (p) => {
        p.panelCountChangedCallback = void 0, p.currentIndexChangedCallback = void 0, p.renderModeChangedCallback = void 0;
      }
    );
    const i = () => e.question.showLegacyNavigation, t = (p) => {
      const g = e.question.getSurvey();
      if (g) {
        const C = g.getElementWrapperComponentName(p);
        if (C)
          return C;
      }
      return "panel";
    }, a = (p) => {
      const g = e.question.getSurvey();
      let C;
      return g && (C = g.getElementWrapperComponentData(p)), {
        componentName: "survey-panel",
        componentData: {
          element: p,
          data: C
        }
      };
    };
    return (p, g) => (o(), l("div", {
      class: r(p.question.cssClasses.root),
      ref_key: "root",
      ref: n
    }, [
      p.question.hasTabbedMenu ? (o(), l("div", {
        key: 0,
        class: r(p.question.getTabsContainerCss())
      }, [
        h(d, {
          is: "sv-action-bar",
          model: p.question.tabbedMenu
        }, null, 8, ["model"])
      ], 2)) : m("", !0),
      p.question.getShowNoEntriesPlaceholder() ? (o(), l("div", {
        key: 1,
        class: r(p.question.cssClasses.noEntriesPlaceholder)
      }, [
        v("span", null, [
          h(d, {
            is: "survey-string",
            locString: p.question.locNoEntriesText
          }, null, 8, ["locString"])
        ]),
        h(d, {
          is: "sv-paneldynamic-add-btn",
          data: { question: p.question }
        }, null, 8, ["data"])
      ], 2)) : m("", !0),
      !i() && p.question.isProgressTopShowing && p.question.isRangeShowing ? (o(), l("div", {
        key: 2,
        class: r(p.question.cssClasses.progress)
      }, [
        v("div", {
          class: r(p.question.cssClasses.progressBar),
          style: M({ width: p.question.progress }),
          role: "progressbar"
        }, null, 6)
      ], 2)) : m("", !0),
      i() && p.question.isProgressTopShowing ? (o(), c(d, {
        key: 3,
        is: "survey-paneldynamicprogress",
        question: p.question
      }, null, 8, ["question"])) : m("", !0),
      v("div", {
        class: r(p.question.cssClasses.panelsContainer)
      }, [
        (o(!0), l(I, null, S(p.question.renderedPanels, (C, q) => (o(), l(I, {
          key: C.id
        }, [
          v("div", {
            class: r(p.question.getPanelWrapperCss(C))
          }, [
            h(d, D({
              is: t(C)
            }, a(C)), null, 16, ["is"]),
            p.question.canRenderRemovePanelOnRight(C) ? (o(), c(d, {
              key: 0,
              is: "sv-paneldynamic-remove-btn",
              data: { question: p.question, panel: C }
            }, null, 8, ["data"])) : m("", !0)
          ], 2),
          p.question.isRenderModeList && q < p.question.visiblePanelCount - 1 ? (o(), l("hr", {
            class: r(p.question.cssClasses.separator),
            key: "separator" + C.id
          }, null, 2)) : m("", !0)
        ], 64))), 128))
      ], 2),
      i() && p.question.isProgressBottomShowing ? (o(), c(d, {
        key: 4,
        is: "survey-paneldynamicprogress",
        question: p.question
      }, null, 8, ["question"])) : m("", !0),
      i() && p.question.isRenderModeList ? (o(), c(d, {
        key: 5,
        is: "sv-paneldynamic-add-btn",
        data: { question: p.question }
      }, null, 8, ["data"])) : m("", !0),
      p.question.showNavigation ? (o(), c(d, {
        key: 6,
        is: "survey-paneldynamicprogress-v2",
        question: p.question
      }, null, 8, ["question"])) : m("", !0)
    ], 2));
  }
}), En = /* @__PURE__ */ y({
  __name: "PanelDynamicProgress",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = () => e.question.isProgressTopShowing ? e.question.cssClasses.progressTop : e.question.cssClasses.progressBottom;
    return (s, i) => (o(), l("div", {
      class: r(n())
    }, [
      v("div", {
        style: { clear: "both" },
        class: r(n())
      }, [
        v("div", {
          class: r(s.question.cssClasses.progressContainer)
        }, [
          h(d, {
            is: "sv-paneldynamic-prev-btn",
            data: { question: s.question }
          }, null, 8, ["data"]),
          s.question.isRangeShowing ? (o(), l("div", {
            key: 0,
            class: r(s.question.cssClasses.progress)
          }, [
            v("div", {
              class: r(s.question.cssClasses.progressBar),
              style: M({ width: s.question.progress }),
              role: "progressbar"
            }, null, 6)
          ], 2)) : m("", !0),
          h(d, {
            is: "sv-paneldynamic-next-btn",
            data: { question: s.question }
          }, null, 8, ["data"])
        ], 2),
        h(d, {
          is: "sv-paneldynamic-add-btn",
          data: { question: s.question }
        }, null, 8, ["data"]),
        h(d, {
          is: "sv-paneldynamic-progress-text",
          data: { question: s.question }
        }, null, 8, ["data"])
      ], 2)
    ], 2));
  }
}), Wn = /* @__PURE__ */ y({
  __name: "PanelDynamicProgressV2",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => e.question.cssClasses.footer ? (o(), l("div", {
      key: 0,
      class: r(e.question.cssClasses.footer)
    }, [
      v("hr", {
        class: r(e.question.cssClasses.separator)
      }, null, 2),
      e.question.isRangeShowing && e.question.isProgressBottomShowing ? (o(), l("div", {
        key: 0,
        class: r(e.question.cssClasses.progress)
      }, [
        v("div", {
          class: r(e.question.cssClasses.progressBar),
          style: M({ width: e.question.progress }),
          role: "progressbar"
        }, null, 6)
      ], 2)) : m("", !0),
      e.question.footerToolbar.visibleActions.length ? (o(), l("div", {
        key: 1,
        class: r(e.question.cssClasses.footerButtonsContainer)
      }, [
        h(d, {
          is: "sv-action-bar",
          model: e.question.footerToolbar
        }, null, 8, ["model"])
      ], 2)) : m("", !0)
    ], 2)) : m("", !0);
  }
});
function Q(u) {
  return b(
    () => u.item && u.item.data.question || u.data.question
  );
}
const Fn = ["id"], zn = /* @__PURE__ */ y({
  __name: "PaneldynamicAddBtn",
  props: {
    item: {},
    data: {}
  },
  setup(u) {
    const n = Q(u), s = () => {
      n.value.addPanelUI();
    };
    return (i, t) => L(n).canAddPanel ? (o(), l("button", {
      key: 0,
      type: "button",
      id: L(n).addButtonId,
      class: r(L(n).getAddButtonCss()),
      onClick: s
    }, [
      v("span", {
        class: r(L(n).cssClasses.buttonAddText)
      }, [
        h(d, {
          is: "survey-string",
          locString: L(n).locAddPanelText
        }, null, 8, ["locString"])
      ], 2)
    ], 10, Fn)) : m("", !0);
  }
}), On = ["title"], Un = /* @__PURE__ */ y({
  __name: "PaneldynamicNextBtn",
  props: {
    item: {},
    data: {}
  },
  setup(u) {
    const n = Q(u), s = () => {
      n.value.goToNextPanel();
    };
    return (i, t) => (o(), l("div", {
      title: L(n).panelNextText,
      onClick: s,
      class: r(L(n).getNextButtonCss())
    }, [
      h(d, {
        is: "sv-svg-icon",
        iconName: L(n).cssClasses.progressBtnIcon,
        size: "auto"
      }, null, 8, ["iconName"])
    ], 10, On));
  }
}), Kn = ["title"], jn = /* @__PURE__ */ y({
  __name: "PaneldynamicPrevBtn",
  props: {
    item: {},
    data: {}
  },
  setup(u) {
    const n = Q(u), s = () => {
      n.value.goToPrevPanel();
    };
    return (i, t) => (o(), l("div", {
      title: L(n).panelPrevText,
      onClick: s,
      class: r(L(n).getPrevButtonCss())
    }, [
      h(d, {
        is: "sv-svg-icon",
        iconName: L(n).cssClasses.progressBtnIcon,
        size: "auto"
      }, null, 8, ["iconName"])
    ], 10, Kn));
  }
}), Qn = ["id"], Gn = /* @__PURE__ */ y({
  __name: "PaneldynamicRemoveBtn",
  props: {
    item: {},
    data: {}
  },
  setup(u) {
    const e = u, n = Q(e), s = b(
      () => e.item && e.item.data.panel || e.data.panel
    ), i = (a) => n.value.getPanelRemoveButtonId(a), t = (a) => {
      n.value.isInputReadOnly || n.value.removePanelUI(a);
    };
    return (a, p) => (o(), l("button", {
      type: "button",
      id: i(s.value),
      class: r(L(n).getPanelRemoveButtonCss()),
      onClick: p[0] || (p[0] = (g) => t(s.value))
    }, [
      v("span", {
        class: r(L(n).cssClasses.buttonRemoveText)
      }, [
        h(d, {
          is: "survey-string",
          locString: L(n).locRemovePanelText
        }, null, 8, ["locString"])
      ], 2),
      v("span", {
        class: r(L(n).cssClasses.iconRemove)
      }, null, 2)
    ], 10, Qn));
  }
}), Jn = /* @__PURE__ */ y({
  __name: "PaneldynamicProgressText",
  props: {
    item: {},
    data: {}
  },
  setup(u) {
    const n = Q(u);
    return (s, i) => (o(), l("div", {
      class: r(L(n).cssClasses.progressText)
    }, H(L(n).progressText), 3));
  }
}), Xn = ["id"], Yn = /* @__PURE__ */ y({
  __name: "Errors",
  props: {
    element: {},
    location: {}
  },
  setup(u) {
    const e = f();
    return (n, s) => n.element.hasVisibleErrors ? (o(), l("div", {
      key: 0,
      role: "alert",
      "aria-live": "polite",
      class: r(n.element.cssError),
      id: n.element.id + "_errors",
      ref_key: "root",
      ref: e
    }, [
      (o(!0), l(I, null, S(n.element.errors, (i, t) => (o(), c(d, {
        is: n.element.survey.questionErrorComponent,
        element: n.element,
        key: "error_" + t,
        errorKey: "error_" + t,
        error: i,
        cssClasses: n.element.cssClasses
      }, null, 8, ["is", "element", "errorKey", "error", "cssClasses"]))), 128))
    ], 10, Xn)) : m("", !0);
  }
}), _n = { key: 0 }, xn = /* @__PURE__ */ y({
  __name: "QuestionComment",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => e.question.isReadOnlyRenderDiv() ? (o(), l("div", _n, H(e.question.comment), 1)) : (o(), c(d, {
      key: 1,
      is: "sv-text-area",
      model: e.question.commentTextAreaModel
    }, null, 8, ["model"]));
  }
}), et = /* @__PURE__ */ y({
  __name: "TitleElement",
  props: {
    element: {},
    css: {}
  },
  setup(u) {
    const e = (n) => {
      ye(n);
    };
    return (n, s) => n.element.hasTitle ? (o(), c(ve(n.element.titleTagName), {
      key: 0,
      class: r(n.element.cssTitle),
      "aria-label": n.element.titleAriaLabel,
      id: n.element.ariaTitleId,
      tabindex: n.element.titleTabIndex,
      "aria-expanded": n.element.titleAriaExpanded,
      role: n.element.titleAriaRole,
      onKeyup: s[0] || (s[0] = (i) => {
        e(i);
      })
    }, {
      default: E(() => [
        !n.element.isExpanded && n.element.getCssTitleExpandableSvg() ? (o(), c(d, {
          key: 0,
          is: "sv-svg-icon",
          class: r(n.element.getCssTitleExpandableSvg()),
          iconName: "icon-expand-16x16",
          size: "'auto'"
        }, null, 8, ["class"])) : m("", !0),
        n.element.isExpanded && n.element.getCssTitleExpandableSvg() ? (o(), c(d, {
          key: 1,
          is: "sv-svg-icon",
          class: r(n.element.getCssTitleExpandableSvg()),
          iconName: "icon-collapse-16x16",
          size: "'auto'"
        }, null, 8, ["class"])) : m("", !0),
        n.element.hasTitleActions ? m("", !0) : (o(), c(d, {
          key: 2,
          is: "survey-element-title-content",
          element: n.element,
          css: n.css
        }, null, 8, ["element", "css"])),
        n.element.hasTitleActions ? (o(), c(d, {
          key: 3,
          is: "sv-title-actions",
          element: n.element,
          css: n.css
        }, null, 8, ["element", "css"])) : m("", !0)
      ]),
      _: 1
    }, 40, ["class", "aria-label", "id", "tabindex", "aria-expanded", "role"])) : m("", !0);
  }
}), st = { key: 3 }, nt = { key: 5 }, tt = { key: 7 }, ot = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "TitleContent",
  props: {
    element: {},
    css: {}
  },
  setup(u) {
    const e = u;
    return b(
      () => (e.element.isPanel ? e.element.cssClasses.panel : e.element.cssClasses) || {}
    ), (n, s) => (o(), l(I, null, [
      n.element.isTitleRenderedAsString ? (o(), c(d, {
        key: 0,
        is: "survey-string",
        locString: n.element.locTitle
      }, null, 8, ["locString"])) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.isRequireTextOnStart ? (o(), l("span", {
        key: 1,
        class: r(n.element.cssRequiredMark),
        "aria-hidden": !0
      }, H(n.element.requiredMark), 3)) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.no ? (o(), l("span", {
        key: 2,
        style: { position: "static" },
        class: r(n.element.cssTitleNumber),
        "aria-hidden": !0
      }, H(n.element.no), 3)) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.no ? (o(), l("span", st, " ")) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.isRequireTextBeforeTitle ? (o(), l("span", {
        key: 4,
        class: r(n.element.cssRequiredMark),
        "aria-hidden": !0
      }, H(n.element.requiredMark), 3)) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.isRequireTextBeforeTitle ? (o(), l("span", nt, " ")) : m("", !0),
      n.element.isTitleRenderedAsString ? m("", !0) : (o(), c(d, {
        key: 6,
        is: "survey-string",
        locString: n.element.locTitle
      }, null, 8, ["locString"])),
      !n.element.isTitleRenderedAsString && n.element.isRequireTextAfterTitle ? (o(), l("span", tt, " ")) : m("", !0),
      !n.element.isTitleRenderedAsString && n.element.isRequireTextAfterTitle ? (o(), l("span", {
        key: 8,
        class: r(n.element.cssRequiredMark),
        "aria-hidden": !0
      }, H(n.element.requiredMark), 3)) : m("", !0)
    ], 64));
  }
}), it = { class: "sv-title-actions" }, rt = { class: "sv-title-actions__title" }, lt = /* @__PURE__ */ y({
  __name: "TitleActions",
  props: {
    element: {},
    css: {}
  },
  setup(u) {
    const e = u, n = b(() => e.element.getTitleToolbar());
    return (s, i) => (o(), l("div", it, [
      v("span", rt, [
        s.element.isPage ? (o(), c(d, {
          key: 0,
          is: "survey-string",
          locString: s.element.locTitle
        }, null, 8, ["locString"])) : m("", !0),
        s.element.isPage ? m("", !0) : (o(), c(d, {
          key: 1,
          is: "survey-element-title-content",
          element: s.element,
          css: s.css
        }, null, 8, ["element", "css"]))
      ]),
      h(d, {
        is: "sv-action-bar",
        model: n.value
      }, null, 8, ["model"])
    ]));
  }
}), at = (u, e) => {
  const n = u.__vccOpts || u;
  for (const [s, i] of e)
    n[s] = i;
  return n;
}, ut = {}, dt = { class: "sv-brand-info" }, mt = /* @__PURE__ */ Ze('<a class="sv-brand-info__logo" href="https://surveyjs.io/?utm_source=built-in_links&amp;utm_medium=online_survey_tool&amp;utm_campaign=landing_page"><img src="https://surveyjs.io/Content/Images/poweredby.svg"></a><div class="sv-brand-info__text"> Try and see how easy it is to <a href="https://surveyjs.io/create-survey?utm_source=built-in_links&amp;utm_medium=online_survey_tool&amp;utm_campaign=create_survey">create a survey</a></div><div class="sv-brand-info__terms"><a href="https://surveyjs.io/TermsOfUse">Terms of Use &amp; Privacy Statement</a></div>', 3), pt = [
  mt
];
function Ct(u, e) {
  return o(), l("div", dt, pt);
}
const vt = /* @__PURE__ */ at(ut, [["render", Ct]]), ct = /* @__PURE__ */ v("use", null, null, -1), gt = [
  ct
], ht = /* @__PURE__ */ y({
  __name: "SvgIcon",
  props: {
    size: {},
    width: {},
    height: {},
    iconName: {},
    title: {}
  },
  setup(u) {
    const e = u, n = f(), s = () => {
      We(
        e.size,
        e.width,
        e.height,
        e.iconName,
        n.value,
        e.title
      );
    };
    return j(() => {
      s();
    }), $(() => {
      s();
    }), (i, t) => (o(), l("svg", {
      ref_key: "svgIconElement",
      ref: n,
      class: "sv-svg-icon",
      role: "presentation"
    }, gt, 512));
  }
}), yt = /* @__PURE__ */ y({
  __name: "QuestionError",
  props: {
    errorKey: {},
    error: {},
    cssClasses: {},
    element: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", { key: e.errorKey }, [
      v("span", {
        class: r(
          e.cssClasses ? e.cssClasses.error.icon || void 0 : "panel-error-icon"
        ),
        "aria-hidden": "true"
      }, null, 2),
      v("span", {
        class: r(
          e.cssClasses ? e.cssClasses.error.item || void 0 : "panel-error-item"
        )
      }, [
        h(d, {
          is: "survey-string",
          locString: e.error.locText
        }, null, 8, ["locString"])
      ], 2)
    ]));
  }
}), qt = /* @__PURE__ */ y({
  __name: "ActionBar",
  props: {
    model: {},
    container: {},
    handleClick: { type: Boolean, default: !0 }
  },
  setup(u) {
    const e = u, n = f(null), s = (t) => {
      e.handleClick && t.stopPropagation();
    };
    V(() => e.model);
    const i = ee(() => e.model.renderedActions);
    return $(() => {
      e.model.hasActions && e.model.initResponsivityManager(n.value);
    }), P(() => {
      e.model.resetResponsivityManager();
    }), (t, a) => t.model.hasActions ? (o(), l("div", {
      key: 0,
      ref_key: "root",
      ref: n,
      class: r(t.model.getRootCss()),
      onClick: s
    }, [
      (o(!0), l(I, null, S(L(i), (p) => (o(), c(d, {
        is: "sv-action",
        key: p.renderedId,
        item: p
      }, null, 8, ["item"]))), 128))
    ], 2)) : m("", !0);
  }
}), wt = ["id"], Lt = { class: "sv-action__content" }, kt = /* @__PURE__ */ y({
  __name: "Action",
  props: {
    item: {}
  },
  setup(u) {
    const e = f(), n = u, s = b(
      () => n.item.component || "sv-action-bar-item"
    );
    return V(() => n.item), $(() => {
      const i = n.item;
      i.updateModeCallback = (t, a) => {
        i.mode = t, ge(() => {
          a(t, e.value);
        });
      };
    }), P(() => {
      const i = n.item;
      i.updateModeCallback = void 0;
    }), (i, t) => (o(), l("div", {
      class: r(i.item.getActionRootCss()),
      id: i.item.id,
      ref_key: "root",
      ref: e
    }, [
      v("div", Lt, [
        i.item.needSeparator ? (o(), c(d, {
          key: 0,
          is: "sv-action-bar-separator"
        })) : m("", !0),
        h(d, {
          is: s.value,
          item: i.item
        }, null, 8, ["is", "item"])
      ])
    ], 10, wt));
  }
}), U = {
  mounted: function(u, e) {
    const n = Object.assign(
      {
        processEsc: !0
      },
      { ...e.value }
    );
    if (n.disableTabStop) {
      u.tabIndex = -1;
      return;
    }
    n.disableTabStop || (u.tabIndex = 0), u.addEventListener("keyup", (s) => (s.preventDefault(), s.stopPropagation(), ye(s, n), !1)), u.addEventListener("keydown", (s) => {
      Fe(s, n);
    }), u.addEventListener("blur", (s) => {
      ze(s);
    });
  }
}, ft = ["disabled", "title", "aria-checked", "aria-expanded", "role"], bt = {
  inheritAttrs: !1
}, Mt = /* @__PURE__ */ y({
  ...bt,
  __name: "ActionBarItem",
  props: {
    item: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => R((o(), l("button", {
      class: r(n.item.getActionBarItemCss()),
      type: "button",
      onClick: s[0] || (s[0] = (i) => {
        n.item.doAction(i);
      }),
      onKeyup: s[1] || (s[1] = (i) => {
        i.stopPropagation();
      }),
      onMousedown: s[2] || (s[2] = (i) => {
        n.item.doMouseDown(i);
      }),
      onFocus: s[3] || (s[3] = (i) => {
        n.item.doFocus(i);
      }),
      disabled: n.item.disabled,
      title: n.item.tooltip || n.item.title,
      "aria-checked": n.item.ariaChecked,
      "aria-expanded": n.item.ariaExpanded,
      role: n.item.ariaRole
    }, [
      n.item.iconName ? (o(), c(d, {
        key: 0,
        is: "sv-svg-icon",
        class: r(n.item.cssClasses.itemIcon),
        iconName: n.item.iconName,
        size: n.item.iconSize,
        title: n.item.tooltip || n.item.title
      }, null, 8, ["class", "iconName", "size", "title"])) : m("", !0),
      n.item.hasTitle ? (o(), l("span", {
        key: 1,
        class: r(n.item.getActionBarItemTitleCss())
      }, H(n.item.title), 3)) : m("", !0)
    ], 42, ft)), [
      [L(U), { processEsc: !1, disableTabStop: n.item.disableTabStop }]
    ]);
  }
}), Ht = ["disabled", "title", "role"], It = {
  inheritAttrs: !1
}, St = /* @__PURE__ */ y({
  ...It,
  __name: "ActionBarItemDropdown",
  props: {
    item: {}
  },
  setup(u) {
    const e = u;
    let n;
    return V(
      () => e.item,
      (s) => {
        n = new Oe(s);
      },
      () => {
        n.dispose();
      }
    ), (s, i) => (o(), l(I, null, [
      R((o(), l("button", {
        type: "button",
        class: r(s.item.getActionBarItemCss()),
        onClick: i[0] || (i[0] = (t) => {
          s.item.action(s.item, !!t.pointerType);
        }),
        onKeyup: i[1] || (i[1] = (t) => {
          t.stopPropagation();
        }),
        disabled: s.item.disabled,
        title: s.item.tooltip || s.item.title,
        role: s.item.ariaRole
      }, [
        s.item.iconName ? (o(), c(d, {
          key: 0,
          is: "sv-svg-icon",
          class: r(s.item.cssClasses.itemIcon),
          iconName: s.item.iconName,
          size: s.item.iconSize,
          title: s.item.tooltip || s.item.title
        }, null, 8, ["class", "iconName", "size", "title"])) : m("", !0),
        s.item.hasTitle ? (o(), l("span", {
          key: 1,
          class: r(s.item.getActionBarItemTitleCss())
        }, H(s.item.title), 3)) : m("", !0)
      ], 42, Ht)), [
        [L(U), { processEsc: !1, disableTabStop: s.item.disableTabStop }]
      ]),
      h(d, {
        is: "sv-popup",
        model: s.item.popupModel
      }, null, 8, ["model"])
    ], 64));
  }
}), Vt = /* @__PURE__ */ y({
  __name: "ActionBarSeparator",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, n = b(() => e.item && e.item.innerCss);
    return (s, i) => (o(), l("div", {
      class: r(["sv-action-bar-separator", n.value])
    }, null, 2));
  }
}), Bt = ["aria-label", "placeholder", "value"], Rt = ["aria-label"], Tt = ["id"], Zt = /* @__PURE__ */ y({
  __name: "List",
  props: {
    model: {}
  },
  setup(u) {
    const e = u, n = f(null), s = (p) => {
      const g = e.model;
      g.filterString = p.target.value;
    }, i = (p) => {
      const g = e.model;
      g.filterString = p.target.value, e.model.goToItems(p);
    }, t = (p) => {
      e.model.onMouseMove(p);
    }, a = ee(() => e.model.renderedActions);
    return V(() => e.model), $(() => {
      e.model.initListContainerHtmlElement(n.value);
    }), P(() => {
      e.model && (e.model.removeScrollEventListener(), e.model.initListContainerHtmlElement(void 0));
    }), (p, g) => (o(), l("div", {
      class: r(p.model.cssClasses.root),
      ref_key: "listContainerElement",
      ref: n
    }, [
      p.model.showFilter ? (o(), l("div", {
        key: 0,
        class: r(p.model.cssClasses.filter)
      }, [
        v("div", {
          class: r(p.model.cssClasses.filterIcon)
        }, [
          h(d, {
            is: "sv-svg-icon",
            iconName: "icon-search",
            size: "auto"
          })
        ], 2),
        v("input", {
          type: "text",
          class: r(p.model.cssClasses.filterInput),
          "aria-label": p.model.filterStringPlaceholder,
          placeholder: p.model.filterStringPlaceholder,
          value: p.model.filterString,
          onChange: s,
          onKeyup: i
        }, null, 42, Bt),
        p.model.showSearchClearButton && p.model.filterString ? (o(), l("button", {
          key: 0,
          onClick: g[0] || (g[0] = (C) => {
            p.model.onClickSearchClearButton(C);
          }),
          class: r(p.model.cssClasses.searchClearButtonIcon)
        }, [
          h(d, {
            is: "sv-svg-icon",
            iconName: "icon-searchclear",
            size: "auto"
          })
        ], 2)) : m("", !0)
      ], 2)) : m("", !0),
      R(v("div", {
        class: r(p.model.cssClasses.emptyContainer)
      }, [
        v("div", {
          class: r(p.model.cssClasses.emptyText),
          "aria-label": p.model.emptyMessage
        }, H(p.model.emptyMessage), 11, Rt)
      ], 2), [
        [N, p.model.isEmpty]
      ]),
      p.model.renderElements ? R((o(), l("ul", {
        key: 1,
        class: r(p.model.getListClass()),
        role: "listbox",
        id: p.model.elementId,
        onMousedown: g[1] || (g[1] = (C) => {
          C.preventDefault();
        }),
        onMousemove: t,
        onKeydown: g[2] || (g[2] = (C) => {
          p.model.onKeyDown(C);
        })
      }, [
        (o(!0), l(I, null, S(L(a), (C) => (o(), c(d, {
          is: "sv-list-item",
          item: C,
          model: p.model,
          key: C.id
        }, null, 8, ["item", "model"]))), 128))
      ], 42, Tt)), [
        [N, !p.model.isEmpty]
      ]) : m("", !0)
    ], 2));
  }
}), $t = ["aria-selected", "id", "tabindex"], Dt = ["title"], At = /* @__PURE__ */ y({
  __name: "ListItem",
  props: {
    model: {},
    item: {}
  },
  setup(u) {
    const e = u, n = b(() => e.item.elementId), s = (t) => {
      e.model.onItemClick(e.item), t.stopPropagation();
    };
    V(() => e.item);
    const i = b(
      () => e.item.component || e.model.itemComponent
    );
    return $(() => {
      setTimeout(() => {
        e.model.onLastItemRended(e.item);
      });
    }), (t, a) => R((o(), l("li", {
      role: "option",
      "aria-selected": t.model.isItemSelected(t.item),
      key: t.item.id,
      id: n.value,
      onPointerdown: a[2] || (a[2] = (p) => t.model.onPointerDown(p, t.item)),
      class: r(t.model.getItemClass(t.item)),
      onClick: s,
      tabindex: t.item.disableTabStop ? -1 : 0
    }, [
      t.item.needSeparator ? (o(), l("div", {
        key: 0,
        class: r(t.model.cssClasses.itemSeparator)
      }, null, 2)) : m("", !0),
      v("div", {
        style: M(t.model.getItemStyle(t.item)),
        class: r(t.model.cssClasses.itemBody),
        title: t.item.getTooltip(),
        onMouseover: a[0] || (a[0] = (p) => t.model.onItemHover(t.item)),
        onMouseleave: a[1] || (a[1] = (p) => t.model.onItemLeave(t.item))
      }, [
        h(d, {
          is: i.value,
          item: t.item,
          model: t.model
        }, null, 8, ["is", "item", "model"])
      ], 46, Dt)
    ], 42, $t)), [
      [N, t.model.isItemVisible(t.item)],
      [L(U), { processEsc: !1, disableTabStop: t.item.disableTabStop }]
    ]);
  }
}), Nt = /* @__PURE__ */ y({
  __name: "ListItemContent",
  props: {
    model: {},
    item: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l(I, null, [
      n.item.iconName ? (o(), c(d, {
        key: 0,
        is: "sv-svg-icon",
        class: r(n.model.cssClasses.itemIcon),
        iconName: n.item.iconName,
        size: n.item.iconSize
      }, null, 8, ["class", "iconName", "size"])) : m("", !0),
      h(d, {
        is: "survey-string",
        locString: n.item.locTitle
      }, null, 8, ["locString"]),
      n.item.markerIconName ? (o(), c(d, {
        key: 1,
        is: "sv-svg-icon",
        class: r(n.item.cssClasses.itemMarkerIcon),
        iconName: n.item.markerIconName,
        size: "auto"
      }, null, 8, ["class", "iconName"])) : m("", !0)
    ], 64));
  }
}), Pt = /* @__PURE__ */ y({
  __name: "ListItemGroup",
  props: {
    model: {},
    item: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.item), (n, s) => (o(), l(I, null, [
      h(d, {
        is: "sv-list-item-content",
        item: n.item,
        model: n.model
      }, null, 8, ["item", "model"]),
      h(d, {
        is: "sv-popup",
        model: n.item.popupModel
      }, null, 8, ["model"])
    ], 64));
  }
}), Et = /* @__PURE__ */ y({
  __name: "Popup",
  props: {
    model: {}
  },
  setup(u) {
    const e = u, n = W(), s = f(null), i = () => {
      const t = s.value;
      t && n.value.setComponentElement(t);
    };
    return F(
      () => e.model,
      (t) => {
        n.value && n.value.dispose(), n.value = Ue(t), i();
      },
      { immediate: !0 }
    ), V(() => n.value), $(() => {
      i();
    }), P(() => {
      n.value.dispose();
    }), (t, a) => (o(), l("div", {
      ref_key: "root",
      ref: s
    }, [
      h(d, {
        is: "sv-popup-container",
        model: n.value
      }, null, 8, ["model"])
    ], 512));
  }
}), Wt = { class: "sv-popup__body-content" }, Ft = {
  key: 0,
  class: "sv-popup__body-header"
}, zt = { class: "sv-popup__scrolling-content" }, Ot = { class: "sv-popup__content" }, Ut = {
  key: 1,
  class: "sv-popup__body-footer"
}, Kt = /* @__PURE__ */ y({
  __name: "PopupContainer",
  props: {
    model: {}
  },
  setup(u) {
    const e = u, n = (s) => {
      s.stopPropagation();
    };
    return V(() => e.model), j(() => {
      const s = e.model;
      s.isVisible && !s.isPositionSet && e.model.updateOnShowing();
    }), $(() => {
      e.model.isVisible && e.model.updateOnShowing();
    }), (s, i) => R((o(), l("div", {
      tabindex: "-1",
      class: r(["sv-popup", s.model.styleClass]),
      onKeydown: i[0] || (i[0] = (t) => {
        s.model.onKeyDown(t);
      }),
      onClick: i[1] || (i[1] = (t) => {
        s.model.clickOutside(t);
      })
    }, [
      v("div", {
        class: "sv-popup__container",
        style: M({
          left: s.model.left,
          top: s.model.top,
          height: s.model.height,
          width: s.model.width,
          minWidth: s.model.minWidth
        }),
        onClick: n
      }, [
        s.model.showHeader ? (o(), c(d, {
          key: 0,
          is: s.model.popupHeaderTemplate,
          model: s.model
        }, null, 8, ["is", "model"])) : m("", !0),
        v("div", Wt, [
          s.model.title ? (o(), l("div", Ft, H(s.model.title), 1)) : m("", !0),
          v("div", zt, [
            v("div", Ot, [
              h(d, D({
                is: s.model.contentComponentName
              }, s.model.contentComponentData), null, 16, ["is"])
            ])
          ]),
          s.model.showFooter ? (o(), l("div", Ut, [
            h(d, {
              is: "sv-action-bar",
              model: s.model.footerToolbar
            }, null, 8, ["model"])
          ])) : m("", !0)
        ])
      ], 4)
    ], 34)), [
      [N, s.model.isVisible]
    ]);
  }
}), jt = /* @__PURE__ */ y({
  __name: "PopupPointer",
  props: {
    model: {}
  },
  setup(u) {
    return (e, n) => (o(), l("span", {
      class: "sv-popup__pointer",
      style: M({
        left: e.model.pointerTarget.left,
        top: e.model.pointerTarget.top
      })
    }, null, 4));
  }
}), Qt = /* @__PURE__ */ y({
  __name: "Container",
  props: {
    survey: {},
    container: {},
    needRenderWrapper: {}
  },
  setup(u) {
    const e = u, n = b(
      () => e.survey.getContainerContent(e.container)
    );
    return (s, i) => n.value.length > 0 ? (o(), l(I, { key: 0 }, [
      s.needRenderWrapper ? (o(), l("div", {
        key: 0,
        class: r(["sv-components-column", "sv-components-container-" + s.container])
      }, [
        (o(!0), l(I, null, S(n.value, (t) => (o(), c(d, {
          key: t.id,
          is: t.component,
          survey: s.survey,
          container: s.container,
          model: t.data
        }, null, 8, ["is", "survey", "container", "model"]))), 128))
      ], 2)) : (o(!0), l(I, { key: 1 }, S(n.value, (t) => (o(), c(d, {
        key: t.id,
        is: t.component,
        survey: s.survey,
        container: s.container,
        model: t.data
      }, null, 8, ["is", "survey", "container", "model"]))), 128))
    ], 64)) : m("", !0);
  }
}), J = /* @__PURE__ */ y({
  __name: "Progress",
  props: {
    survey: {},
    container: {},
    css: {}
  },
  setup(u) {
    const e = u, n = b(() => e.survey.progressValue + "%"), s = (t) => de.getProgressTextInBarCss(t), i = (t) => de.getProgressTextUnderBarCss(t);
    return (t, a) => (o(), l("div", {
      class: r(t.survey.getProgressCssClasses(t.container))
    }, [
      v("div", {
        class: r(t.survey.css.progressBar),
        style: M({ width: n.value }),
        role: "progressbar",
        "aria-valuemin": "0",
        "aria-valuemax": "100",
        "aria-label": "progress"
      }, [
        v("span", {
          class: r(s(t.survey.css))
        }, H(t.survey.progressText), 3)
      ], 6),
      v("span", {
        class: r(i(t.survey.css))
      }, H(t.survey.progressText), 3)
    ], 2));
  }
}), Gt = ["title"], Jt = ["onClick", "data-page-number"], Xt = ["title"], Yt = ["title"], _t = ["title"], xt = /* @__PURE__ */ y({
  __name: "ProgressButtons",
  props: {
    survey: {},
    model: {},
    container: {}
  },
  setup(u) {
    const e = u, n = f(!1), s = f(!1), i = f(!1), t = f(!0), a = f(), p = b(() => e.survey.css);
    let g = null;
    const C = (q) => {
      let B = a.value;
      B.scrollLeft += (q ? -1 : 1) * 70;
    };
    return $(() => {
      const q = a.value;
      g = new Ke(e.model, q, {
        onResize: (B) => {
          t.value = B, s.value = !B;
        },
        onUpdateScroller: (B) => {
          n.value = B;
        },
        onUpdateSettings: () => {
          t.value = e.model.showItemTitles, i.value = !e.model.showItemTitles;
        },
        container: b(() => e.container)
      });
    }), z(() => {
      g.dispose();
    }), (q, B) => (o(), l("div", {
      class: r(q.model.getRootCss(q.container)),
      style: M({ maxWidth: q.model.progressWidth }),
      role: "progressbar",
      "aria-valuemin": "0",
      "aria-valuemax": "100",
      "aria-label": "progress"
    }, [
      s.value ? (o(), l("div", {
        key: 0,
        class: r(q.survey.css.progressButtonsHeader)
      }, [
        v("div", {
          class: r(q.survey.css.progressButtonsPageTitle),
          title: q.model.headerText
        }, H(q.model.headerText), 11, Gt)
      ], 2)) : m("", !0),
      v("div", {
        class: r(p.value.progressButtonsContainer)
      }, [
        v("div", {
          class: r(q.model.getScrollButtonCss(n.value, !0)),
          onClick: B[0] || (B[0] = (k) => C(!0)),
          role: "button"
        }, null, 2),
        v("div", {
          class: r(p.value.progressButtonsListContainer),
          ref_key: "progressButtonsListContainer",
          ref: a
        }, [
          v("ul", {
            class: r(p.value.progressButtonsList)
          }, [
            (o(!0), l(I, null, S(q.survey.visiblePages, (k, Z) => (o(), l("li", {
              key: "listelement" + Z,
              class: r(q.model.getListElementCss(Z)),
              onClick: (w) => q.model.isListElementClickable(Z) ? q.model.clickListElement(k) : null,
              "data-page-number": q.model.getItemNumber(k)
            }, [
              v("div", {
                class: r(p.value.progressButtonsConnector)
              }, null, 2),
              t.value ? (o(), l("div", {
                key: 0,
                class: r(p.value.progressButtonsPageTitle),
                title: k.renderedNavigationTitle
              }, [
                h(d, {
                  is: "survey-string",
                  locString: k.locNavigationTitle
                }, null, 8, ["locString"])
              ], 10, Xt)) : m("", !0),
              t.value ? (o(), l("div", {
                key: 1,
                class: r(p.value.progressButtonsPageDescription),
                title: k.locNavigationDescription.renderedHtml
              }, H(k.locNavigationDescription.renderedHtml), 11, Yt)) : m("", !0),
              v("div", {
                class: r(p.value.progressButtonsButton)
              }, [
                v("div", {
                  class: r(p.value.progressButtonsButtonBackground)
                }, null, 2),
                v("div", {
                  class: r(p.value.progressButtonsButtonContent)
                }, null, 2),
                v("span", null, H(q.model.getItemNumber(k)), 1)
              ], 2)
            ], 10, Jt))), 128))
          ], 2)
        ], 2),
        v("div", {
          class: r(q.model.getScrollButtonCss(n.value, !1)),
          onClick: B[1] || (B[1] = (k) => C(!1)),
          role: "button"
        }, null, 2)
      ], 2),
      i.value ? (o(), l("div", {
        key: 1,
        class: r(q.survey.css.progressButtonsFooter)
      }, [
        v("div", {
          class: r(q.survey.css.progressButtonsPageTitle),
          title: q.model.footerText
        }, H(q.model.footerText), 11, _t)
      ], 2)) : m("", !0)
    ], 6));
  }
}), eo = /* @__PURE__ */ y({
  __name: "ProgressToc",
  props: {
    survey: {},
    model: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", {
      class: r(e.model.containerCss)
    }, [
      e.model.isMobile ? R((o(), l("div", {
        key: 0,
        onClick: n[0] || (n[0] = //@ts-ignore
        (...s) => e.model.togglePopup && e.model.togglePopup(...s))
      }, [
        h(d, {
          is: "sv-svg-icon",
          iconName: e.model.icon,
          size: 24
        }, null, 8, ["iconName"]),
        h(d, {
          is: "sv-popup",
          model: e.model.popupModel
        }, null, 8, ["model"])
      ])), [
        [L(U)]
      ]) : (o(), c(d, {
        key: 1,
        is: "sv-list",
        model: e.model.listModel
      }, null, 8, ["model"]))
    ], 2));
  }
});
/*!
 * surveyjs - Survey JavaScript library v2.0.2
 * Copyright (c) 2015-2025 Devsoft Baltic OÜ  - http://surveyjs.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
var so = {
  modernbooleancheckchecked: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><polygon points="19,10 14,10 14,5 10,5 10,10 5,10 5,14 10,14 10,19 14,19 14,14 19,14 "></polygon></svg>',
  modernbooleancheckind: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M22,0H2C0.9,0,0,0.9,0,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V2C24,0.9,23.1,0,22,0z M21,18L6,3h15V18z M3,6l15,15H3V6z"></path></svg>',
  modernbooleancheckunchecked: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><rect x="5" y="10" width="14" height="4"></rect></svg>',
  moderncheck: '<svg viewBox="0 0 24 24"><path d="M5,13l2-2l3,3l7-7l2,2l-9,9L5,13z"></path></svg>',
  modernradio: '<svg viewBox="-12 -12 24 24"><circle r="6" cx="0" cy="0"></circle></svg>',
  progressbutton: '<svg viewBox="0 0 10 10"><polygon points="2,2 0,4 5,9 10,4 8,2 5,5 "></polygon></svg>',
  removefile: '<svg viewBox="0 0 16 16"><path d="M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z M11,10l-1,1L8,9l-2,2l-1-1l2-2L5,6l1-1l2,2l2-2l1,1L9,8 L11,10z"></path></svg>',
  timercircle: '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 160 160"><circle cx="80" cy="80" r="70" style="stroke: var(--sd-timer-stroke-background-color); stroke-width: var(--sd-timer-stroke-background-width)" stroke-dasharray="none" stroke-dashoffset="none"></circle><circle cx="80" cy="80" r="70"></circle></svg>',
  "add-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 11H17V13H13V17H11V13H7V11H11V7H13V11ZM23 12C23 18.1 18.1 23 12 23C5.9 23 1 18.1 1 12C1 5.9 5.9 1 12 1C18.1 1 23 5.9 23 12ZM21 12C21 7 17 3 12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12Z"></path></svg>',
  "arrowleft-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15 8.99999H4.4L8.7 13.3L7.3 14.7L0.599998 7.99999L7.3 1.29999L8.7 2.69999L4.4 6.99999H15V8.99999Z"></path></svg>',
  "arrowright-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M1 6.99999H11.6L7.3 2.69999L8.7 1.29999L15.4 7.99999L8.7 14.7L7.3 13.3L11.6 8.99999H1V6.99999Z"></path></svg>',
  "camera-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.01 4H18.4C18.2 4 18.01 3.9 17.9 3.73L16.97 2.34C16.41 1.5 15.48 1 14.47 1H9.54C8.53 1 7.6 1.5 7.04 2.34L6.11 3.73C6 3.9 5.81 4 5.61 4H4C2.35 4 1 5.35 1 7V19C1 20.65 2.35 22 4 22H20C21.65 22 23 20.65 23 19V7C23 5.35 21.65 4 20 4H20.01ZM21.01 19C21.01 19.55 20.56 20 20.01 20H4.01C3.46 20 3.01 19.55 3.01 19V7C3.01 6.45 3.46 6 4.01 6H5.62C6.49 6 7.3 5.56 7.79 4.84L8.72 3.45C8.91 3.17 9.22 3 9.55 3H14.48C14.81 3 15.13 3.17 15.31 3.45L16.24 4.84C16.72 5.56 17.54 6 18.41 6H20.02C20.57 6 21.02 6.45 21.02 7V19H21.01ZM12.01 6C8.7 6 6.01 8.69 6.01 12C6.01 15.31 8.7 18 12.01 18C15.32 18 18.01 15.31 18.01 12C18.01 8.69 15.32 6 12.01 6ZM12.01 16C9.8 16 8.01 14.21 8.01 12C8.01 9.79 9.8 8 12.01 8C14.22 8 16.01 9.79 16.01 12C16.01 14.21 14.22 16 12.01 16ZM13.01 10C13.01 10.55 12.56 11 12.01 11C11.46 11 11.01 11.45 11.01 12C11.01 12.55 10.56 13 10.01 13C9.46 13 9.01 12.55 9.01 12C9.01 10.35 10.36 9 12.01 9C12.56 9 13.01 9.45 13.01 10Z"></path></svg>',
  "camera-32x32": '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M27 6H23.8C23.34 6 22.92 5.77 22.66 5.39L22.25 4.78C21.51 3.66 20.26 3 18.92 3H13.06C11.72 3 10.48 3.67 9.73 4.78L9.32 5.39C9.07 5.77 8.64 6 8.18 6H4.98C2.79 6 1 7.79 1 10V24C1 26.21 2.79 28 5 28H27C29.21 28 31 26.21 31 24V10C31 7.79 29.21 6 27 6ZM29 24C29 25.1 28.1 26 27 26H5C3.9 26 3 25.1 3 24V10C3 8.9 3.9 8 5 8H8.2C9.33 8 10.38 7.44 11 6.5L11.41 5.89C11.78 5.33 12.41 5 13.07 5H18.93C19.6 5 20.22 5.33 20.59 5.89L21 6.5C21.62 7.44 22.68 8 23.8 8H27C28.1 8 29 8.9 29 10V24ZM16 9C12.13 9 9 12.13 9 16C9 19.87 12.13 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21ZM17 13C17 13.55 16.55 14 16 14C14.9 14 14 14.9 14 16C14 16.55 13.55 17 13 17C12.45 17 12 16.55 12 16C12 13.79 13.79 12 16 12C16.55 12 17 12.45 17 13Z"></path></svg>',
  "cancel-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.6 8.6L16.4 2.4C16 2 15.5 1.8 15 1.8C14.5 1.8 14 2 13.6 2.4L1.40005 14.6C0.600049 15.4 0.600049 16.6 1.40005 17.4L6.00005 22H12L22.6 11.4C23.3 10.6 23.3 9.3 22.6 8.6ZM11.1 20H6.80005L2.80005 16L6.20005 12.6L12.4 18.8L11.1 20ZM13.8 17.4L7.60005 11.2L15 3.8L21.2 10L13.8 17.4ZM16 20H23V22H14L16 20Z"></path></svg>',
  "check-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.003 14.413L0.292999 9.70303L1.703 8.29303L5.003 11.583L14.293 2.29303L15.703 3.70303L5.003 14.413Z"></path></svg>',
  "check-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 20.1L1 12L3.1 9.9L9 15.9L20.9 4L23 6.1L9 20.1Z"></path></svg>',
  "chevrondown-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 15L17 10H7L12 15Z"></path></svg>',
  "chevronright-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M5.64648 12.6465L6.34648 13.3465L11.7465 8.04648L6.34648 2.64648L5.64648 3.34648L10.2465 8.04648L5.64648 12.6465Z"></path></svg>',
  "clear-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.35 3.34999L12.65 2.64999L8.05002 7.24999L3.35002 2.64999L2.65002 3.34999L7.25002 8.04999L2.65002 12.65L3.35002 13.35L8.05002 8.74999L12.65 13.35L13.35 12.65L8.75002 8.04999L13.35 3.34999Z"></path></svg>',
  "clear-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.6 8.6L16.4 2.4C16 2 15.5 1.8 15 1.8C14.5 1.8 14 2 13.6 2.4L1.40005 14.6C0.600049 15.4 0.600049 16.6 1.40005 17.4L6.00005 22H12L22.6 11.4C23.3 10.6 23.3 9.3 22.6 8.6ZM11.1 20H6.80005L2.80005 16L6.20005 12.6L12.4 18.8L11.1 20ZM13.8 17.4L7.60005 11.2L15 3.8L21.2 10L13.8 17.4ZM16 20H23V22H14L16 20Z"></path></svg>',
  "close-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M9.43 8.0025L13.7 3.7225C14.09 3.3325 14.09 2.6925 13.7 2.2925C13.31 1.9025 12.67 1.9025 12.27 2.2925L7.99 6.5725L3.72 2.3025C3.33 1.9025 2.69 1.9025 2.3 2.3025C1.9 2.6925 1.9 3.3325 2.3 3.7225L6.58 8.0025L2.3 12.2825C1.91 12.6725 1.91 13.3125 2.3 13.7125C2.69 14.1025 3.33 14.1025 3.73 13.7125L8.01 9.4325L12.29 13.7125C12.68 14.1025 13.32 14.1025 13.72 13.7125C14.11 13.3225 14.11 12.6825 13.72 12.2825L9.44 8.0025H9.43Z"></path></svg>',
  "close-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.4101 12L20.7001 4.71C21.0901 4.32 21.0901 3.69 20.7001 3.3C20.3101 2.91 19.6801 2.91 19.2901 3.3L12.0001 10.59L4.71006 3.29C4.32006 2.9 3.68006 2.9 3.29006 3.29C2.90006 3.68 2.90006 4.32 3.29006 4.71L10.5801 12L3.29006 19.29C2.90006 19.68 2.90006 20.31 3.29006 20.7C3.49006 20.9 3.74006 20.99 4.00006 20.99C4.26006 20.99 4.51006 20.89 4.71006 20.7L12.0001 13.41L19.2901 20.7C19.4901 20.9 19.7401 20.99 20.0001 20.99C20.2601 20.99 20.5101 20.89 20.7101 20.7C21.1001 20.31 21.1001 19.68 20.7101 19.29L13.4201 12H13.4101Z"></path></svg>',
  "collapse-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 6L3 5L8 10L13 5L14 6L8 12L2 6Z"></path></svg>',
  "collapsedetails-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 7H3V9H13V7Z"></path></svg>',
  "delete-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 4H20H16V2C16 0.9 15.1 0 14 0H10C8.9 0 8 0.9 8 2V4H4H2V6H4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V6H22V4ZM10 2H14V4H10V2ZM18 20H6V6H8H16H18V20ZM14 8H16V18H14V8ZM11 8H13V18H11V8ZM8 8H10V18H8V8Z"></path></svg>',
  "drag-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13 6C13 4.9 13.9 4 15 4C16.1 4 17 4.9 17 6C17 7.1 16.1 8 15 8C13.9 8 13 7.1 13 6ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16ZM9 16C7.9 16 7 16.9 7 18C7 19.1 7.9 20 9 20C10.1 20 11 19.1 11 18C11 16.9 10.1 16 9 16Z"></path></svg>',
  "draghorizontal-24x16": '<svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg"><path d="M18 9C19.1 9 20 9.9 20 11C20 12.1 19.1 13 18 13C16.9 13 16 12.1 16 11C16 9.9 16.9 9 18 9ZM20 5C20 3.9 19.1 3 18 3C16.9 3 16 3.9 16 5C16 6.1 16.9 7 18 7C19.1 7 20 6.1 20 5ZM14 11C14 9.9 13.1 9 12 9C10.9 9 10 9.9 10 11C10 12.1 10.9 13 12 13C13.1 13 14 12.1 14 11ZM14 5C14 3.9 13.1 3 12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5ZM8 11C8 9.9 7.1 9 6 9C4.9 9 4 9.9 4 11C4 12.1 4.9 13 6 13C7.1 13 8 12.1 8 11ZM8 5C8 3.9 7.1 3 6 3C4.9 3 4 3.9 4 5C4 6.1 4.9 7 6 7C7.1 7 8 6.1 8 5Z"></path></svg>',
  "expand-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6 14L5 13L10 8L5 3L6 2L12 8L6 14Z"></path></svg>',
  "expanddetails-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 7H9V3H7V7H3V9H7V13H9V9H13V7Z"></path></svg>',
  "file-72x72": '<svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path d="M62.83 12.83L53.17 3.17C52.7982 2.79866 52.357 2.50421 51.8714 2.30346C51.3858 2.1027 50.8654 1.99959 50.34 2H14C12.4087 2 10.8826 2.63214 9.75735 3.75736C8.63214 4.88258 8 6.4087 8 8V64C8 65.5913 8.63214 67.1174 9.75735 68.2426C10.8826 69.3679 12.4087 70 14 70H58C59.5913 70 61.1174 69.3679 62.2426 68.2426C63.3679 67.1174 64 65.5913 64 64V15.66C64.0004 15.1346 63.8973 14.6142 63.6965 14.1286C63.4958 13.643 63.2013 13.2018 62.83 12.83ZM52 4.83L61.17 14H56C54.9391 14 53.9217 13.5786 53.1716 12.8284C52.4214 12.0783 52 11.0609 52 10V4.83ZM62 64C62 65.0609 61.5786 66.0783 60.8284 66.8284C60.0783 67.5786 59.0609 68 58 68H14C12.9391 68 11.9217 67.5786 11.1716 66.8284C10.4214 66.0783 10 65.0609 10 64V8C10 6.93914 10.4214 5.92172 11.1716 5.17157C11.9217 4.42143 12.9391 4 14 4H50V10C50 11.5913 50.6321 13.1174 51.7574 14.2426C52.8826 15.3679 54.4087 16 56 16H62V64ZM22 26H50V28H22V26ZM22 32H50V34H22V32ZM22 38H50V40H22V38ZM22 44H50V46H22V44Z"></path></svg>',
  "flip-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 12.0037C23 14.2445 21.7794 16.3052 19.5684 17.8257C19.3984 17.9458 19.1983 18.0058 19.0082 18.0058C18.688 18.0058 18.3779 17.8557 18.1778 17.5756C17.8677 17.1155 17.9777 16.4953 18.4379 16.1852C20.0887 15.0448 21.0091 13.5643 21.0091 12.0138C21.0091 8.70262 16.9673 6.01171 12.005 6.01171C11.4948 6.01171 10.9945 6.04172 10.5043 6.09173L11.7149 7.30215C12.105 7.69228 12.105 8.32249 11.7149 8.71263C11.5148 8.9127 11.2647 9.00273 11.0045 9.00273C10.7444 9.00273 10.4943 8.90269 10.2942 8.71263L6.58254 5.00136L10.2842 1.2901C10.6744 0.899964 11.3047 0.899964 11.6949 1.2901C12.085 1.68023 12.085 2.31045 11.6949 2.70058L10.3042 4.09105C10.8545 4.03103 11.4147 4.00102 11.985 4.00102C18.0578 4.00102 22.99 7.59225 22.99 12.0037H23ZM12.2851 15.2949C11.895 15.685 11.895 16.3152 12.2851 16.7054L13.4957 17.9158C13.0055 17.9758 12.4952 17.9958 11.995 17.9958C7.03274 17.9958 2.99091 15.3049 2.99091 11.9937C2.99091 10.4332 3.90132 8.95271 5.56207 7.82232C6.02228 7.51222 6.13233 6.89201 5.82219 6.43185C5.51205 5.97169 4.89177 5.86166 4.43156 6.17176C2.22055 7.69228 1 9.76299 1 11.9937C1 16.4052 5.93224 19.9965 12.005 19.9965C12.5753 19.9965 13.1355 19.9665 13.6858 19.9064L12.2951 21.2969C11.905 21.6871 11.905 22.3173 12.2951 22.7074C12.4952 22.9075 12.7453 22.9975 13.0055 22.9975C13.2656 22.9975 13.5157 22.8975 13.7158 22.7074L17.4275 18.9961L13.7158 15.2849C13.3256 14.8947 12.6953 14.8947 12.3051 15.2849L12.2851 15.2949Z"></path></svg>',
  "folder-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.93 9H21V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H10L8 3H4C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5L2 21H21L23.89 11.63C23.9916 11.3244 24.0179 10.9988 23.9667 10.6809C23.9155 10.363 23.7882 10.0621 23.5958 9.80392C23.4034 9.54571 23.1514 9.33779 22.8614 9.19782C22.5714 9.05786 22.2519 8.99 21.93 9ZM4 5H7.17L8.59 6.41L9.17 7H19V9H6L4 15V5ZM22 11L19.54 19H4.77L7.44 11H22Z"></path></svg>',
  "fullsize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 13H4C2.9 13 2 12.1 2 11V5C2 3.9 2.9 3 4 3H12C13.1 3 14 3.9 14 5V11C14 12.1 13.1 13 12 13ZM4 5V11H12V5H4Z"></path></svg>',
  "image-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M36 8H12C9.79 8 8 9.79 8 12V36C8 38.21 9.79 40 12 40H36C38.21 40 40 38.21 40 36V12C40 9.79 38.21 8 36 8ZM38 36C38 37.1 37.1 38 36 38H12C10.9 38 10 37.1 10 36V12C10 10.9 10.9 10 12 10H36C37.1 10 38 10.9 38 12V36ZM14 17C14 15.34 15.34 14 17 14C18.66 14 20 15.34 20 17C20 18.66 18.66 20 17 20C15.34 20 14 18.66 14 17ZM27 24L36 36H12L19 27L23 29L27 24Z"></path></svg>',
  "loading-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_19679_369428)"><path opacity="0.1" d="M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z" fill="black" fill-opacity="0.91"></path><path d="M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z"></path></g><defs><clipPath id="clip0_19679_369428"><rect width="32" height="32" fill="white" transform="translate(8 8)"></rect></clipPath></defs></svg>',
  "maximize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.71 10.71L4.42 13H6.01C6.56 13 7.01 13.45 7.01 14C7.01 14.55 6.56 15 6.01 15H2C1.45 15 1 14.55 1 14V10C1 9.45 1.45 9 2 9C2.55 9 3 9.45 3 10V11.59L5.29 9.3C5.68 8.91 6.31 8.91 6.7 9.3C7.09 9.69 7.09 10.32 6.7 10.71H6.71ZM14 1H10C9.45 1 9 1.45 9 2C9 2.55 9.45 3 10 3H11.59L9.3 5.29C8.91 5.68 8.91 6.31 9.3 6.7C9.5 6.9 9.75 6.99 10.01 6.99C10.27 6.99 10.52 6.89 10.72 6.7L13.01 4.41V6C13.01 6.55 13.46 7 14.01 7C14.56 7 15.01 6.55 15.01 6V2C15.01 1.45 14.56 1 14.01 1H14Z"></path></svg>',
  "minimize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 9H3C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7H13C13.55 7 14 7.45 14 8C14 8.55 13.55 9 13 9Z"></path></svg>',
  "more-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 12C6 13.1 5.1 14 4 14C2.9 14 2 13.1 2 12C2 10.9 2.9 10 4 10C5.1 10 6 10.9 6 12ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM20 10C18.9 10 18 10.9 18 12C18 13.1 18.9 14 20 14C21.1 14 22 13.1 22 12C22 10.9 21.1 10 20 10Z"></path></svg>',
  "navmenu-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H2V5H16V7ZM2 11V13H22V11H2ZM2 19H10V17H2V19Z"></path></svg>',
  "noimage-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M14 17.01C14 16.4167 14.1759 15.8366 14.5056 15.3433C14.8352 14.8499 15.3038 14.4654 15.8519 14.2384C16.4001 14.0113 17.0033 13.9519 17.5853 14.0676C18.1672 14.1834 18.7018 14.4691 19.1213 14.8887C19.5409 15.3082 19.8266 15.8428 19.9424 16.4247C20.0581 17.0067 19.9987 17.6099 19.7716 18.1581C19.5446 18.7062 19.1601 19.1748 18.6667 19.5044C18.1734 19.8341 17.5933 20.01 17 20.01C16.2044 20.01 15.4413 19.6939 14.8787 19.1313C14.3161 18.5687 14 17.8056 14 17.01ZM27.09 24.14L20 36.01H36L27.09 24.14ZM36.72 8.14L35.57 10.01H36C36.5304 10.01 37.0391 10.2207 37.4142 10.5958C37.7893 10.9709 38 11.4796 38 12.01V36.01C38 36.5404 37.7893 37.0491 37.4142 37.4242C37.0391 37.7993 36.5304 38.01 36 38.01H18.77L17.57 40.01H36C37.0609 40.01 38.0783 39.5886 38.8284 38.8384C39.5786 38.0883 40 37.0709 40 36.01V12.01C39.9966 11.0765 39.6668 10.1737 39.0678 9.45778C38.4688 8.74188 37.6382 8.25802 36.72 8.09V8.14ZM36.86 4.5L12.86 44.5L11.14 43.5L13.23 40.01H12C10.9391 40.01 9.92172 39.5886 9.17157 38.8384C8.42143 38.0883 8 37.0709 8 36.01V12.01C8 10.9491 8.42143 9.93172 9.17157 9.18157C9.92172 8.43143 10.9391 8.01 12 8.01H32.43L35.14 3.5L36.86 4.5ZM14.43 38.01L15.63 36.01H12L19 27.01L20.56 27.8L31.23 10.01H12C11.4696 10.01 10.9609 10.2207 10.5858 10.5958C10.2107 10.9709 10 11.4796 10 12.01V36.01C10 36.5404 10.2107 37.0491 10.5858 37.4242C10.9609 37.7993 11.4696 38.01 12 38.01H14.43Z"></path></svg>',
  "ranking-arrows": '<svg viewBox="0 0 10 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 5L5 0L0 5H4V9H6V5H10Z"></path><path d="M6 19V15H4V19H0L5 24L10 19H6Z"></path></svg>',
  "rankingundefined-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 7H3V9H13V7Z"></path></svg>',
  "rating-star-2": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z" fill="none" stroke-width="2"></path><path d="M24.3981 33.1305L24 32.9206L23.6019 33.1305L15.8715 37.2059L17.3542 28.5663L17.43 28.1246L17.1095 27.8113L10.83 21.6746L19.4965 20.4049L19.9405 20.3399L20.1387 19.9373L24 12.0936L27.8613 19.9373L28.0595 20.3399L28.5035 20.4049L37.17 21.6746L30.8905 27.8113L30.57 28.1246L30.6458 28.5663L32.1285 37.2059L24.3981 33.1305Z" stroke-width="1.70746"></path></svg>',
  "rating-star-small-2": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z" fill="none" stroke-width="2"></path><path d="M12 15.9472L8.58001 17.7572L9.23001 13.9272L6.45001 11.2072L10.29 10.6472L12 7.17725L13.71 10.6472L17.55 11.2072L14.77 13.9272L15.42 17.7572L12 15.9472Z"></path></svg>',
  "rating-star-small": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z"></path></g></svg>',
  "rating-star": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z"></path></g></svg>',
  "reorder-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M17 5L12 0L7 5H11V9H13V5H17Z"></path><path d="M13 19V15H11V19H7L12 24L17 19H13Z"></path></svg>',
  "restoredown-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15 6C15 6.55 14.55 7 14 7H10C9.45 7 9 6.55 9 6V2C9 1.45 9.45 1 10 1C10.55 1 11 1.45 11 2V3.59L13.29 1.29C13.49 1.09 13.74 1 14 1C14.26 1 14.51 1.1 14.71 1.29C15.1 1.68 15.1 2.31 14.71 2.7L12.42 4.99H14.01C14.56 4.99 15.01 5.44 15.01 5.99L15 6ZM6 9H2C1.45 9 0.999998 9.45 0.999998 10C0.999998 10.55 1.45 11 2 11H3.59L1.29 13.29C0.899998 13.68 0.899998 14.31 1.29 14.7C1.68 15.09 2.31 15.09 2.7 14.7L4.99 12.41V14C4.99 14.55 5.44 15 5.99 15C6.54 15 6.99 14.55 6.99 14V10C6.99 9.45 6.54 9 5.99 9H6Z"></path></svg>',
  "search-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 2C9.6 2 6 5.6 6 10C6 11.8 6.6 13.5 7.7 14.9L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.5 21.9 2.7 22 3 22C3.3 22 3.5 21.9 3.7 21.7L9.1 16.3C10.5 17.4 12.2 18 14 18C18.4 18 22 14.4 22 10C22 5.6 18.4 2 14 2ZM14 16C10.7 16 8 13.3 8 10C8 6.7 10.7 4 14 4C17.3 4 20 6.7 20 10C20 13.3 17.3 16 14 16Z"></path></svg>',
  "smiley-rate1-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 4.9938C4 4.44362 4.45 3.99348 5 3.99348H6.59L5.3 2.70306C4.91 2.31293 4.91 1.68272 5.3 1.2926C5.69 0.902468 6.32 0.902468 6.71 1.2926L9.71 4.29357C9.8 4.3836 9.88 4.49364 9.93 4.62368C10.03 4.86376 10.03 5.14385 9.93 5.38393C9.88 5.50397 9.81 5.614 9.71 5.71404L6.71 8.71501C6.51 8.91508 6.26 9.00511 6 9.00511C5.74 9.00511 5.49 8.90508 5.29 8.71501C4.9 8.32489 4.9 7.69468 5.29 7.30456L6.58 6.01413H4.99C4.44 6.01413 3.99 5.56399 3.99 5.01381L4 4.9938ZM14.08 5.37393C14.13 5.49397 14.2 5.604 14.3 5.70403L17.3 8.70501C17.5 8.90508 17.75 8.99511 18.01 8.99511C18.27 8.99511 18.52 8.89507 18.72 8.70501C19.11 8.31488 19.11 7.68468 18.72 7.29455L17.43 6.00413H19.02C19.57 6.00413 20.02 5.55399 20.02 5.00381C20.02 4.45363 19.57 4.00348 19.02 4.00348H17.43L18.72 2.71306C19.11 2.32293 19.11 1.69273 18.72 1.3026C18.33 0.912471 17.7 0.912471 17.31 1.3026L14.31 4.30358C14.22 4.39361 14.14 4.50364 14.09 4.63368C13.99 4.87376 13.99 5.15385 14.09 5.39393L14.08 5.37393ZM22 14.9971V20.999C22 22.6496 20.65 24 19 24H5C3.35 24 2 22.6496 2 20.999V14.9971C2 13.3465 3.35 11.9961 5 11.9961H19C20.65 11.9961 22 13.3465 22 14.9971ZM19 13.9967H16V16.9977H20V14.9971C20 14.4469 19.55 13.9967 19 13.9967ZM14 16.9977V13.9967H10V16.9977H14ZM10 18.9984V21.9993H14V18.9984H10ZM4 14.9971V16.9977H8V13.9967H5C4.45 13.9967 4 14.4469 4 14.9971ZM5 21.9993H8V18.9984H4V20.999C4 21.5492 4.45 21.9993 5 21.9993ZM20 20.999V18.9984H16V21.9993H19C19.55 21.9993 20 21.5492 20 20.999Z"></path></svg>',
  "smiley-rate10-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 23C6.85721 23 1.15412 19.9621 0.0134987 13.1669C-0.0765501 12.6272 0.293651 12.1076 0.833944 12.0177C1.38424 11.9277 1.89452 12.2975 1.98457 12.8371C2.92508 18.4732 7.69767 20.9914 12 20.9914C16.3023 20.9914 21.0749 18.4732 22.0154 12.8371C22.1055 12.2975 22.6158 11.9277 23.1661 12.0177C23.7063 12.1076 24.0765 12.6272 23.9865 13.1669C22.8559 19.9521 17.1428 23 11.99 23H12.01ZM21.165 6.15177C22.3056 5.01257 22.3056 3.16386 21.165 2.02465L21.0049 1.85477C19.9143 0.765533 18.1633 0.725561 17.0227 1.71487C15.8821 0.715568 14.1312 0.765533 13.0406 1.85477L12.8705 2.01466C11.7299 3.15386 11.7299 5.00257 12.8705 6.14178L17.0227 10.2889L21.175 6.14178L21.165 6.15177ZM15.742 3.27378L17.0127 4.54289L18.2834 3.27378C18.6436 2.91403 19.2239 2.91403 19.5841 3.27378L19.7442 3.43367C20.1044 3.79342 20.1044 4.37301 19.7442 4.73276L17.0127 7.46086L14.2812 4.73276C13.921 4.37301 13.921 3.79342 14.2812 3.43367L14.4413 3.27378C14.6214 3.09391 14.8515 3.00397 15.0917 3.00397C15.3318 3.00397 15.5619 3.09391 15.742 3.27378ZM11.1595 6.15177C12.3002 5.01257 12.3002 3.16386 11.1595 2.02465L10.9995 1.85477C9.90886 0.765533 8.15792 0.725561 7.0173 1.71487C5.87668 0.715568 4.12573 0.765533 3.03514 1.85477L2.86505 2.01466C1.72443 3.15386 1.72443 5.00257 2.86505 6.14178L7.0173 10.2889L11.1695 6.14178L11.1595 6.15177ZM5.7366 3.27378L7.00729 4.54289L8.27798 3.27378C8.63818 2.91403 9.21849 2.91403 9.57869 3.27378L9.73877 3.43367C10.099 3.79342 10.099 4.37301 9.73877 4.73276L7.00729 7.46086L4.27581 4.73276C3.91562 4.37301 3.91562 3.79342 4.27581 3.43367L4.4359 3.27378C4.61599 3.09391 4.84612 3.00397 5.08625 3.00397C5.32638 3.00397 5.5565 3.09391 5.7366 3.27378Z"></path></svg>',
  "smiley-rate2-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_15894_140103)"><path d="M4.88291 4.51001C4.47291 4.51001 4.08291 4.25001 3.94291 3.84001C3.76291 3.32001 4.03291 2.75001 4.55291 2.57001L8.32291 1.25001C8.84291 1.06001 9.41291 1.34001 9.59291 1.86001C9.77291 2.38001 9.50291 2.95001 8.98291 3.13001L5.20291 4.45001C5.09291 4.49001 4.98291 4.51001 4.87291 4.51001H4.88291ZM19.8129 3.89001C20.0229 3.38001 19.7729 2.79001 19.2629 2.59001L15.5529 1.07001C15.0429 0.860007 14.4529 1.11001 14.2529 1.62001C14.0429 2.13001 14.2929 2.72001 14.8029 2.92001L18.5029 4.43001C18.6229 4.48001 18.7529 4.50001 18.8829 4.50001C19.2729 4.50001 19.6529 4.27001 19.8129 3.88001V3.89001ZM3.50291 6.00001C2.64291 6.37001 1.79291 6.88001 1.00291 7.48001C0.79291 7.64001 0.64291 7.87001 0.59291 8.14001C0.48291 8.73001 0.87291 9.29001 1.45291 9.40001C2.04291 9.51001 2.60291 9.12001 2.71291 8.54001C2.87291 7.69001 3.12291 6.83001 3.50291 5.99001V6.00001ZM21.0429 8.55001C21.6029 10.48 24.2429 8.84001 22.7529 7.48001C21.9629 6.88001 21.1129 6.37001 20.2529 6.00001C20.6329 6.84001 20.8829 7.70001 21.0429 8.55001ZM21.5729 13.2C21.2529 14.2 22.5429 15.09 23.3629 14.39C23.8529 14 23.9229 13.29 23.5429 12.81C21.7429 10.67 22.1329 10.55 21.5829 13.2H21.5729ZM1.75291 11C1.22291 11.79 -0.14709 12.64 0.0129102 13.75C0.15291 14.36 0.75291 14.74 1.35291 14.6C2.98291 14.1 1.80291 12.22 1.75291 11ZM19.8829 17C19.8829 13.14 16.2929 10 11.8829 10C7.47291 10 3.88291 13.14 3.88291 17C3.88291 20.86 7.47291 24 11.8829 24C16.2929 24 19.8829 20.86 19.8829 17ZM17.8829 17C17.8829 19.76 15.1929 22 11.8829 22C8.57291 22 5.88291 19.76 5.88291 17C5.88291 14.24 8.57291 12 11.8829 12C15.1929 12 17.8829 14.24 17.8829 17Z"></path></g><defs><clipPath id="clip0_15894_140103"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>',
  "smiley-rate3-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.01915 7C6.46961 7 6.01998 6.55 6.01998 6V2C6.01998 1.45 6.46961 1 7.01915 1C7.56869 1 8.01832 1.45 8.01832 2V6C8.01832 6.55 7.56869 7 7.01915 7ZM18.01 6V2C18.01 1.45 17.5604 1 17.0108 1C16.4613 1 16.0117 1.45 16.0117 2V6C16.0117 6.55 16.4613 7 17.0108 7C17.5604 7 18.01 6.55 18.01 6ZM16.4213 21.58L18.01 19.99L19.2989 21.28C19.6886 21.67 20.3181 21.67 20.7077 21.28C21.0974 20.89 21.0974 20.26 20.7077 19.87L19.4188 18.58C18.6395 17.8 17.3705 17.8 16.5912 18.58L15.0025 20.17L13.4138 18.58C12.6345 17.8 11.3655 17.8 10.5862 18.58L8.9975 20.17L7.40883 18.58C6.62948 17.8 5.36053 17.8 4.58118 18.58L3.29226 19.87C2.90258 20.26 2.90258 20.89 3.29226 21.28C3.68193 21.67 4.31141 21.67 4.70108 21.28L5.99001 19.99L7.57868 21.58C8.35803 22.36 9.62698 22.36 10.4063 21.58L11.995 19.99L13.5837 21.58C13.9734 21.97 14.4829 22.16 14.9925 22.16C15.5021 22.16 16.0117 21.97 16.4013 21.58H16.4213Z"></path></svg>',
  "smiley-rate4-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.06927 7C6.51927 7 6.06927 6.55 6.06927 6V2C6.06927 1.45 6.51927 1 7.06927 1C7.61927 1 8.06927 1.45 8.06927 2V6C8.06927 6.55 7.61927 7 7.06927 7ZM18.0693 6V2C18.0693 1.45 17.6193 1 17.0693 1C16.5193 1 16.0693 1.45 16.0693 2V6C16.0693 6.55 16.5193 7 17.0693 7C17.6193 7 18.0693 6.55 18.0693 6ZM22.5693 21.9C23.0693 21.66 23.2793 21.07 23.0393 20.57C21.1093 16.52 16.9093 14 12.0693 14C7.22927 14 3.02927 16.52 1.09927 20.57C0.859273 21.07 1.06927 21.67 1.56927 21.9C2.06927 22.14 2.65927 21.93 2.89927 21.43C4.49927 18.08 8.00927 16 12.0593 16C16.1093 16 19.6293 18.08 21.2193 21.43C21.3893 21.79 21.7493 22 22.1193 22C22.2593 22 22.4093 21.97 22.5493 21.9H22.5693Z"></path></svg>',
  "smiley-rate5-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.00572 7C6.45572 7 6.00572 6.55 6.00572 6V2C6.00572 1.45 6.45572 1 7.00572 1C7.55572 1 8.00572 1.45 8.00572 2V6C8.00572 6.55 7.55572 7 7.00572 7ZM18.0057 6V2C18.0057 1.45 17.5557 1 17.0057 1C16.4557 1 16.0057 1.45 16.0057 2V6C16.0057 6.55 16.4557 7 17.0057 7C17.5557 7 18.0057 6.55 18.0057 6ZM19.9457 21.33C20.1257 20.81 19.8557 20.24 19.3357 20.05C14.5457 18.35 9.45572 18.35 4.66572 20.05C4.14572 20.23 3.87572 20.81 4.05572 21.33C4.23572 21.85 4.80572 22.12 5.33572 21.94C9.69572 20.4 14.3057 20.4 18.6657 21.94C18.7757 21.98 18.8857 22 18.9957 22C19.4057 22 19.7957 21.74 19.9357 21.33H19.9457Z"></path></svg>',
  "smiley-rate6-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 7C6.45 7 6 6.55 6 6V2C6 1.45 6.45 1 7 1C7.55 1 8 1.45 8 2V6C8 6.55 7.55 7 7 7ZM18 6V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V6C16 6.55 16.45 7 17 7C17.55 7 18 6.55 18 6ZM21 21C21 20.45 20.55 20 20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21Z"></path></svg>',
  "smiley-rate7-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.0022 23.99C11.452 23.99 11.0018 23.5402 11.0018 22.9904C11.0018 22.4407 11.452 21.9909 12.0022 21.9909C16.3137 21.9909 21.0755 19.472 22.0158 13.8344C22.1058 13.2947 22.616 12.9248 23.1662 13.0148C23.7064 13.1047 24.0765 13.6245 23.9865 14.1643C22.8561 20.9513 17.144 24 11.9922 24L12.0022 23.99ZM8.00072 5.99783V1.99957C8.00072 1.4498 7.55056 1 7.00036 1C6.45016 1 6 1.4498 6 1.99957V5.99783C6 6.54759 6.45016 6.99739 7.00036 6.99739C7.55056 6.99739 8.00072 6.54759 8.00072 5.99783ZM18.0043 5.99783V1.99957C18.0043 1.4498 17.5542 1 17.004 1C16.4538 1 16.0036 1.4498 16.0036 1.99957V5.99783C16.0036 6.54759 16.4538 6.99739 17.004 6.99739C17.5542 6.99739 18.0043 6.54759 18.0043 5.99783Z"></path></svg>',
  "smiley-rate8-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85721 24 1.15412 20.96 0.0134987 14.16C-0.0765501 13.62 0.293651 13.1 0.833944 13.01C1.38424 12.92 1.89452 13.29 1.98457 13.83C2.92508 19.47 7.69767 21.99 12 21.99C16.3023 21.99 21.0749 19.47 22.0154 13.83C22.1055 13.29 22.6158 12.92 23.1661 13.01C23.7063 13.1 24.0765 13.62 23.9865 14.16C22.8559 20.95 17.1428 24 11.99 24H12.01ZM8.00783 6V2C8.00783 1.45 7.55759 1 7.00729 1C6.45699 1 6.00675 1.45 6.00675 2V6C6.00675 6.55 6.45699 7 7.00729 7C7.55759 7 8.00783 6.55 8.00783 6ZM18.0133 6V2C18.0133 1.45 17.563 1 17.0127 1C16.4624 1 16.0122 1.45 16.0122 2V6C16.0122 6.55 16.4624 7 17.0127 7C17.563 7 18.0133 6.55 18.0133 6Z"></path></svg>',
  "smiley-rate9-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85767 24 1.15509 20.96 0.0145752 14.16C-0.0354475 13.87 0.0445888 13.57 0.234675 13.35C0.424761 13.13 0.704888 13 0.995019 13H23.005C23.2951 13 23.5752 13.13 23.7653 13.35C23.9554 13.57 24.0354 13.87 23.9854 14.16C22.8549 20.95 17.1423 24 11.99 24H12.01ZM2.25559 15C3.61621 19.82 8.0182 22 12.01 22C16.0018 22 20.4038 19.82 21.7644 15H2.25559ZM8.00819 6V2C8.00819 1.45 7.55799 1 7.00774 1C6.45749 1 6.00729 1.45 6.00729 2V6C6.00729 6.55 6.45749 7 7.00774 7C7.55799 7 8.00819 6.55 8.00819 6ZM18.0127 6V2C18.0127 1.45 17.5625 1 17.0123 1C16.462 1 16.0118 1.45 16.0118 2V6C16.0118 6.55 16.462 7 17.0123 7C17.5625 7 18.0127 6.55 18.0127 6Z"></path></svg>'
};
/*!
 * surveyjs - Survey JavaScript library v2.0.2
 * Copyright (c) 2015-2025 Devsoft Baltic OÜ  - http://surveyjs.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */
var ke = {
  modernbooleancheckchecked: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><polygon points="19,10 14,10 14,5 10,5 10,10 5,10 5,14 10,14 10,19 14,19 14,14 19,14 "></polygon></svg>',
  modernbooleancheckind: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M22,0H2C0.9,0,0,0.9,0,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V2C24,0.9,23.1,0,22,0z M21,18L6,3h15V18z M3,6l15,15H3V6z"></path></svg>',
  modernbooleancheckunchecked: '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><rect x="5" y="10" width="14" height="4"></rect></svg>',
  moderncheck: '<svg viewBox="0 0 24 24"><path d="M5,13l2-2l3,3l7-7l2,2l-9,9L5,13z"></path></svg>',
  modernradio: '<svg viewBox="-12 -12 24 24"><circle r="6" cx="0" cy="0"></circle></svg>',
  progressbutton: '<svg viewBox="0 0 10 10"><polygon points="2,2 0,4 5,9 10,4 8,2 5,5 "></polygon></svg>',
  removefile: '<svg viewBox="0 0 16 16"><path d="M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z M11,10l-1,1L8,9l-2,2l-1-1l2-2L5,6l1-1l2,2l2-2l1,1L9,8 L11,10z"></path></svg>',
  timercircle: '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 160 160"><circle cx="80" cy="80" r="70" style="stroke: var(--sd-timer-stroke-background-color); stroke-width: var(--sd-timer-stroke-background-width)" stroke-dasharray="none" stroke-dashoffset="none"></circle><circle cx="80" cy="80" r="70"></circle></svg>',
  "add-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M15.75 12C15.75 12.41 15.41 12.75 15 12.75H12.75V15C12.75 15.41 12.41 15.75 12 15.75C11.59 15.75 11.25 15.41 11.25 15V12.75H9C8.59 12.75 8.25 12.41 8.25 12C8.25 11.59 8.59 11.25 9 11.25H11.25V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V11.25H15C15.41 11.25 15.75 11.59 15.75 12ZM21.75 12C21.75 17.38 17.38 21.75 12 21.75C6.62 21.75 2.25 17.38 2.25 12C2.25 6.62 6.62 2.25 12 2.25C17.38 2.25 21.75 6.62 21.75 12ZM20.25 12C20.25 7.45 16.55 3.75 12 3.75C7.45 3.75 3.75 7.45 3.75 12C3.75 16.55 7.45 20.25 12 20.25C16.55 20.25 20.25 16.55 20.25 12Z"></path></svg>',
  "arrowleft-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.7475 7.9975C14.7475 8.4075 14.4075 8.7475 13.9975 8.7475H3.8075L7.5275 12.4675C7.8175 12.7575 7.8175 13.2375 7.5275 13.5275C7.3775 13.6775 7.1875 13.7475 6.9975 13.7475C6.8075 13.7475 6.6175 13.6775 6.4675 13.5275L1.4675 8.5275C1.1775 8.2375 1.1775 7.7575 1.4675 7.4675L6.4675 2.4675C6.7575 2.1775 7.2375 2.1775 7.5275 2.4675C7.8175 2.7575 7.8175 3.2375 7.5275 3.5275L3.8075 7.2475H13.9975C14.4075 7.2475 14.7475 7.5875 14.7475 7.9975Z"></path></svg>',
  "arrowright-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.53 8.5275L9.53 13.5275C9.38 13.6775 9.19 13.7475 9 13.7475C8.81 13.7475 8.62 13.6775 8.47 13.5275C8.18 13.2375 8.18 12.7575 8.47 12.4675L12.19 8.7475H2C1.59 8.7475 1.25 8.4075 1.25 7.9975C1.25 7.5875 1.59 7.2475 2 7.2475H12.19L8.47 3.5275C8.18 3.2375 8.18 2.7575 8.47 2.4675C8.76 2.1775 9.24 2.1775 9.53 2.4675L14.53 7.4675C14.82 7.7575 14.82 8.2375 14.53 8.5275Z"></path></svg>',
  "camera-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.19 4.25H17.12C16.72 4.25 16.35 4.03 16.17 3.67C15.73 2.8 14.86 2.25 13.88 2.25H10.12C9.14 2.25 8.27 2.79 7.83 3.67C7.65 4.03 7.29 4.25 6.88 4.25H4.81C3.4 4.25 2.25 5.4 2.25 6.81V18.19C2.25 19.6 3.4 20.75 4.81 20.75H19.19C20.6 20.75 21.75 19.6 21.75 18.19V6.81C21.75 5.4 20.6 4.25 19.19 4.25ZM20.25 18.19C20.25 18.77 19.78 19.25 19.19 19.25H4.81C4.23 19.25 3.75 18.78 3.75 18.19V6.81C3.75 6.23 4.22 5.75 4.81 5.75H6.88C7.86 5.75 8.73 5.21 9.17 4.33C9.35 3.97 9.71 3.75 10.12 3.75H13.88C14.28 3.75 14.65 3.97 14.83 4.33C15.27 5.2 16.14 5.75 17.12 5.75H19.19C19.77 5.75 20.25 6.22 20.25 6.81V18.19ZM12 6.25C8.83 6.25 6.25 8.83 6.25 12C6.25 15.17 8.83 17.75 12 17.75C15.17 17.75 17.75 15.17 17.75 12C17.75 8.83 15.17 6.25 12 6.25ZM12 16.25C9.66 16.25 7.75 14.34 7.75 12C7.75 9.66 9.66 7.75 12 7.75C14.34 7.75 16.25 9.66 16.25 12C16.25 14.34 14.34 16.25 12 16.25ZM14.75 12C14.75 13.52 13.52 14.75 12 14.75C11.59 14.75 11.25 14.41 11.25 14C11.25 13.59 11.59 13.25 12 13.25C12.69 13.25 13.25 12.69 13.25 12C13.25 11.59 13.59 11.25 14 11.25C14.41 11.25 14.75 11.59 14.75 12Z"></path></svg>',
  "camera-32x32": '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M25 7.25H22.19C21.73 7.25 21.31 7 21.09 6.59L20.89 6.22C20.23 5.01 18.97 4.25 17.59 4.25H14.41C13.03 4.25 11.77 5 11.11 6.22L10.91 6.6C10.69 7 10.27 7.26 9.81 7.26H7C4.93 7.26 3.25 8.94 3.25 11.01V24.01C3.25 26.08 4.93 27.76 7 27.76H25C27.07 27.76 28.75 26.08 28.75 24.01V11C28.75 8.93 27.07 7.25 25 7.25ZM27.25 24C27.25 25.24 26.24 26.25 25 26.25H7C5.76 26.25 4.75 25.24 4.75 24V11C4.75 9.76 5.76 8.75 7 8.75H9.81C10.82 8.75 11.75 8.2 12.23 7.31L12.43 6.94C12.82 6.21 13.58 5.76 14.41 5.76H17.59C18.42 5.76 19.18 6.21 19.57 6.94L19.77 7.31C20.25 8.2 21.18 8.76 22.19 8.76H25C26.24 8.76 27.25 9.77 27.25 11.01V24.01V24ZM16 10.25C12.28 10.25 9.25 13.28 9.25 17C9.25 20.72 12.28 23.75 16 23.75C19.72 23.75 22.75 20.72 22.75 17C22.75 13.28 19.72 10.25 16 10.25ZM16 22.25C13.11 22.25 10.75 19.89 10.75 17C10.75 14.11 13.11 11.75 16 11.75C18.89 11.75 21.25 14.11 21.25 17C21.25 19.89 18.89 22.25 16 22.25ZM19.75 17C19.75 19.07 18.07 20.75 16 20.75C15.59 20.75 15.25 20.41 15.25 20C15.25 19.59 15.59 19.25 16 19.25C17.24 19.25 18.25 18.24 18.25 17C18.25 16.59 18.59 16.25 19 16.25C19.41 16.25 19.75 16.59 19.75 17Z"></path></svg>',
  "cancel-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.8099 11.75L15.2799 9.28C15.5699 8.99 15.5699 8.51 15.2799 8.22C14.9899 7.93 14.5099 7.93 14.2199 8.22L11.7499 10.69L9.27994 8.22C8.98994 7.93 8.50994 7.93 8.21994 8.22C7.92994 8.51 7.92994 8.99 8.21994 9.28L10.6899 11.75L8.21994 14.22C7.92994 14.51 7.92994 14.99 8.21994 15.28C8.36994 15.43 8.55994 15.5 8.74994 15.5C8.93994 15.5 9.12994 15.43 9.27994 15.28L11.7499 12.81L14.2199 15.28C14.3699 15.43 14.5599 15.5 14.7499 15.5C14.9399 15.5 15.1299 15.43 15.2799 15.28C15.5699 14.99 15.5699 14.51 15.2799 14.22L12.8099 11.75Z"></path></svg>',
  "check-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M14.0275 5.0275L6.5275 12.5275C6.3775 12.6775 6.1875 12.7475 5.9975 12.7475C5.8075 12.7475 5.6175 12.6775 5.4675 12.5275L2.4675 9.5275C2.1775 9.2375 2.1775 8.7575 2.4675 8.4675C2.7575 8.1775 3.2375 8.1775 3.5275 8.4675L5.9975 10.9375L12.9675 3.9675C13.2575 3.6775 13.7375 3.6775 14.0275 3.9675C14.3175 4.2575 14.3175 4.7375 14.0275 5.0275Z"></path></svg>',
  "check-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.5275 7.5275L9.5275 17.5275C9.3775 17.6775 9.1875 17.7475 8.9975 17.7475C8.8075 17.7475 8.6175 17.6775 8.4675 17.5275L4.4675 13.5275C4.1775 13.2375 4.1775 12.7575 4.4675 12.4675C4.7575 12.1775 5.2375 12.1775 5.5275 12.4675L8.9975 15.9375L18.4675 6.4675C18.7575 6.1775 19.2375 6.1775 19.5275 6.4675C19.8175 6.7575 19.8175 7.2375 19.5275 7.5275Z"></path></svg>',
  "chevrondown-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M16.5275 10.5275L12.5275 14.5275C12.3775 14.6775 12.1875 14.7475 11.9975 14.7475C11.8075 14.7475 11.6175 14.6775 11.4675 14.5275L7.4675 10.5275C7.1775 10.2375 7.1775 9.7575 7.4675 9.4675C7.7575 9.1775 8.2375 9.1775 8.5275 9.4675L11.9975 12.9375L15.4675 9.4675C15.7575 9.1775 16.2375 9.1775 16.5275 9.4675C16.8175 9.7575 16.8175 10.2375 16.5275 10.5275Z"></path></svg>',
  "chevronright-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.35 8.34627L7.35 12.3463C7.25 12.4463 7.12 12.4963 7 12.4963C6.88 12.4963 6.74 12.4463 6.65 12.3463C6.45 12.1463 6.45 11.8363 6.65 11.6363L10.3 7.98627L6.65 4.34627C6.45 4.15627 6.45 3.83627 6.65 3.64627C6.85 3.45627 7.16 3.44627 7.35 3.64627L11.35 7.64627C11.55 7.84627 11.55 8.15627 11.35 8.35627V8.34627Z"></path></svg>',
  "clear-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12.35 11.65C12.55 11.85 12.55 12.16 12.35 12.36C12.25 12.46 12.12 12.51 12 12.51C11.88 12.51 11.74 12.46 11.65 12.36L8 8.71L4.35 12.36C4.25 12.46 4.12 12.51 4 12.51C3.88 12.51 3.74 12.46 3.65 12.36C3.45 12.16 3.45 11.85 3.65 11.65L7.3 8L3.65 4.35C3.45 4.16 3.45 3.84 3.65 3.65C3.85 3.46 4.16 3.45 4.35 3.65L8 7.3L11.65 3.65C11.85 3.45 12.16 3.45 12.36 3.65C12.56 3.85 12.56 4.16 12.36 4.36L8.71 8.01L12.36 11.66L12.35 11.65Z"></path></svg>',
  "clear-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.12 10.9325C20.64 10.4125 20.93 9.7225 20.93 8.9925C20.93 8.2625 20.64 7.5725 20.12 7.0525L16.95 3.8825C15.88 2.8125 14.13 2.8125 13.06 3.8825L3.88 13.0525C3.36 13.5725 3.07 14.2625 3.07 14.9925C3.07 15.7225 3.36 16.4125 3.88 16.9325L5.64 18.6925C6.57 19.6225 7.78 20.0825 9 20.0825C10.22 20.0825 11.43 19.6225 12.36 18.6925L20.12 10.9325ZM14.12 4.9325C14.36 4.6925 14.67 4.5625 15 4.5625C15.33 4.5625 15.65 4.6925 15.88 4.9325L19.05 8.1025C19.54 8.5925 19.54 9.3825 19.05 9.8725L12.99 15.9325L8.05 10.9925L14.12 4.9325ZM6.7 17.6325L4.94 15.8725C4.45 15.3825 4.45 14.5925 4.94 14.1025L7 12.0425L11.94 16.9825L11.3 17.6225C10.07 18.8525 7.93 18.8525 6.7 17.6225V17.6325ZM22.75 20.9925C22.75 21.4025 22.41 21.7425 22 21.7425H14C13.59 21.7425 13.25 21.4025 13.25 20.9925C13.25 20.5825 13.59 20.2425 14 20.2425H22C22.41 20.2425 22.75 20.5825 22.75 20.9925ZM4.75 20.9925C4.75 21.4025 4.41 21.7425 4 21.7425H2C1.59 21.7425 1.25 21.4025 1.25 20.9925C1.25 20.5825 1.59 20.2425 2 20.2425H4C4.41 20.2425 4.75 20.5825 4.75 20.9925Z"></path></svg>',
  "close-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.5275 12.4675C13.8175 12.7575 13.8175 13.2375 13.5275 13.5275C13.3775 13.6775 13.1875 13.7475 12.9975 13.7475C12.8075 13.7475 12.6175 13.6775 12.4675 13.5275L7.9975 9.0575L3.5275 13.5275C3.3775 13.6775 3.1875 13.7475 2.9975 13.7475C2.8075 13.7475 2.6175 13.6775 2.4675 13.5275C2.1775 13.2375 2.1775 12.7575 2.4675 12.4675L6.9375 7.9975L2.4675 3.5275C2.1775 3.2375 2.1775 2.7575 2.4675 2.4675C2.7575 2.1775 3.2375 2.1775 3.5275 2.4675L7.9975 6.9375L12.4675 2.4675C12.7575 2.1775 13.2375 2.1775 13.5275 2.4675C13.8175 2.7575 13.8175 3.2375 13.5275 3.5275L9.0575 7.9975L13.5275 12.4675Z"></path></svg>',
  "close-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.5275 18.4675C19.8175 18.7575 19.8175 19.2375 19.5275 19.5275C19.3775 19.6775 19.1875 19.7475 18.9975 19.7475C18.8075 19.7475 18.6175 19.6775 18.4675 19.5275L11.9975 13.0575L5.5275 19.5275C5.3775 19.6775 5.1875 19.7475 4.9975 19.7475C4.8075 19.7475 4.6175 19.6775 4.4675 19.5275C4.1775 19.2375 4.1775 18.7575 4.4675 18.4675L10.9375 11.9975L4.4675 5.5275C4.1775 5.2375 4.1775 4.7575 4.4675 4.4675C4.7575 4.1775 5.2375 4.1775 5.5275 4.4675L11.9975 10.9375L18.4675 4.4675C18.7575 4.1775 19.2375 4.1775 19.5275 4.4675C19.8175 4.7575 19.8175 5.2375 19.5275 5.5275L13.0575 11.9975L19.5275 18.4675Z"></path></svg>',
  "collapse-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z"></path></svg>',
  "collapsedetails-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z"></path></svg>',
  "delete-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.75 9V17C12.75 17.41 12.41 17.75 12 17.75C11.59 17.75 11.25 17.41 11.25 17V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9ZM14.25 9V17C14.25 17.41 14.59 17.75 15 17.75C15.41 17.75 15.75 17.41 15.75 17V9C15.75 8.59 15.41 8.25 15 8.25C14.59 8.25 14.25 8.59 14.25 9ZM9 8.25C8.59 8.25 8.25 8.59 8.25 9V17C8.25 17.41 8.59 17.75 9 17.75C9.41 17.75 9.75 17.41 9.75 17V9C9.75 8.59 9.41 8.25 9 8.25ZM20.75 6C20.75 6.41 20.41 6.75 20 6.75H18.75V18C18.75 19.52 17.52 20.75 16 20.75H8C6.48 20.75 5.25 19.52 5.25 18V6.75H4C3.59 6.75 3.25 6.41 3.25 6C3.25 5.59 3.59 5.25 4 5.25H8.25V4C8.25 3.04 9.04 2.25 10 2.25H14C14.96 2.25 15.75 3.04 15.75 4V5.25H20C20.41 5.25 20.75 5.59 20.75 6ZM9.75 5.25H14.25V4C14.25 3.86 14.14 3.75 14 3.75H10C9.86 3.75 9.75 3.86 9.75 4V5.25ZM17.25 6.75H6.75V18C6.75 18.69 7.31 19.25 8 19.25H16C16.69 19.25 17.25 18.69 17.25 18V6.75Z"></path></svg>',
  "drag-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.5 8.75C15.19 8.75 15.75 8.19 15.75 7.5C15.75 6.81 15.19 6.25 14.5 6.25C13.81 6.25 13.25 6.81 13.25 7.5C13.25 8.19 13.81 8.75 14.5 8.75ZM14.5 7.25C14.64 7.25 14.75 7.36 14.75 7.5C14.75 7.78 14.25 7.78 14.25 7.5C14.25 7.36 14.36 7.25 14.5 7.25ZM9.5 6.25C8.81 6.25 8.25 6.81 8.25 7.5C8.25 8.19 8.81 8.75 9.5 8.75C10.19 8.75 10.75 8.19 10.75 7.5C10.75 6.81 10.19 6.25 9.5 6.25ZM9.25 7.5C9.25 7.36 9.36 7.25 9.5 7.25C9.64 7.25 9.75 7.36 9.75 7.5C9.75 7.78 9.25 7.78 9.25 7.5ZM14.5 11.25C13.81 11.25 13.25 11.81 13.25 12.5C13.25 13.19 13.81 13.75 14.5 13.75C15.19 13.75 15.75 13.19 15.75 12.5C15.75 11.81 15.19 11.25 14.5 11.25ZM14.25 12.5C14.25 12.36 14.36 12.25 14.5 12.25C14.64 12.25 14.75 12.36 14.75 12.5C14.75 12.78 14.25 12.78 14.25 12.5ZM9.5 11.25C8.81 11.25 8.25 11.81 8.25 12.5C8.25 13.19 8.81 13.75 9.5 13.75C10.19 13.75 10.75 13.19 10.75 12.5C10.75 11.81 10.19 11.25 9.5 11.25ZM9.25 12.5C9.25 12.36 9.36 12.25 9.5 12.25C9.64 12.25 9.75 12.36 9.75 12.5C9.75 12.78 9.25 12.78 9.25 12.5ZM14.5 16.25C13.81 16.25 13.25 16.81 13.25 17.5C13.25 18.19 13.81 18.75 14.5 18.75C15.19 18.75 15.75 18.19 15.75 17.5C15.75 16.81 15.19 16.25 14.5 16.25ZM14.25 17.5C14.25 17.36 14.36 17.25 14.5 17.25C14.64 17.25 14.75 17.36 14.75 17.5C14.75 17.78 14.25 17.78 14.25 17.5ZM9.5 16.25C8.81 16.25 8.25 16.81 8.25 17.5C8.25 18.19 8.81 18.75 9.5 18.75C10.19 18.75 10.75 18.19 10.75 17.5C10.75 16.81 10.19 16.25 9.5 16.25ZM9.25 17.5C9.25 17.36 9.36 17.25 9.5 17.25C9.64 17.25 9.75 17.36 9.75 17.5C9.75 17.78 9.25 17.78 9.25 17.5Z"></path></svg>',
  "draghorizontal-24x16": '<svg viewBox="0 0 24 16" xmlns="http://www.w3.org/2000/svg"><path d="M17.5 9.25C16.81 9.25 16.25 9.81 16.25 10.5C16.25 11.19 16.81 11.75 17.5 11.75C18.19 11.75 18.75 11.19 18.75 10.5C18.75 9.81 18.19 9.25 17.5 9.25ZM17.25 10.5C17.25 10.36 17.36 10.25 17.5 10.25C17.64 10.25 17.75 10.36 17.75 10.5C17.75 10.78 17.25 10.78 17.25 10.5ZM17.5 6.75C18.19 6.75 18.75 6.19 18.75 5.5C18.75 4.81 18.19 4.25 17.5 4.25C16.81 4.25 16.25 4.81 16.25 5.5C16.25 6.19 16.81 6.75 17.5 6.75ZM17.5 5.25C17.64 5.25 17.75 5.36 17.75 5.5C17.75 5.78 17.25 5.78 17.25 5.5C17.25 5.36 17.36 5.25 17.5 5.25ZM12.5 9.25C11.81 9.25 11.25 9.81 11.25 10.5C11.25 11.19 11.81 11.75 12.5 11.75C13.19 11.75 13.75 11.19 13.75 10.5C13.75 9.81 13.19 9.25 12.5 9.25ZM12.25 10.5C12.25 10.36 12.36 10.25 12.5 10.25C12.64 10.25 12.75 10.36 12.75 10.5C12.75 10.78 12.25 10.78 12.25 10.5ZM12.5 4.25C11.81 4.25 11.25 4.81 11.25 5.5C11.25 6.19 11.81 6.75 12.5 6.75C13.19 6.75 13.75 6.19 13.75 5.5C13.75 4.81 13.19 4.25 12.5 4.25ZM12.25 5.5C12.25 5.36 12.36 5.25 12.5 5.25C12.64 5.25 12.75 5.36 12.75 5.5C12.75 5.78 12.25 5.78 12.25 5.5ZM7.5 9.25C6.81 9.25 6.25 9.81 6.25 10.5C6.25 11.19 6.81 11.75 7.5 11.75C8.19 11.75 8.75 11.19 8.75 10.5C8.75 9.81 8.19 9.25 7.5 9.25ZM7.25 10.5C7.25 10.36 7.36 10.25 7.5 10.25C7.64 10.25 7.75 10.36 7.75 10.5C7.75 10.78 7.25 10.78 7.25 10.5ZM7.5 4.25C6.81 4.25 6.25 4.81 6.25 5.5C6.25 6.19 6.81 6.75 7.5 6.75C8.19 6.75 8.75 6.19 8.75 5.5C8.75 4.81 8.19 4.25 7.5 4.25ZM7.25 5.5C7.25 5.36 7.36 5.25 7.5 5.25C7.64 5.25 7.75 5.36 7.75 5.5C7.75 5.78 7.25 5.78 7.25 5.5Z"></path></svg>',
  "expand-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.75 8C11.75 8.41 11.41 8.75 11 8.75H8.75V11C8.75 11.41 8.41 11.75 8 11.75C7.59 11.75 7.25 11.41 7.25 11V8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H7.25V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V7.25H11C11.41 7.25 11.75 7.59 11.75 8Z"></path></svg>',
  "expanddetails-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.75 8C11.75 8.41 11.41 8.75 11 8.75H8.75V11C8.75 11.41 8.41 11.75 8 11.75C7.59 11.75 7.25 11.41 7.25 11V8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H7.25V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V7.25H11C11.41 7.25 11.75 7.59 11.75 8Z"></path></svg>',
  "file-72x72": '<svg viewBox="0 0 72 72" xmlns="http://www.w3.org/2000/svg"><path d="M62.83 12.83L53.17 3.17C52.7982 2.79866 52.357 2.50421 51.8714 2.30346C51.3858 2.1027 50.8654 1.99959 50.34 2H14C12.4087 2 10.8826 2.63214 9.75735 3.75736C8.63214 4.88258 8 6.4087 8 8V64C8 65.5913 8.63214 67.1174 9.75735 68.2426C10.8826 69.3679 12.4087 70 14 70H58C59.5913 70 61.1174 69.3679 62.2426 68.2426C63.3679 67.1174 64 65.5913 64 64V15.66C64.0004 15.1346 63.8973 14.6142 63.6965 14.1286C63.4958 13.643 63.2013 13.2018 62.83 12.83ZM52 4.83L61.17 14H56C54.9391 14 53.9217 13.5786 53.1716 12.8284C52.4214 12.0783 52 11.0609 52 10V4.83ZM62 64C62 65.0609 61.5786 66.0783 60.8284 66.8284C60.0783 67.5786 59.0609 68 58 68H14C12.9391 68 11.9217 67.5786 11.1716 66.8284C10.4214 66.0783 10 65.0609 10 64V8C10 6.93914 10.4214 5.92172 11.1716 5.17157C11.9217 4.42143 12.9391 4 14 4H50V10C50 11.5913 50.6321 13.1174 51.7574 14.2426C52.8826 15.3679 54.4087 16 56 16H62V64ZM22 26H50V28H22V26ZM22 32H50V34H22V32ZM22 38H50V40H22V38ZM22 44H50V46H22V44Z"></path></svg>',
  "flip-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14.53 17.4775C14.82 17.7675 14.82 18.2475 14.53 18.5375L11.53 21.5375C11.38 21.6875 11.19 21.7575 11 21.7575C10.81 21.7575 10.62 21.6875 10.47 21.5375C10.18 21.2475 10.18 20.7675 10.47 20.4775L12.2 18.7475C12.13 18.7475 12.07 18.7475 12 18.7475C6.62 18.7475 2.25 15.7475 2.25 12.0575C2.25 10.2975 3.22 8.6375 4.99 7.3875C5.33 7.1475 5.8 7.2275 6.03 7.5675C6.27 7.9075 6.19 8.3775 5.85 8.6075C4.49 9.5675 3.74 10.7875 3.74 12.0575C3.74 14.9175 7.44 17.2475 11.99 17.2475C12.05 17.2475 12.11 17.2475 12.17 17.2475L10.46 15.5375C10.17 15.2475 10.17 14.7675 10.46 14.4775C10.75 14.1875 11.23 14.1875 11.52 14.4775L14.52 17.4775H14.53ZM12 5.2575C11.93 5.2575 11.87 5.2575 11.8 5.2575L13.53 3.5275C13.82 3.2375 13.82 2.7575 13.53 2.4675C13.24 2.1775 12.76 2.1775 12.47 2.4675L9.47 5.4675C9.18 5.7575 9.18 6.2375 9.47 6.5275L12.47 9.5275C12.62 9.6775 12.81 9.7475 13 9.7475C13.19 9.7475 13.38 9.6775 13.53 9.5275C13.82 9.2375 13.82 8.7575 13.53 8.4675L11.82 6.7575C11.88 6.7575 11.94 6.7575 12 6.7575C16.55 6.7575 20.25 9.0875 20.25 11.9475C20.25 13.2075 19.5 14.4375 18.14 15.3975C17.8 15.6375 17.72 16.1075 17.96 16.4475C18.11 16.6575 18.34 16.7675 18.57 16.7675C18.72 16.7675 18.87 16.7275 19 16.6275C20.77 15.3775 21.75 13.7175 21.75 11.9575C21.75 8.2675 17.38 5.2675 12 5.2675V5.2575Z"></path></svg>',
  "folder-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M21.72 9.24C21.45 8.92 21.12 8.67 20.75 8.5V8C20.75 6.48 19.52 5.25 18 5.25H10.65C10.32 4.1 9.26 3.25 8 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18.33C19.66 20.75 20.8 19.8 21.04 18.49L22.31 11.49C22.46 10.69 22.24 9.86 21.72 9.24ZM4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H8C8.69 4.75 9.25 5.31 9.25 6C9.25 6.41 9.59 6.75 10 6.75H18C18.69 6.75 19.25 7.31 19.25 8V8.25H9.27C7.94 8.25 6.8 9.2 6.56 10.51L5.29 17.51C5.19 18.07 5.27 18.64 5.51 19.15C5.06 18.96 4.75 18.52 4.75 18ZM20.83 11.22L19.56 18.22C19.45 18.81 18.94 19.25 18.33 19.25H8C7.63 19.25 7.28 19.09 7.04 18.8C6.8 18.51 6.7 18.14 6.77 17.78L8.04 10.78C8.15 10.19 8.66 9.75 9.27 9.75H19.6C19.97 9.75 20.32 9.91 20.56 10.2C20.8 10.49 20.9 10.86 20.83 11.22Z"></path></svg>',
  "fullsize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 3.25H4C3.04 3.25 2.25 4.04 2.25 5V11C2.25 11.96 3.04 12.75 4 12.75H12C12.96 12.75 13.75 11.96 13.75 11V5C13.75 4.04 12.96 3.25 12 3.25ZM12.25 11C12.25 11.14 12.14 11.25 12 11.25H4C3.86 11.25 3.75 11.14 3.75 11V5C3.75 4.86 3.86 4.75 4 4.75H12C12.14 4.75 12.25 4.86 12.25 5V11Z"></path></svg>',
  "image-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M33 10.25H15C12.38 10.25 10.25 12.38 10.25 15V33C10.25 35.62 12.38 37.75 15 37.75H33C35.62 37.75 37.75 35.62 37.75 33V15C37.75 12.38 35.62 10.25 33 10.25ZM36.25 33C36.25 34.79 34.79 36.25 33 36.25H15C13.21 36.25 11.75 34.79 11.75 33V15C11.75 13.21 13.21 11.75 15 11.75H33C34.79 11.75 36.25 13.21 36.25 15V33ZM30.5 14.25C28.71 14.25 27.25 15.71 27.25 17.5C27.25 19.29 28.71 20.75 30.5 20.75C32.29 20.75 33.75 19.29 33.75 17.5C33.75 15.71 32.29 14.25 30.5 14.25ZM30.5 19.25C29.54 19.25 28.75 18.46 28.75 17.5C28.75 16.54 29.54 15.75 30.5 15.75C31.46 15.75 32.25 16.54 32.25 17.5C32.25 18.46 31.46 19.25 30.5 19.25ZM29.26 26.28C28.94 25.92 28.49 25.71 28.01 25.7C27.54 25.68 27.07 25.87 26.73 26.2L24.95 27.94L22.28 25.23C21.94 24.89 21.5 24.71 21 24.71C20.52 24.71 20.06 24.93 19.74 25.28L14.74 30.78C14.25 31.3 14.12 32.06 14.41 32.72C14.69 33.36 15.28 33.75 15.95 33.75H32.07C32.74 33.75 33.33 33.35 33.61 32.72C33.89 32.06 33.77 31.31 33.29 30.79L29.27 26.29L29.26 26.28ZM32.22 32.12C32.18 32.2 32.13 32.25 32.06 32.25H15.94C15.87 32.25 15.81 32.21 15.78 32.12C15.77 32.09 15.71 31.93 15.83 31.8L20.84 26.29C20.9 26.22 20.99 26.21 21.02 26.21C21.06 26.21 21.14 26.22 21.2 26.29L24.4 29.54C24.69 29.83 25.16 29.84 25.46 29.54L27.77 27.27C27.83 27.21 27.9 27.2 27.94 27.2C28.01 27.2 28.06 27.21 28.13 27.28L32.16 31.79C32.16 31.79 32.16 31.79 32.17 31.8C32.29 31.93 32.23 32.09 32.22 32.12Z"></path></svg>',
  "loading-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_19679_369428)"><path opacity="0.1" d="M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z" fill="black" fill-opacity="0.91"></path><path d="M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z"></path></g><defs><clipPath id="clip0_19679_369428"><rect width="32" height="32" fill="white" transform="translate(8 8)"></rect></clipPath></defs></svg>',
  "maximize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 3V7C13.75 7.41 13.41 7.75 13 7.75C12.59 7.75 12.25 7.41 12.25 7V4.81L9.53 7.53C9.38 7.68 9.19 7.75 9 7.75C8.81 7.75 8.62 7.68 8.47 7.53C8.18 7.24 8.18 6.76 8.47 6.47L11.19 3.75H9C8.59 3.75 8.25 3.41 8.25 3C8.25 2.59 8.59 2.25 9 2.25H13C13.1 2.25 13.19 2.27 13.29 2.31C13.47 2.39 13.62 2.53 13.7 2.72C13.74 2.81 13.76 2.91 13.76 3.01L13.75 3ZM7.53 8.47C7.24 8.18 6.76 8.18 6.47 8.47L3.75 11.19V9C3.75 8.59 3.41 8.25 3 8.25C2.59 8.25 2.25 8.59 2.25 9V13C2.25 13.1 2.27 13.19 2.31 13.29C2.39 13.47 2.53 13.62 2.72 13.7C2.81 13.74 2.91 13.76 3.01 13.76H7.01C7.42 13.76 7.76 13.42 7.76 13.01C7.76 12.6 7.42 12.26 7.01 12.26H4.82L7.54 9.54C7.83 9.25 7.83 8.77 7.54 8.48L7.53 8.47Z"></path></svg>',
  "minimize-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.75 8C13.75 8.41 13.41 8.75 13 8.75H3C2.59 8.75 2.25 8.41 2.25 8C2.25 7.59 2.59 7.25 3 7.25H13C13.41 7.25 13.75 7.59 13.75 8Z"></path></svg>',
  "more-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25ZM11.75 12C11.75 11.86 11.86 11.75 12 11.75C12.14 11.75 12.25 11.86 12.25 12C12.25 12.28 11.75 12.28 11.75 12ZM19 10.25C18.04 10.25 17.25 11.04 17.25 12C17.25 12.96 18.04 13.75 19 13.75C19.96 13.75 20.75 12.96 20.75 12C20.75 11.04 19.96 10.25 19 10.25ZM18.75 12C18.75 11.86 18.86 11.75 19 11.75C19.14 11.75 19.25 11.86 19.25 12C19.25 12.28 18.75 12.28 18.75 12ZM5 10.25C4.04 10.25 3.25 11.04 3.25 12C3.25 12.96 4.04 13.75 5 13.75C5.96 13.75 6.75 12.96 6.75 12C6.75 11.04 5.96 10.25 5 10.25ZM4.75 12C4.75 11.86 4.86 11.75 5 11.75C5.14 11.75 5.25 11.86 5.25 12C5.25 12.28 4.75 12.28 4.75 12Z"></path></svg>',
  "navmenu-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.25 7C3.25 6.59 3.59 6.25 4 6.25H15C15.41 6.25 15.75 6.59 15.75 7C15.75 7.41 15.41 7.75 15 7.75H4C3.59 7.75 3.25 7.41 3.25 7ZM20 11.25H4C3.59 11.25 3.25 11.59 3.25 12C3.25 12.41 3.59 12.75 4 12.75H20C20.41 12.75 20.75 12.41 20.75 12C20.75 11.59 20.41 11.25 20 11.25ZM9 16.25H4C3.59 16.25 3.25 16.59 3.25 17C3.25 17.41 3.59 17.75 4 17.75H9C9.41 17.75 9.75 17.41 9.75 17C9.75 16.59 9.41 16.25 9 16.25Z"></path></svg>',
  "noimage-48x48": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M30.4975 14.2475C28.7075 14.2475 27.2475 15.7075 27.2475 17.4975C27.2475 19.2875 28.7075 20.7475 30.4975 20.7475C32.2875 20.7475 33.7475 19.2875 33.7475 17.4975C33.7475 15.7075 32.2875 14.2475 30.4975 14.2475ZM30.4975 19.2475C29.5375 19.2475 28.7475 18.4575 28.7475 17.4975C28.7475 16.5375 29.5375 15.7475 30.4975 15.7475C31.4575 15.7475 32.2475 16.5375 32.2475 17.4975C32.2475 18.4575 31.4575 19.2475 30.4975 19.2475ZM13.5175 11.2175C13.4375 10.8075 13.7075 10.4175 14.1175 10.3375C14.4275 10.2775 14.7175 10.2475 14.9975 10.2475H32.9975C35.6175 10.2475 37.7475 12.3775 37.7475 14.9975V32.9975C37.7475 33.2775 37.7175 33.5675 37.6575 33.8775C37.5875 34.2375 37.2775 34.4875 36.9175 34.4875C36.8675 34.4875 36.8275 34.4875 36.7775 34.4775C36.3675 34.3975 36.1075 34.0075 36.1775 33.5975C36.2175 33.3775 36.2375 33.1775 36.2375 32.9975V14.9975C36.2375 13.2075 34.7775 11.7475 32.9875 11.7475H14.9975C14.8075 11.7475 14.6175 11.7675 14.3975 11.8075C13.9875 11.8875 13.5975 11.6175 13.5175 11.2075V11.2175ZM34.4775 36.7775C34.5575 37.1875 34.2875 37.5775 33.8775 37.6575C33.5675 37.7175 33.2775 37.7475 32.9975 37.7475H14.9975C12.3775 37.7475 10.2475 35.6175 10.2475 32.9975V14.9975C10.2475 14.7175 10.2775 14.4275 10.3375 14.1175C10.4175 13.7075 10.8075 13.4375 11.2175 13.5175C11.6275 13.5975 11.8875 13.9875 11.8175 14.3975C11.7775 14.6175 11.7575 14.8175 11.7575 14.9975V32.9975C11.7575 34.7875 13.2175 36.2475 15.0075 36.2475H33.0075C33.1975 36.2475 33.3875 36.2275 33.6075 36.1875C34.0075 36.1075 34.4075 36.3775 34.4875 36.7875L34.4775 36.7775ZM15.8275 31.7975C15.6975 31.9375 15.7575 32.0875 15.7775 32.1175C15.8175 32.1975 15.8675 32.2475 15.9375 32.2475H29.8175C30.2275 32.2475 30.5675 32.5875 30.5675 32.9975C30.5675 33.4075 30.2275 33.7475 29.8175 33.7475H15.9375C15.2675 33.7475 14.6775 33.3475 14.3975 32.7175C14.1075 32.0575 14.2375 31.2975 14.7275 30.7775L19.7275 25.2775C20.0475 24.9275 20.5075 24.7175 20.9875 24.7075C21.4875 24.7275 21.9375 24.8875 22.2675 25.2275L25.4675 28.4775C25.7575 28.7675 25.7575 29.2475 25.4675 29.5375C25.1675 29.8275 24.6975 29.8275 24.4075 29.5375L21.2075 26.2875C21.1475 26.2175 21.0675 26.1875 21.0275 26.2075C20.9875 26.2075 20.9075 26.2175 20.8475 26.2875L15.8375 31.7975H15.8275ZM38.5275 38.5275C38.3775 38.6775 38.1875 38.7475 37.9975 38.7475C37.8075 38.7475 37.6175 38.6775 37.4675 38.5275L9.4675 10.5275C9.1775 10.2375 9.1775 9.7575 9.4675 9.4675C9.7575 9.1775 10.2375 9.1775 10.5275 9.4675L38.5275 37.4675C38.8175 37.7575 38.8175 38.2375 38.5275 38.5275Z"></path></svg>',
  "ranking-arrows": '<svg viewBox="0 0 10 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 5L5 0L0 5H4V9H6V5H10Z"></path><path d="M6 19V15H4V19H0L5 24L10 19H6Z"></path></svg>',
  "rankingundefined-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z"></path></svg>',
  "rating-star-2": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z" fill="none" stroke-width="2"></path><path d="M24.3981 33.1305L24 32.9206L23.6019 33.1305L15.8715 37.2059L17.3542 28.5663L17.43 28.1246L17.1095 27.8113L10.83 21.6746L19.4965 20.4049L19.9405 20.3399L20.1387 19.9373L24 12.0936L27.8613 19.9373L28.0595 20.3399L28.5035 20.4049L37.17 21.6746L30.8905 27.8113L30.57 28.1246L30.6458 28.5663L32.1285 37.2059L24.3981 33.1305Z" stroke-width="1.70746"></path></svg>',
  "rating-star-small-2": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z" fill="none" stroke-width="2"></path><path d="M12 15.9472L8.58001 17.7572L9.23001 13.9272L6.45001 11.2072L10.29 10.6472L12 7.17725L13.71 10.6472L17.55 11.2072L14.77 13.9272L15.42 17.7572L12 15.9472Z"></path></svg>',
  "rating-star-small": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z"></path></g></svg>',
  "rating-star": '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z"></path></g></svg>',
  "reorder-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M8.9444 10.75H15.0544C15.7144 10.75 16.3144 10.39 16.6144 9.80002C16.9144 9.22002 16.8644 8.52002 16.4844 7.98002L13.4244 3.71002C12.7644 2.79002 11.2344 2.79002 10.5744 3.71002L7.5244 7.99002C7.1444 8.53002 7.0944 9.22002 7.3944 9.81002C7.6944 10.4 8.2944 10.76 8.9544 10.76L8.9444 10.75ZM8.7444 8.86002L11.7944 4.58002C11.8644 4.49002 11.9544 4.48002 11.9944 4.48002C12.0344 4.48002 12.1344 4.49002 12.1944 4.58002L15.2544 8.86002C15.3344 8.97002 15.3044 9.07002 15.2744 9.12002C15.2444 9.17002 15.1844 9.26002 15.0544 9.26002H8.9444C8.8144 9.26002 8.7444 9.18002 8.7244 9.12002C8.7044 9.06002 8.6644 8.97002 8.7444 8.86002ZM15.0544 13.25H8.9444C8.2844 13.25 7.6844 13.61 7.3844 14.2C7.0844 14.78 7.1344 15.48 7.5144 16.02L10.5744 20.3C10.9044 20.76 11.4344 21.03 11.9944 21.03C12.5544 21.03 13.0944 20.76 13.4144 20.3L16.4744 16.02C16.8544 15.48 16.9044 14.79 16.6044 14.2C16.3044 13.61 15.7044 13.25 15.0444 13.25H15.0544ZM15.2644 15.15L12.2044 19.43C12.0744 19.61 11.9244 19.61 11.7944 19.43L8.7344 15.15C8.6544 15.04 8.6844 14.94 8.7144 14.89C8.7444 14.84 8.8044 14.75 8.9344 14.75H15.0444C15.1744 14.75 15.2444 14.83 15.2644 14.89C15.2844 14.95 15.3244 15.04 15.2444 15.15H15.2644Z"></path></svg>',
  "restoredown-16x16": '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M7.69 8.71C7.73 8.8 7.75 8.9 7.75 9V13C7.75 13.41 7.41 13.75 7 13.75C6.59 13.75 6.25 13.41 6.25 13V10.81L3.53 13.53C3.38 13.68 3.19 13.75 3 13.75C2.81 13.75 2.62 13.68 2.47 13.53C2.18 13.24 2.18 12.76 2.47 12.47L5.19 9.75H3C2.59 9.75 2.25 9.41 2.25 9C2.25 8.59 2.59 8.25 3 8.25H7C7.1 8.25 7.19 8.27 7.29 8.31C7.47 8.39 7.62 8.53 7.7 8.72L7.69 8.71ZM13 6.25H10.81L13.53 3.53C13.82 3.24 13.82 2.76 13.53 2.47C13.24 2.18 12.76 2.18 12.47 2.47L9.75 5.19V3C9.75 2.59 9.41 2.25 9 2.25C8.59 2.25 8.25 2.59 8.25 3V7C8.25 7.1 8.27 7.19 8.31 7.29C8.39 7.47 8.53 7.62 8.72 7.7C8.81 7.74 8.91 7.76 9.01 7.76H13.01C13.42 7.76 13.76 7.42 13.76 7.01C13.76 6.6 13.42 6.26 13.01 6.26L13 6.25Z"></path></svg>',
  "search-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.9975 2.25C9.7275 2.25 6.2475 5.73 6.2475 10C6.2475 11.87 6.9075 13.58 8.0175 14.92L2.4675 20.47C2.1775 20.76 2.1775 21.24 2.4675 21.53C2.6175 21.68 2.8075 21.75 2.9975 21.75C3.1875 21.75 3.3775 21.68 3.5275 21.53L9.0775 15.98C10.4175 17.08 12.1275 17.75 13.9975 17.75C18.2675 17.75 21.7475 14.27 21.7475 10C21.7475 5.73 18.2675 2.25 13.9975 2.25ZM13.9975 16.25C10.5475 16.25 7.7475 13.45 7.7475 10C7.7475 6.55 10.5475 3.75 13.9975 3.75C17.4475 3.75 20.2475 6.55 20.2475 10C20.2475 13.45 17.4475 16.25 13.9975 16.25Z"></path></svg>',
  "smiley-rate1-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 4.9938C4 4.44362 4.45 3.99348 5 3.99348H6.59L5.3 2.70306C4.91 2.31293 4.91 1.68272 5.3 1.2926C5.69 0.902468 6.32 0.902468 6.71 1.2926L9.71 4.29357C9.8 4.3836 9.88 4.49364 9.93 4.62368C10.03 4.86376 10.03 5.14385 9.93 5.38393C9.88 5.50397 9.81 5.614 9.71 5.71404L6.71 8.71501C6.51 8.91508 6.26 9.00511 6 9.00511C5.74 9.00511 5.49 8.90508 5.29 8.71501C4.9 8.32489 4.9 7.69468 5.29 7.30456L6.58 6.01413H4.99C4.44 6.01413 3.99 5.56399 3.99 5.01381L4 4.9938ZM14.08 5.37393C14.13 5.49397 14.2 5.604 14.3 5.70403L17.3 8.70501C17.5 8.90508 17.75 8.99511 18.01 8.99511C18.27 8.99511 18.52 8.89507 18.72 8.70501C19.11 8.31488 19.11 7.68468 18.72 7.29455L17.43 6.00413H19.02C19.57 6.00413 20.02 5.55399 20.02 5.00381C20.02 4.45363 19.57 4.00348 19.02 4.00348H17.43L18.72 2.71306C19.11 2.32293 19.11 1.69273 18.72 1.3026C18.33 0.912471 17.7 0.912471 17.31 1.3026L14.31 4.30358C14.22 4.39361 14.14 4.50364 14.09 4.63368C13.99 4.87376 13.99 5.15385 14.09 5.39393L14.08 5.37393ZM22 14.9971V20.999C22 22.6496 20.65 24 19 24H5C3.35 24 2 22.6496 2 20.999V14.9971C2 13.3465 3.35 11.9961 5 11.9961H19C20.65 11.9961 22 13.3465 22 14.9971ZM19 13.9967H16V16.9977H20V14.9971C20 14.4469 19.55 13.9967 19 13.9967ZM14 16.9977V13.9967H10V16.9977H14ZM10 18.9984V21.9993H14V18.9984H10ZM4 14.9971V16.9977H8V13.9967H5C4.45 13.9967 4 14.4469 4 14.9971ZM5 21.9993H8V18.9984H4V20.999C4 21.5492 4.45 21.9993 5 21.9993ZM20 20.999V18.9984H16V21.9993H19C19.55 21.9993 20 21.5492 20 20.999Z"></path></svg>',
  "smiley-rate10-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 23C6.85721 23 1.15412 19.9621 0.0134987 13.1669C-0.0765501 12.6272 0.293651 12.1076 0.833944 12.0177C1.38424 11.9277 1.89452 12.2975 1.98457 12.8371C2.92508 18.4732 7.69767 20.9914 12 20.9914C16.3023 20.9914 21.0749 18.4732 22.0154 12.8371C22.1055 12.2975 22.6158 11.9277 23.1661 12.0177C23.7063 12.1076 24.0765 12.6272 23.9865 13.1669C22.8559 19.9521 17.1428 23 11.99 23H12.01ZM21.165 6.15177C22.3056 5.01257 22.3056 3.16386 21.165 2.02465L21.0049 1.85477C19.9143 0.765533 18.1633 0.725561 17.0227 1.71487C15.8821 0.715568 14.1312 0.765533 13.0406 1.85477L12.8705 2.01466C11.7299 3.15386 11.7299 5.00257 12.8705 6.14178L17.0227 10.2889L21.175 6.14178L21.165 6.15177ZM15.742 3.27378L17.0127 4.54289L18.2834 3.27378C18.6436 2.91403 19.2239 2.91403 19.5841 3.27378L19.7442 3.43367C20.1044 3.79342 20.1044 4.37301 19.7442 4.73276L17.0127 7.46086L14.2812 4.73276C13.921 4.37301 13.921 3.79342 14.2812 3.43367L14.4413 3.27378C14.6214 3.09391 14.8515 3.00397 15.0917 3.00397C15.3318 3.00397 15.5619 3.09391 15.742 3.27378ZM11.1595 6.15177C12.3002 5.01257 12.3002 3.16386 11.1595 2.02465L10.9995 1.85477C9.90886 0.765533 8.15792 0.725561 7.0173 1.71487C5.87668 0.715568 4.12573 0.765533 3.03514 1.85477L2.86505 2.01466C1.72443 3.15386 1.72443 5.00257 2.86505 6.14178L7.0173 10.2889L11.1695 6.14178L11.1595 6.15177ZM5.7366 3.27378L7.00729 4.54289L8.27798 3.27378C8.63818 2.91403 9.21849 2.91403 9.57869 3.27378L9.73877 3.43367C10.099 3.79342 10.099 4.37301 9.73877 4.73276L7.00729 7.46086L4.27581 4.73276C3.91562 4.37301 3.91562 3.79342 4.27581 3.43367L4.4359 3.27378C4.61599 3.09391 4.84612 3.00397 5.08625 3.00397C5.32638 3.00397 5.5565 3.09391 5.7366 3.27378Z"></path></svg>',
  "smiley-rate2-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_15894_140103)"><path d="M4.88291 4.51001C4.47291 4.51001 4.08291 4.25001 3.94291 3.84001C3.76291 3.32001 4.03291 2.75001 4.55291 2.57001L8.32291 1.25001C8.84291 1.06001 9.41291 1.34001 9.59291 1.86001C9.77291 2.38001 9.50291 2.95001 8.98291 3.13001L5.20291 4.45001C5.09291 4.49001 4.98291 4.51001 4.87291 4.51001H4.88291ZM19.8129 3.89001C20.0229 3.38001 19.7729 2.79001 19.2629 2.59001L15.5529 1.07001C15.0429 0.860007 14.4529 1.11001 14.2529 1.62001C14.0429 2.13001 14.2929 2.72001 14.8029 2.92001L18.5029 4.43001C18.6229 4.48001 18.7529 4.50001 18.8829 4.50001C19.2729 4.50001 19.6529 4.27001 19.8129 3.88001V3.89001ZM3.50291 6.00001C2.64291 6.37001 1.79291 6.88001 1.00291 7.48001C0.79291 7.64001 0.64291 7.87001 0.59291 8.14001C0.48291 8.73001 0.87291 9.29001 1.45291 9.40001C2.04291 9.51001 2.60291 9.12001 2.71291 8.54001C2.87291 7.69001 3.12291 6.83001 3.50291 5.99001V6.00001ZM21.0429 8.55001C21.6029 10.48 24.2429 8.84001 22.7529 7.48001C21.9629 6.88001 21.1129 6.37001 20.2529 6.00001C20.6329 6.84001 20.8829 7.70001 21.0429 8.55001ZM21.5729 13.2C21.2529 14.2 22.5429 15.09 23.3629 14.39C23.8529 14 23.9229 13.29 23.5429 12.81C21.7429 10.67 22.1329 10.55 21.5829 13.2H21.5729ZM1.75291 11C1.22291 11.79 -0.14709 12.64 0.0129102 13.75C0.15291 14.36 0.75291 14.74 1.35291 14.6C2.98291 14.1 1.80291 12.22 1.75291 11ZM19.8829 17C19.8829 13.14 16.2929 10 11.8829 10C7.47291 10 3.88291 13.14 3.88291 17C3.88291 20.86 7.47291 24 11.8829 24C16.2929 24 19.8829 20.86 19.8829 17ZM17.8829 17C17.8829 19.76 15.1929 22 11.8829 22C8.57291 22 5.88291 19.76 5.88291 17C5.88291 14.24 8.57291 12 11.8829 12C15.1929 12 17.8829 14.24 17.8829 17Z"></path></g><defs><clipPath id="clip0_15894_140103"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>',
  "smiley-rate3-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.01915 7C6.46961 7 6.01998 6.55 6.01998 6V2C6.01998 1.45 6.46961 1 7.01915 1C7.56869 1 8.01832 1.45 8.01832 2V6C8.01832 6.55 7.56869 7 7.01915 7ZM18.01 6V2C18.01 1.45 17.5604 1 17.0108 1C16.4613 1 16.0117 1.45 16.0117 2V6C16.0117 6.55 16.4613 7 17.0108 7C17.5604 7 18.01 6.55 18.01 6ZM16.4213 21.58L18.01 19.99L19.2989 21.28C19.6886 21.67 20.3181 21.67 20.7077 21.28C21.0974 20.89 21.0974 20.26 20.7077 19.87L19.4188 18.58C18.6395 17.8 17.3705 17.8 16.5912 18.58L15.0025 20.17L13.4138 18.58C12.6345 17.8 11.3655 17.8 10.5862 18.58L8.9975 20.17L7.40883 18.58C6.62948 17.8 5.36053 17.8 4.58118 18.58L3.29226 19.87C2.90258 20.26 2.90258 20.89 3.29226 21.28C3.68193 21.67 4.31141 21.67 4.70108 21.28L5.99001 19.99L7.57868 21.58C8.35803 22.36 9.62698 22.36 10.4063 21.58L11.995 19.99L13.5837 21.58C13.9734 21.97 14.4829 22.16 14.9925 22.16C15.5021 22.16 16.0117 21.97 16.4013 21.58H16.4213Z"></path></svg>',
  "smiley-rate4-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.06927 7C6.51927 7 6.06927 6.55 6.06927 6V2C6.06927 1.45 6.51927 1 7.06927 1C7.61927 1 8.06927 1.45 8.06927 2V6C8.06927 6.55 7.61927 7 7.06927 7ZM18.0693 6V2C18.0693 1.45 17.6193 1 17.0693 1C16.5193 1 16.0693 1.45 16.0693 2V6C16.0693 6.55 16.5193 7 17.0693 7C17.6193 7 18.0693 6.55 18.0693 6ZM22.5693 21.9C23.0693 21.66 23.2793 21.07 23.0393 20.57C21.1093 16.52 16.9093 14 12.0693 14C7.22927 14 3.02927 16.52 1.09927 20.57C0.859273 21.07 1.06927 21.67 1.56927 21.9C2.06927 22.14 2.65927 21.93 2.89927 21.43C4.49927 18.08 8.00927 16 12.0593 16C16.1093 16 19.6293 18.08 21.2193 21.43C21.3893 21.79 21.7493 22 22.1193 22C22.2593 22 22.4093 21.97 22.5493 21.9H22.5693Z"></path></svg>',
  "smiley-rate5-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.00572 7C6.45572 7 6.00572 6.55 6.00572 6V2C6.00572 1.45 6.45572 1 7.00572 1C7.55572 1 8.00572 1.45 8.00572 2V6C8.00572 6.55 7.55572 7 7.00572 7ZM18.0057 6V2C18.0057 1.45 17.5557 1 17.0057 1C16.4557 1 16.0057 1.45 16.0057 2V6C16.0057 6.55 16.4557 7 17.0057 7C17.5557 7 18.0057 6.55 18.0057 6ZM19.9457 21.33C20.1257 20.81 19.8557 20.24 19.3357 20.05C14.5457 18.35 9.45572 18.35 4.66572 20.05C4.14572 20.23 3.87572 20.81 4.05572 21.33C4.23572 21.85 4.80572 22.12 5.33572 21.94C9.69572 20.4 14.3057 20.4 18.6657 21.94C18.7757 21.98 18.8857 22 18.9957 22C19.4057 22 19.7957 21.74 19.9357 21.33H19.9457Z"></path></svg>',
  "smiley-rate6-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 7C6.45 7 6 6.55 6 6V2C6 1.45 6.45 1 7 1C7.55 1 8 1.45 8 2V6C8 6.55 7.55 7 7 7ZM18 6V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V6C16 6.55 16.45 7 17 7C17.55 7 18 6.55 18 6ZM21 21C21 20.45 20.55 20 20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21Z"></path></svg>',
  "smiley-rate7-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.0022 23.99C11.452 23.99 11.0018 23.5402 11.0018 22.9904C11.0018 22.4407 11.452 21.9909 12.0022 21.9909C16.3137 21.9909 21.0755 19.472 22.0158 13.8344C22.1058 13.2947 22.616 12.9248 23.1662 13.0148C23.7064 13.1047 24.0765 13.6245 23.9865 14.1643C22.8561 20.9513 17.144 24 11.9922 24L12.0022 23.99ZM8.00072 5.99783V1.99957C8.00072 1.4498 7.55056 1 7.00036 1C6.45016 1 6 1.4498 6 1.99957V5.99783C6 6.54759 6.45016 6.99739 7.00036 6.99739C7.55056 6.99739 8.00072 6.54759 8.00072 5.99783ZM18.0043 5.99783V1.99957C18.0043 1.4498 17.5542 1 17.004 1C16.4538 1 16.0036 1.4498 16.0036 1.99957V5.99783C16.0036 6.54759 16.4538 6.99739 17.004 6.99739C17.5542 6.99739 18.0043 6.54759 18.0043 5.99783Z"></path></svg>',
  "smiley-rate8-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85721 24 1.15412 20.96 0.0134987 14.16C-0.0765501 13.62 0.293651 13.1 0.833944 13.01C1.38424 12.92 1.89452 13.29 1.98457 13.83C2.92508 19.47 7.69767 21.99 12 21.99C16.3023 21.99 21.0749 19.47 22.0154 13.83C22.1055 13.29 22.6158 12.92 23.1661 13.01C23.7063 13.1 24.0765 13.62 23.9865 14.16C22.8559 20.95 17.1428 24 11.99 24H12.01ZM8.00783 6V2C8.00783 1.45 7.55759 1 7.00729 1C6.45699 1 6.00675 1.45 6.00675 2V6C6.00675 6.55 6.45699 7 7.00729 7C7.55759 7 8.00783 6.55 8.00783 6ZM18.0133 6V2C18.0133 1.45 17.563 1 17.0127 1C16.4624 1 16.0122 1.45 16.0122 2V6C16.0122 6.55 16.4624 7 17.0127 7C17.563 7 18.0133 6.55 18.0133 6Z"></path></svg>',
  "smiley-rate9-24x24": '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85767 24 1.15509 20.96 0.0145752 14.16C-0.0354475 13.87 0.0445888 13.57 0.234675 13.35C0.424761 13.13 0.704888 13 0.995019 13H23.005C23.2951 13 23.5752 13.13 23.7653 13.35C23.9554 13.57 24.0354 13.87 23.9854 14.16C22.8549 20.95 17.1423 24 11.99 24H12.01ZM2.25559 15C3.61621 19.82 8.0182 22 12.01 22C16.0018 22 20.4038 19.82 21.7644 15H2.25559ZM8.00819 6V2C8.00819 1.45 7.55799 1 7.00774 1C6.45749 1 6.00729 1.45 6.00729 2V6C6.00729 6.55 6.45749 7 7.00774 7C7.55799 7 8.00819 6.55 8.00819 6ZM18.0127 6V2C18.0127 1.45 17.5625 1 17.0123 1C16.462 1 16.0118 1.45 16.0118 2V6C16.0118 6.55 16.462 7 17.0123 7C17.5625 7 18.0127 6.55 18.0127 6Z"></path></svg>'
};
const no = ["lang", "dir"], to = { onsubmit: "return false;" }, oo = {
  key: 0,
  class: "sv_custom_header"
}, io = { class: "sv-components-column sv-components-column--expandable" }, ro = ["id"], lo = { key: 2 }, ao = ["innerHTML"], uo = ["innerHTML"], mo = ["innerHTML"];
qe("v1", so);
qe("v2", ke);
X.registerIcons(ke);
const re = /* @__PURE__ */ y({
  __name: "Survey",
  props: {
    model: {},
    survey: {}
  },
  setup(u) {
    const e = u, n = f(), s = f(""), i = f(1), t = b(() => {
      const Z = e.survey ? e.survey : e.model;
      return $e(Z);
    }), a = b(() => t.value.activePage ? t.value.activePage.id : ""), p = () => {
      const Z = a.value;
      return !!t.value && Z + i.value.toString();
    }, g = b(
      () => t.value.showCompletedPage && t.value.state === "completed"
    ), C = b(() => t.value.css), q = b(() => "page" + p()), B = () => g.value ? (s.value || (s.value = t.value.processedCompletedHtml), s.value) : "", k = (Z) => {
      if (Z) {
        var w = n.value;
        w && Z.afterRenderSurvey(w), Z.renderCallback = () => {
          var A, le;
          i.value++, (le = (A = he()) == null ? void 0 : A.proxy) == null || le.$forceUpdate();
        }, Z.startTimerFromUI();
      }
    };
    return V(
      () => t.value,
      (Z, w) => {
        Z && w && k(Z);
      },
      (Z) => {
        Z.stopTimer(), Z.renderCallback = void 0;
      }
    ), $(() => {
      k(t.value);
    }), P(() => {
      t.value.stopTimer(), t.value.beforeDestroySurveyElement(), t.value.renderCallback = void 0;
    }), (Z, w) => (o(), l("div", {
      class: r(t.value.getRootCss()),
      style: M(t.value.themeVariables),
      lang: t.value.locale || "en",
      dir: t.value.localeDir,
      ref_key: "root",
      ref: n
    }, [
      t.value.needRenderIcons ? (o(), c(d, {
        key: 0,
        is: "sv-svg-bundle"
      })) : m("", !0),
      v("div", {
        class: r(t.value.wrapperFormCss)
      }, [
        h(d, { is: "survey-popup-modal" }),
        t.value.renderBackgroundImage ? (o(), l("div", {
          key: 0,
          class: r(C.value.rootBackgroundImage),
          style: M(t.value.backgroundImageStyle)
        }, null, 6)) : m("", !0),
        v("form", to, [
          t.value.hasLogo ? m("", !0) : (o(), l("div", oo)),
          v("div", {
            class: r(C.value.container)
          }, [
            t.value.headerView === "basic" ? (o(), c(d, {
              key: 0,
              is: "survey-header",
              survey: t.value
            }, null, 8, ["survey"])) : m("", !0),
            h(d, {
              is: "sv-components-container",
              survey: t.value,
              container: "header",
              needRenderWrapper: !1
            }, null, 8, ["survey"]),
            t.value.isShowingPage ? (o(), l("div", {
              key: 1,
              class: r(t.value.bodyContainerCss)
            }, [
              h(d, {
                is: "sv-components-container",
                survey: t.value,
                container: "left",
                needRenderWrapper: !0
              }, null, 8, ["survey"]),
              v("div", io, [
                h(d, {
                  is: "sv-components-container",
                  survey: t.value,
                  container: "center",
                  needRenderWrapper: !0
                }, null, 8, ["survey"]),
                v("div", {
                  class: r(t.value.bodyCss),
                  style: M({ maxWidth: t.value.renderedWidth }),
                  id: a.value
                }, [
                  h(d, {
                    is: "sv-components-container",
                    survey: t.value,
                    container: "contentTop",
                    needRenderWrapper: !0
                  }, null, 8, ["survey"]),
                  (o(), c(d, {
                    is: "survey-page",
                    key: q.value,
                    survey: t.value,
                    page: t.value.activePage,
                    css: C.value
                  }, null, 8, ["survey", "page", "css"])),
                  h(d, {
                    is: "sv-components-container",
                    survey: t.value,
                    container: "contentBottom",
                    needRenderWrapper: !0
                  }, null, 8, ["survey"]),
                  t.value.showBrandInfo ? (o(), c(d, {
                    key: 0,
                    is: "sv-brand-info"
                  })) : m("", !0)
                ], 14, ro)
              ]),
              h(d, {
                is: "sv-components-container",
                survey: t.value,
                container: "right",
                needRenderWrapper: !0
              }, null, 8, ["survey"])
            ], 2)) : m("", !0),
            h(d, {
              is: "sv-components-container",
              survey: t.value,
              container: "footer",
              needRenderWrapper: !1
            }, null, 8, ["survey"]),
            g.value ? (o(), l("div", lo, [
              v("div", {
                innerHTML: B(),
                class: r(t.value.completedCss)
              }, null, 10, ao),
              h(d, {
                is: "sv-components-container",
                survey: t.value,
                container: "completePage",
                needRenderWrapper: !0
              }, null, 8, ["survey"])
            ])) : m("", !0),
            t.value.state === "completedbefore" ? (o(), l("div", {
              key: 3,
              class: r(t.value.completedBeforeCss),
              innerHTML: t.value.processedCompletedBeforeHtml
            }, null, 10, uo)) : m("", !0),
            t.value.state === "loading" ? (o(), l("div", {
              key: 4,
              class: r(t.value.loadingBodyCss),
              innerHTML: t.value.processedLoadingHtml
            }, null, 10, mo)) : m("", !0),
            t.value.state === "empty" ? (o(), l("div", {
              key: 5,
              class: r(C.value.bodyEmpty)
            }, H(t.value.emptySurveyText), 3)) : m("", !0)
          ], 2)
        ]),
        h(d, {
          is: "sv-notifier",
          model: t.value.notifier
        }, null, 8, ["model"])
      ], 2)
    ], 14, no));
  }
}), po = /* @__PURE__ */ y({
  __name: "Notifier",
  props: {
    model: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.model), (n, s) => n.model.isDisplayed ? (o(), l("div", {
      key: 0,
      class: r(n.model.css),
      style: M({ visibility: n.model.active ? "visible" : "hidden" }),
      role: "alert",
      "aria-live": "polite"
    }, [
      v("span", null, H(n.model.message), 1),
      h(d, {
        is: "sv-action-bar",
        model: n.model.actionBar
      }, null, 8, ["model"])
    ], 6)) : m("", !0);
  }
}), Co = { key: 0 }, vo = /* @__PURE__ */ y({
  __name: "QuestionOther",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", {
      class: r(e.question.getCommentAreaCss(!0))
    }, [
      e.question.isReadOnlyRenderDiv() ? (o(), l("div", Co, H(e.question.otherValue), 1)) : (o(), c(d, {
        key: 1,
        is: "sv-text-area",
        model: e.question.otherTextAreaModel
      }, null, 8, ["model"]))
    ], 2));
  }
}), co = ["disabled", "value", "title"], go = /* @__PURE__ */ y({
  __name: "SurveyNavigationButton",
  props: {
    item: {}
  },
  setup(u) {
    const e = u, n = () => e.item.data && e.item.data.mouseDown();
    return V(() => e.item), (s, i) => s.item.visible ? (o(), l("input", {
      key: 0,
      type: "button",
      disabled: s.item.disabled,
      value: s.item.title,
      class: r(s.item.innerCss),
      title: s.item.getTooltip(),
      onMousedown: n,
      onClick: i[0] || (i[0] = //@ts-ignore
      (...t) => s.item.action && s.item.action(...t))
    }, null, 42, co)) : m("", !0);
  }
}), fe = /* @__PURE__ */ y({
  __name: "PopupSurvey",
  props: {
    survey: {},
    isExpanded: { type: Boolean },
    allowClose: { type: Boolean },
    allowFullScreen: { type: Boolean },
    onClose: { type: Function },
    closeOnCompleteTimeout: {}
  },
  setup(u) {
    const e = u, n = W(), s = () => {
      n.value.changeExpandCollapse();
    }, i = () => {
      n.value.hide(), e.onClose && e.onClose();
    }, t = () => {
      n.value.toggleFullScreen();
    }, a = () => {
      n.value.onScroll();
    }, p = () => {
      let C = n.value.cssHeaderRoot;
      return n.value.isCollapsed && (C += " " + n.value.cssRootCollapsedMod), C;
    };
    V(() => n.value);
    const g = F(
      () => e.survey,
      (C) => {
        const q = new je(null, C);
        e.isExpanded !== void 0 && (q.isExpanded = e.isExpanded), e.closeOnCompleteTimeout !== void 0 && (q.closeOnCompleteTimeout = e.closeOnCompleteTimeout), e.allowClose !== void 0 && (q.allowClose = e.allowClose), e.allowFullScreen !== void 0 && (q.allowFullScreen = e.allowFullScreen), q.isShowing = !0, n.value = q;
      },
      {
        immediate: !0
      }
    );
    return P(() => {
      g();
    }), (C, q) => n.value.isShowing ? (o(), l("div", {
      key: 0,
      style: M({
        maxWidth: n.value.renderedWidth,
        width: n.value.renderedWidth
      }),
      class: r(n.value.cssRoot),
      onScroll: a
    }, [
      v("div", {
        class: r(n.value.cssRootContent)
      }, [
        v("div", {
          class: r(p())
        }, [
          n.value.isCollapsed && n.value.locTitle ? (o(), l("div", {
            key: 0,
            class: r(n.value.cssHeaderTitleCollapsed)
          }, H(n.value.locTitle.renderedHtml), 3)) : m("", !0),
          v("div", {
            class: r(n.value.cssHeaderButtonsContainer)
          }, [
            n.value.allowFullScreen ? (o(), l("div", {
              key: 0,
              class: r(n.value.cssHeaderFullScreenButton),
              onClick: t
            }, [
              n.value.isFullScreen ? (o(), c(d, {
                key: 0,
                is: "sv-svg-icon",
                iconName: "icon-back-to-panel_16x16",
                size: 16
              })) : m("", !0),
              n.value.isFullScreen ? m("", !0) : (o(), c(d, {
                key: 1,
                is: "sv-svg-icon",
                iconName: "icon-full-screen_16x16",
                size: 16
              }))
            ], 2)) : m("", !0),
            v("div", {
              class: r(n.value.cssHeaderCollapseButton),
              onClick: s
            }, [
              n.value.isExpanded ? (o(), c(d, {
                key: 0,
                is: "sv-svg-icon",
                iconName: "icon-minimize_16x16",
                size: 16
              })) : m("", !0),
              n.value.isCollapsed ? (o(), c(d, {
                key: 1,
                is: "sv-svg-icon",
                iconName: "icon-restore_16x16",
                size: 16
              })) : m("", !0)
            ], 2),
            n.value.allowClose ? (o(), l("div", {
              key: 1,
              class: r(n.value.cssHeaderCloseButton),
              onClick: i
            }, [
              h(d, {
                is: "sv-svg-icon",
                iconName: "icon-close_16x16",
                size: 16
              })
            ], 2)) : m("", !0)
          ], 2)
        ], 2),
        v("div", {
          class: r(n.value.cssBody)
        }, [
          h(re, { survey: C.survey }, null, 8, ["survey"])
        ], 2)
      ], 2)
    ], 38)) : m("", !0);
  }
}), ho = ["innerHTML"], yo = /* @__PURE__ */ y({
  __name: "CustomWidget",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(), s = b(
      () => e.question.customWidget.isDefaultRender
    ), i = b(
      () => !!e.question.customWidget.htmlTemplate
    ), t = b(() => e.question.customWidget.htmlTemplate), a = b(() => "survey-" + e.question.getTemplate());
    return $(() => {
      e.question.customWidget.afterRender(e.question, n.value);
    }), z(() => {
      e.question.customWidget.willUnmount(e.question, n.value);
    }), (p, g) => (o(), l("div", {
      ref_key: "root",
      ref: n
    }, [
      i.value ? (o(), l("div", {
        key: 0,
        innerHTML: t.value
      }, null, 8, ho)) : m("", !0),
      s.value ? (o(), c(d, {
        key: 1,
        is: a.value,
        question: p.question,
        css: p.css
      }, null, 8, ["is", "question", "css"])) : m("", !0)
    ], 512));
  }
}), qo = /* @__PURE__ */ y({
  __name: "PopupModal",
  setup(u) {
    const e = W();
    function n(s, i) {
      const t = Qe(
        s,
        i
      ), a = (p, g) => {
        g.isVisible || (e.value = void 0, t.dispose(), t.onVisibilityChanged.remove(a));
      };
      return t.onVisibilityChanged.add(a), t.model.isVisible = !0, e.value = t, t;
    }
    return se.showDialog || (se.showDialog = n, P(() => {
      se.showDialog = void 0;
    })), (s, i) => e.value ? (o(), c(De, {
      key: 0,
      to: e.value.container
    }, [
      h(d, {
        is: "sv-popup-container",
        model: e.value
      }, null, 8, ["model"])
    ], 8, ["to"])) : m("", !0);
  }
}), wo = ["readonly", "disabled", "value", "id", "maxlength", "cols", "rows", "placeholder", "aria-required", "aria-label", "aria-labelledby", "aria-describedby", "aria-invalid", "aria-errormessage"], Lo = /* @__PURE__ */ y({
  __name: "TextArea",
  props: {
    model: {}
  },
  setup(u) {
    const e = u, n = f(
      null
    ), s = b(() => e.model.getTextValue() || "");
    return $(() => {
      e.model.setElement(n.value);
    }), j(() => {
      e.model.setElement(n.value);
    }), P(() => {
      e.model.resetElement();
    }), (i, t) => (o(), l("textarea", {
      ref_key: "contentElement",
      ref: n,
      readonly: i.model.isReadOnlyAttr,
      disabled: i.model.isDisabledAttr,
      value: s.value,
      id: i.model.id,
      maxlength: i.model.maxLength,
      cols: i.model.cols,
      rows: i.model.rows,
      placeholder: i.model.placeholder,
      class: r(i.model.className),
      onBlur: t[0] || (t[0] = (a) => {
        i.model.onTextAreaBlur(a);
      }),
      onFocus: t[1] || (t[1] = (a) => {
        i.model.onTextAreaFocus(a);
      }),
      onChange: t[2] || (t[2] = (a) => {
        i.model.onTextAreaChange(a);
      }),
      onInput: t[3] || (t[3] = (a) => {
        i.model.onTextAreaInput(a);
      }),
      onKeydown: t[4] || (t[4] = (a) => {
        i.model.onTextAreaKeyDown(a);
      }),
      "aria-required": i.model.ariaRequired,
      "aria-label": i.model.ariaLabel,
      "aria-labelledby": i.model.ariaLabelledBy,
      "aria-describedby": i.model.ariaDescribedBy,
      "aria-invalid": i.model.ariaInvalid,
      "aria-errormessage": i.model.ariaErrormessage,
      style: M({ resize: i.model.question.resizeStyle })
    }, null, 46, wo));
  }
}), ko = /* @__PURE__ */ y({
  __name: "CharacterCounter",
  props: {
    counter: {},
    remainingCharacterCounter: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.counter), (n, s) => (o(), l("div", {
      class: r(n.remainingCharacterCounter)
    }, H(n.counter.remainingCharacterCounter), 3));
  }
}), fo = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Composite",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = b(() => e.question.contentPanel);
    return (i, t) => (o(), c(d, {
      is: "survey-panel",
      ref_key: "root",
      ref: n,
      element: s.value,
      css: i.css
    }, null, 8, ["element", "css"]));
  }
}), bo = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Custom",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(null);
    T(e, n);
    const s = b(() => e.question.contentQuestion), i = (t) => oe(t);
    return (t, a) => (o(), c(d, {
      ref: n.value,
      is: i(s.value),
      question: s.value,
      css: t.css
    }, null, 8, ["is", "question", "css"]));
  }
}), Mo = /* @__PURE__ */ v("use", { "xlink:href": "#icon-timercircle" }, null, -1), Ho = [
  Mo
], Ce = 440, Io = /* @__PURE__ */ y({
  __name: "TimerPanel",
  props: {
    model: {},
    css: {}
  },
  setup(u) {
    const e = u, n = b(() => Ce * e.model.progress), s = b(() => e.model.text);
    return V(() => e.model), (i, t) => i.model.isRunning && i.model.showTimerAsClock ? (o(), l("div", {
      key: 0,
      class: r(i.model.rootCss)
    }, [
      i.model.showProgress ? (o(), l("svg", {
        key: 0,
        class: r(i.model.getProgressCss()),
        style: M({ strokeDasharray: Ce, strokeDashoffset: n.value })
      }, Ho, 6)) : m("", !0),
      v("div", {
        class: r(i.model.textContainerCss)
      }, [
        v("span", {
          class: r(i.model.majorTextCss)
        }, H(i.model.clockMajorText), 3),
        i.model.clockMinorText ? (o(), l("span", {
          key: 0,
          class: r(i.model.minorTextCss)
        }, H(i.model.clockMinorText), 3)) : m("", !0)
      ], 2)
    ], 2)) : R((o(), l("div", {
      key: 1,
      class: r(i.model.survey.getCss().timerRoot)
    }, H(s.value), 3)), [
      [N, i.model.isRunning && !i.model.showTimerAsClock]
    ]);
  }
}), So = { class: "sd-loading-indicator" }, Vo = /* @__PURE__ */ y({
  __name: "LoadingIndicator",
  setup(u) {
    return (e, n) => (o(), l("div", So, [
      h(d, {
        is: "sv-svg-icon",
        iconName: "icon-loading",
        size: "'auto'"
      })
    ]));
  }
}), Bo = { key: 2 }, Ro = /* @__PURE__ */ y({
  __name: "Header",
  props: {
    model: {},
    survey: {}
  },
  setup(u) {
    const e = u;
    return V(() => {
      const n = e.model;
      return n.survey = e.survey, e.model;
    }), $(() => {
      e.model.processResponsiveness();
    }), j(() => {
      e.model.processResponsiveness();
    }), (n, s) => n.survey.headerView === "advanced" && !n.model.isEmpty ? (o(), l("div", {
      key: 0,
      class: r(n.model.headerClasses),
      style: M({ height: n.model.renderedHeight })
    }, [
      n.model.backgroundImage ? (o(), l("div", {
        key: 0,
        class: r(n.model.backgroundImageClasses),
        style: M(n.model.backgroundImageStyle)
      }, null, 6)) : m("", !0),
      n.survey.isMobile ? m("", !0) : (o(), l("div", {
        key: 1,
        class: r(n.model.contentClasses),
        style: M({ maxWidth: n.model.maxWidth })
      }, [
        (o(!0), l(I, null, S(n.model.cells, (i, t) => (o(), c(d, {
          is: "sv-header-cell",
          model: i,
          key: t
        }, null, 8, ["model"]))), 128))
      ], 6)),
      n.survey.isMobile ? (o(), l("div", Bo, [
        h(d, {
          is: "sv-header-mobile",
          model: n.model
        }, null, 8, ["model"])
      ])) : m("", !0)
    ], 6)) : m("", !0);
  }
}), To = {
  key: 0,
  class: "sv-header__logo"
}, Zo = ["src", "width", "height", "alt"], $o = /* @__PURE__ */ y({
  __name: "HeaderCell",
  props: {
    model: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", {
      class: r(e.model.css),
      style: M(e.model.style)
    }, [
      v("div", {
        class: "sv-header__cell-content",
        style: M(e.model.contentStyle)
      }, [
        e.model.showLogo ? (o(), l("div", To, [
          v("div", {
            class: r(e.model.survey.logoClassNames)
          }, [
            v("img", {
              class: r(e.model.survey.css.logoImage),
              src: e.model.survey.locLogo.renderedHtml,
              width: e.model.survey.renderedLogoWidth,
              height: e.model.survey.renderedLogoHeight,
              alt: e.model.survey.locTitle.renderedHtml,
              style: M({ objectFit: e.model.survey.logoFit, width: e.model.survey.renderedStyleLogoWidth, height: e.model.survey.renderedStyleLogoHeight })
            }, null, 14, Zo)
          ], 2)
        ])) : m("", !0),
        e.model.showTitle ? (o(), l("div", {
          key: 1,
          class: "sv-header__title",
          style: M({ maxWidth: e.model.textAreaWidth })
        }, [
          h(d, {
            is: "survey-element-title",
            element: e.model.survey,
            css: e.model.survey.css
          }, null, 8, ["element", "css"])
        ], 4)) : m("", !0),
        e.model.showDescription ? (o(), l("div", {
          key: 2,
          class: "sv-header__description",
          style: M({ maxWidth: e.model.textAreaWidth })
        }, [
          e.model.survey.renderedHasDescription ? (o(), l("div", {
            key: 0,
            class: r(e.model.survey.css.description)
          }, [
            h(d, {
              is: "survey-string",
              locString: e.model.survey.locDescription
            }, null, 8, ["locString"])
          ], 2)) : m("", !0)
        ], 4)) : m("", !0)
      ], 4)
    ], 6));
  }
}), Do = { class: "sv-header--mobile" }, Ao = {
  key: 0,
  class: "sv-header__logo"
}, No = ["src", "width", "height", "alt"], Po = /* @__PURE__ */ y({
  __name: "HeaderMobile",
  props: {
    model: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", Do, [
      e.model.survey.hasLogo ? (o(), l("div", Ao, [
        v("div", {
          class: r(e.model.survey.logoClassNames)
        }, [
          v("img", {
            class: r(e.model.survey.css.logoImage),
            src: e.model.survey.locLogo.renderedHtml,
            width: e.model.survey.renderedLogoWidth,
            height: e.model.survey.renderedLogoHeight,
            alt: e.model.survey.locTitle.renderedHtml,
            style: M({ objectFit: e.model.survey.logoFit, width: e.model.survey.renderedStyleLogoWidth, height: e.model.survey.renderedStyleLogoHeight })
          }, null, 14, No)
        ], 2)
      ])) : m("", !0),
      e.model.survey.hasTitle ? (o(), l("div", {
        key: 1,
        class: "sv-header__title",
        style: M({ maxWidth: e.model.renderedTextAreaWidth })
      }, [
        h(d, {
          is: "survey-element-title",
          element: e.model.survey,
          css: e.model.survey.css
        }, null, 8, ["element", "css"])
      ], 4)) : m("", !0),
      e.model.survey.renderedHasDescription ? (o(), l("div", {
        key: 2,
        class: "sv-header__description",
        style: M({ maxWidth: e.model.renderedTextAreaWidth })
      }, [
        e.model.survey.renderedHasDescription ? (o(), l("div", {
          key: 0,
          class: r(e.model.survey.css.description)
        }, [
          h(d, {
            is: "survey-string",
            locString: e.model.survey.locDescription
          }, null, 8, ["locString"])
        ], 2)) : m("", !0)
      ], 4)) : m("", !0)
    ]));
  }
}), Eo = /* @__PURE__ */ y({
  __name: "Element",
  props: {
    element: {},
    row: {},
    css: {}
  },
  setup(u) {
    const e = u, n = f(), s = (g) => g.isPanel ? "survey-panel" : "survey-question", i = b(() => {
      const g = e.element.survey;
      if (g) {
        const C = g.getElementWrapperComponentName(e.element);
        if (C)
          return C;
      }
      return s(e.element);
    }), t = (g) => g.cssClasses ? g.rootStyle : {}, a = b(() => {
      const g = e.element, C = g.survey;
      let q;
      return C && (q = C.getElementWrapperComponentData(g)), {
        componentName: s(g),
        componentData: {
          element: g,
          survey: C,
          row: e.row,
          css: e.css,
          data: q
        }
      };
    }), p = F(
      () => e.element,
      (g, C) => {
        C && C.setWrapperElement(void 0), g.setWrapperElement(n.value);
      }
    );
    return $(() => {
      e.element.setWrapperElement(n.value);
    }), P(() => {
      e.element.setWrapperElement(void 0), p();
    }), (g, C) => (o(), l("div", {
      ref_key: "root",
      ref: n,
      style: M(t(g.element)),
      class: r(g.element.cssClasses.questionWrapper)
    }, [
      g.row.isNeedRender ? (o(), c(d, D({
        key: 0,
        is: i.value
      }, a.value), null, 16, ["is"])) : g.element.skeletonComponentName ? (o(), c(d, {
        key: 1,
        is: g.element.skeletonComponentName,
        element: g.element,
        css: g.css
      }, null, 8, ["is", "element", "css"])) : m("", !0)
    ], 6));
  }
}), Wo = /* @__PURE__ */ y({
  __name: "TemplateRenderer",
  props: {
    componentName: {},
    componentData: {}
  },
  setup(u) {
    const e = Ae(), n = b(() => !!e.default);
    return (s, i) => n.value && !s.componentName ? ce(s.$slots, "default", { key: 0 }) : (o(), c(d, D({
      key: 1,
      is: s.componentName
    }, s.componentData), null, 16, ["is"]));
  }
}), Fo = /* @__PURE__ */ y({
  __name: "FileCleanButton",
  props: {
    question: {},
    css: {}
  },
  setup(u) {
    return (e, n) => (o(), l("button", {
      type: "button",
      class: r(e.css),
      onClick: n[0] || (n[0] = //@ts-ignore
      (...s) => e.question.doClean && e.question.doClean(...s))
    }, [
      v("span", null, H(e.question.clearButtonCaption), 1),
      e.question.cssClasses.removeButtonIconId ? (o(), c(d, {
        key: 0,
        is: "sv-svg-icon",
        iconName: e.question.cssClasses.removeButtonIconId,
        size: "auto",
        title: e.question.clearButtonCaption
      }, null, 8, ["iconName", "title"])) : m("", !0)
    ], 2));
  }
}), zo = ["id"], Oo = /* @__PURE__ */ y({
  __name: "FileVideo",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => (o(), l("div", {
      class: r(e.question.cssClasses.videoContainer)
    }, [
      h(d, {
        is: "sv-action",
        item: e.question.changeCameraAction
      }, null, 8, ["item"]),
      h(d, {
        is: "sv-action",
        item: e.question.closeCameraAction
      }, null, 8, ["item"]),
      v("video", {
        autoplay: "",
        playsinline: "",
        id: e.question.videoId,
        class: r(e.question.cssClasses.video)
      }, null, 10, zo),
      h(d, {
        is: "sv-action",
        item: e.question.takePictureAction
      }, null, 8, ["item"])
    ], 2));
  }
}), Uo = ["for", "aria-label"], Ko = /* @__PURE__ */ y({
  __name: "FileChooseButton",
  props: {
    data: {},
    item: {}
  },
  setup(u) {
    const e = u, n = b(
      () => {
        var s, i;
        return ((s = e.data) == null ? void 0 : s.question) || ((i = e.item) == null ? void 0 : i.data.question);
      }
    );
    return (s, i) => R((o(), l("label", {
      tabindex: "0",
      class: r(n.value.getChooseFileCss()),
      for: n.value.inputId,
      "aria-label": n.value.chooseButtonText,
      onClick: i[0] || (i[0] = (t) => n.value.chooseFile(t))
    }, [
      n.value.cssClasses.chooseFileIconId ? (o(), c(d, {
        key: 0,
        is: "sv-svg-icon",
        title: n.value.chooseButtonText,
        iconName: n.value.cssClasses.chooseFileIconId,
        size: "auto"
      }, null, 8, ["title", "iconName"])) : m("", !0),
      v("span", null, H(n.value.chooseButtonText), 1)
    ], 10, Uo)), [
      [L(U)]
    ]);
  }
}), jo = /* @__PURE__ */ y({
  __name: "FilePreview",
  props: {
    question: {}
  },
  setup(u) {
    return (e, n) => e.question.showPreviewContainer ? (o(), l("div", {
      key: 0,
      class: r(e.question.cssClasses.fileList || void 0)
    }, [
      e.question.supportFileNavigator ? (o(!0), l(I, { key: 0 }, S(e.question.renderedPages, (s) => (o(), c(d, {
        is: "sv-file-page",
        key: s.id,
        page: s,
        question: e.question
      }, null, 8, ["page", "question"]))), 128)) : m("", !0),
      e.question.supportFileNavigator ? m("", !0) : (o(!0), l(I, { key: 1 }, S(e.question.previewValue, (s) => (o(), c(d, {
        is: "sv-file-item",
        key: s,
        item: s,
        question: e.question
      }, null, 8, ["item", "question"]))), 128))
    ], 2)) : m("", !0);
  }
}), Qo = /* @__PURE__ */ y({
  __name: "ButtonGroup",
  props: {
    question: {}
  },
  setup(u) {
    const e = u, n = f();
    return T(e, n), (s, i) => (o(), l("div", {
      role: "group",
      class: r(s.question.cssClasses.root),
      ref_key: "root",
      ref: n
    }, [
      (o(!0), l(I, null, S(s.question.visibleChoices, (t, a) => (o(), c(d, {
        is: "sv-button-group-item",
        question: s.question,
        key: a,
        item: t,
        index: a
      }, null, 8, ["question", "item", "index"]))), 128))
    ], 2));
  }
}), Go = ["title"], Jo = ["name", "id", "aria-required", "aria-label", "aria-invalid", "aria-errormessage", "disabled", "value"], Xo = ["title"], Yo = /* @__PURE__ */ y({
  __name: "ButtonGroupItem",
  props: {
    item: {},
    question: {},
    index: {}
  },
  setup(u) {
    const e = u, n = b(
      () => new Ge(e.question, e.item, e.index)
    ), s = b({
      get: () => e.question.renderedValue,
      set: (i) => {
        const t = e.question;
        t.renderedValue = i;
      }
    });
    return (i, t) => (o(), l("label", {
      class: r(n.value.css.label),
      title: n.value.caption.renderedHtml
    }, [
      R(v("input", {
        type: "radio",
        name: n.value.name,
        id: n.value.id,
        "aria-required": n.value.isRequired,
        "aria-label": n.value.caption.renderedHtml,
        "aria-invalid": n.value.hasErrors,
        "aria-errormessage": n.value.describedBy,
        disabled: n.value.readOnly,
        class: r(n.value.css.control),
        "onUpdate:modelValue": t[0] || (t[0] = (a) => s.value = a),
        value: n.value.value
      }, null, 10, Jo), [
        [_, s.value]
      ]),
      v("div", {
        class: r(n.value.css.decorator)
      }, [
        n.value.iconName ? (o(), c(d, {
          key: 0,
          is: "sv-svg-icon",
          iconName: n.value.iconName,
          size: n.value.iconSize,
          class: r(n.value.css.icon)
        }, null, 8, ["iconName", "size", "class"])) : m("", !0),
        n.value.showCaption ? (o(), l("span", {
          key: 1,
          class: r(n.value.css.caption),
          title: n.value.caption.renderedHtml
        }, [
          h(d, {
            is: "survey-string",
            locString: n.value.caption
          }, null, 8, ["locString"])
        ], 10, Xo)) : m("", !0)
      ], 2)
    ], 10, Go));
  }
}), _o = ["src", "width", "height", "alt"], xo = /* @__PURE__ */ y({
  inheritAttrs: !1,
  __name: "Logo",
  props: {
    data: {}
  },
  setup(u) {
    const e = u, n = b(() => e.data), s = O(() => n.value.locLogo);
    return (i, t) => (o(), l("div", {
      class: r(n.value.logoClassNames)
    }, [
      v("img", {
        class: r(n.value.css.logoImage),
        src: L(s),
        width: n.value.renderedLogoWidth,
        height: n.value.renderedLogoHeight,
        alt: n.value.locTitle.renderedHtml,
        style: M({
          objectFit: n.value.logoFit,
          width: n.value.renderedStyleLogoWidth,
          height: n.value.renderedStyleLogoHeight
        })
      }, null, 14, _o)
    ], 2));
  }
}), ei = /* @__PURE__ */ y({
  __name: "SvgBundle",
  setup(u) {
    const e = f(), n = () => {
      e.value && (e.value.innerHTML = X.iconsRenderedHtml());
    };
    return $(() => {
      n(), X.onIconsChanged.add(n);
    }), P(() => {
      X.onIconsChanged.remove(n);
    }), (s, i) => R((o(), l("svg", {
      id: "sv-icon-holder-global-container",
      ref_key: "root",
      ref: e
    }, null, 512)), [
      [N, !1]
    ]);
  }
}), si = ["id"], ni = /* @__PURE__ */ y({
  __name: "FilePage",
  props: {
    page: {},
    question: {}
  },
  setup(u) {
    const e = u;
    return V(() => e.page), (n, s) => (o(), l("div", {
      class: r(n.page.css),
      id: n.page.id
    }, [
      (o(!0), l(I, null, S(n.page.items, (i) => (o(), c(d, {
        is: "sv-file-item",
        key: i,
        item: i,
        question: n.question
      }, null, 8, ["item", "question"]))), 128))
    ], 10, si));
  }
}), ti = ["href", "title", "download"], oi = ["src"], ii = ["href", "title", "download"], ri = /* @__PURE__ */ y({
  __name: "FileItem",
  props: {
    item: {},
    question: {}
  },
  setup(u) {
    return (e, n) => R((o(), l("span", {
      class: r(e.question.cssClasses.previewItem),
      onClick: n[3] || (n[3] = (s) => e.question.doDownloadFileFromContainer(s))
    }, [
      e.item.name && e.question.cssClasses.fileSign ? (o(), l("div", {
        key: 0,
        class: r(e.question.cssClasses.fileSign)
      }, [
        v("a", {
          onClick: n[0] || (n[0] = (s) => e.question.doDownloadFile(s, e.item)),
          href: e.item.content,
          title: e.item.name,
          download: e.item.name,
          style: M({ width: e.question.imageWidth })
        }, H(e.item.name), 13, ti)
      ], 2)) : m("", !0),
      v("div", {
        class: r(e.question.getImageWrapperCss(e.item))
      }, [
        e.question.canPreviewImage(e.item) ? (o(), l("img", {
          key: 0,
          src: e.item.content,
          style: M({
            height: e.question.imageHeight,
            width: e.question.imageWidth
          }),
          alt: "File preview"
        }, null, 12, oi)) : m("", !0),
        e.question.defaultImage(e.item) ? (o(), c(d, {
          key: 1,
          is: "sv-svg-icon",
          iconName: e.question.cssClasses.defaultImageIconId,
          class: r(e.question.cssClasses.defaultImage),
          size: "auto"
        }, null, 8, ["iconName", "class"])) : m("", !0),
        e.item.name && !e.question.isReadOnly ? (o(), l("div", {
          key: 2,
          class: r(e.question.getRemoveButtonCss()),
          onClick: n[1] || (n[1] = (s) => e.question.doRemoveFile(e.item, s))
        }, [
          v("span", {
            class: r(e.question.cssClasses.removeFile)
          }, H(e.question.removeFileCaption), 3),
          e.question.cssClasses.removeFileSvgIconId ? (o(), c(d, {
            key: 0,
            is: "sv-svg-icon",
            title: e.question.removeFileCaption,
            class: r(e.question.cssClasses.removeFileSvg),
            iconName: e.question.cssClasses.removeFileSvgIconId,
            size: "auto"
          }, null, 8, ["title", "class", "iconName"])) : m("", !0)
        ], 2)) : m("", !0)
      ], 2),
      e.item.name && e.question.cssClasses.fileSignBottom ? (o(), l("div", {
        key: 1,
        class: r(e.question.cssClasses.fileSignBottom)
      }, [
        v("a", {
          onClick: n[2] || (n[2] = (s) => e.question.doDownloadFile(s, e.item)),
          href: e.item.content,
          title: e.item.name,
          download: e.item.name,
          style: M({ width: e.question.imageWidth })
        }, H(e.item.name), 13, ii)
      ], 2)) : m("", !0)
    ], 2)), [
      [N, e.item]
    ]);
  }
});
Je.platform = "vue3";
function li(u, e, n) {
  u(e, n);
}
function be(u) {
  const e = li.bind(
    void 0,
    u
  );
  e("sv-svg-bundle", ei), e("popup-survey", fe), e("survey-header", e1), e("sv-logo-image", xo), e("survey-page", xe), e("survey-row", s1), e("survey-question", i1), e("survey-panel", u1), e("survey-element-header", m1), e("survey-string", p1), e("sv-string-viewer", v1), e("sv-string-editor", g1), e("sv-skeleton", y1), e("survey-text", L1), e("survey-text-input", b1), e("survey-checkbox", V1), e("survey-checkbox-item", T1), e("survey-radiogroup", Z1), e("survey-radiogroup-item", A1), e("survey-signaturepad", W1), e("survey-html", z1), e("survey-image", j1), e("survey-expression", Q1), e("survey-file", Y1), e("sv-file-choose-btn", Ko), e("sv-file-clean-btn", Fo), e("sv-file-preview", jo), e("sv-file-page", ni), e("sv-file-item", ri), e("sv-file-video", Oo), e("survey-imagepicker", x1), e("survey-imagepicker-item", os), e("survey-comment", is), e("survey-dropdown", rs), e("sv-dropdown-select", ds), e("sv-dropdown-option-item", ps), e("sv-dropdown", hs), e("survey-tagbox", ys), e("sv-tagbox", Ls), e("sv-tagbox-item", Hs), e("sv-tagbox-filter", bs), e("survey-ranking", Is), e("survey-ranking-item", Zs), e("sv-ranking-item", $s), e("survey-rating", Ns), e("sv-rating-item", Ws), e("sv-rating-item-smiley", zs), e("sv-rating-item-star", Us), e("sv-rating-dropdown", Js), e("sv-rating-dropdown-item", Gs), e("survey-boolean", Ys), e("sv-boolean-radio", _s), e("sv-boolean-radio-item", sn), e("sv-boolean-checkbox", an), e("survey-multipletext", un), e("survey-multipletext-item", mn), e("survey-matrix", hn), e("survey-matrix-row", qn), e("survey-matrix-cell", kn), e("survey-matrixdropdown", fn), e("survey-matrixtable", Hn), e("survey-matrixheaderrequired", Sn), e("survey-matrixdropdown-cell", Bn), e("survey-matrixdynamic", Rn), e("sv-matrix-remove-button", Zn), e("sv-matrix-drag-drop-icon", Dn), e("sv-matrix-detail-button", Nn), e("survey-paneldynamic", Pn), e("survey-paneldynamicprogress", En), e("survey-paneldynamicprogress-v2", Wn), e("sv-paneldynamic-add-btn", zn), e("sv-paneldynamic-next-btn", Un), e("sv-paneldynamic-prev-btn", jn), e("sv-paneldynamic-remove-btn", Gn), e("sv-paneldynamic-progress-text", Jn), e("sv-components-container", Qt), e("sv-progress-buttons", xt), e("sv-navigation-toc", eo), e("sv-progress-pages", J), e("sv-progress-questions", J), e("sv-progress-correctquestions", J), e("sv-progress-requiredquestions", J), e("survey-errors", Yn), e("survey-question-comment", xn), e("survey-element-title", et), e("survey-element-title-content", ot), e("sv-title-actions", lt), e("sv-brand-info", vt), e("sv-question-error", yt), e("sv-svg-icon", ht), e("sv-action-bar", qt), e("sv-action", kt), e("sv-action-bar-item", Mt), e("sv-action-bar-item-dropdown", St), e("sv-action-bar-separator", Vt), e("sv-list", Zt), e("sv-list-item-content", Nt), e("sv-list-item-group", Pt), e("sv-list-item", At), e("sv-popup", Et), e("sv-popup-container", Kt), e("popup-pointer", jt), e("sv-notifier", po), e("survey-other-choice", vo), e("sv-nav-btn", go), e("survey-customwidget", yo), e("survey-popup-modal", qo), e("survey-composite", fo), e("survey-custom", bo), e("sv-timerpanel", Io), e("sv-loading-indicator", Vo), e("sv-header", Ro), e("sv-header-cell", $o), e("sv-header-mobile", Po), e("sv-template-renderer", Wo), e("sv-character-counter", ko), e("sv-text-area", Lo), e("survey-element", Eo), e("survey-buttongroup", Qo), e("sv-button-group-item", Yo), e("survey", re);
}
be(
  (u, e) => K.Instance.registerComponent(u, e)
);
const mi = {
  install(u) {
    u.component("SurveyComponent", re), u.component("PopupSurveyComponent", fe), u.directive("key2click", U), be((e, n) => {
      u.component(e, n), K.Instance.registerComponent(e, e);
    });
  }
};
export {
  K as ComponentFactory,
  fe as PopupSurveyComponent,
  re as SurveyComponent,
  d as SvComponent,
  U as key2ClickDirective,
  mi as surveyPlugin,
  V as useBase,
  ee as useComputedArray,
  O as useLocString,
  T as useQuestion
};
